/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: any; output: any; }
  date: { input: any; output: any; }
  numeric: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type CountOutput = {
  __typename?: 'CountOutput';
  count: Scalars['Int']['output'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriberOutput = {
  __typename?: 'SubscriberOutput';
  error?: Maybe<Scalars['String']['output']>;
  expiration_date?: Maybe<Scalars['timestamptz']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  subscriber_id?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "agegroup" */
export type Agegroup = {
  __typename?: 'agegroup';
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  event?: Maybe<Events>;
  event_oid: Scalars['Int']['output'];
  from_age: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  oid: Scalars['Int']['output'];
  /** An array relationship */
  ranks: Array<Rank>;
  to_age: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "agegroup" */
export type AgegroupRanksArgs = {
  distinct_on?: InputMaybe<Array<Rank_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rank_Order_By>>;
  where?: InputMaybe<Rank_Bool_Exp>;
};

/** order by aggregate values of table "agegroup" */
export type Agegroup_Aggregate_Order_By = {
  avg?: InputMaybe<Agegroup_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agegroup_Max_Order_By>;
  min?: InputMaybe<Agegroup_Min_Order_By>;
  stddev?: InputMaybe<Agegroup_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Agegroup_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Agegroup_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Agegroup_Sum_Order_By>;
  var_pop?: InputMaybe<Agegroup_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Agegroup_Var_Samp_Order_By>;
  variance?: InputMaybe<Agegroup_Variance_Order_By>;
};

/** order by avg() on columns of table "agegroup" */
export type Agegroup_Avg_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  from_age?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  to_age?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "agegroup". All fields are combined with a logical 'AND'. */
export type Agegroup_Bool_Exp = {
  _and?: InputMaybe<Array<Agegroup_Bool_Exp>>;
  _not?: InputMaybe<Agegroup_Bool_Exp>;
  _or?: InputMaybe<Array<Agegroup_Bool_Exp>>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Events_Bool_Exp>;
  event_oid?: InputMaybe<Int_Comparison_Exp>;
  from_age?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<Int_Comparison_Exp>;
  oid?: InputMaybe<Int_Comparison_Exp>;
  ranks?: InputMaybe<Rank_Bool_Exp>;
  to_age?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "agegroup" */
export type Agegroup_Max_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  from_age?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  to_age?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "agegroup" */
export type Agegroup_Min_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  from_age?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  to_age?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "agegroup". */
export type Agegroup_Order_By = {
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event?: InputMaybe<Events_Order_By>;
  event_oid?: InputMaybe<Order_By>;
  from_age?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  ranks_aggregate?: InputMaybe<Rank_Aggregate_Order_By>;
  to_age?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "agegroup" */
export enum Agegroup_Select_Column {
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventOid = 'event_oid',
  /** column name */
  FromAge = 'from_age',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  Oid = 'oid',
  /** column name */
  ToAge = 'to_age',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "agegroup" */
export type Agegroup_Stddev_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  from_age?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  to_age?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "agegroup" */
export type Agegroup_Stddev_Pop_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  from_age?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  to_age?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "agegroup" */
export type Agegroup_Stddev_Samp_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  from_age?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  to_age?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "agegroup" */
export type Agegroup_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agegroup_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agegroup_Stream_Cursor_Value_Input = {
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_oid?: InputMaybe<Scalars['Int']['input']>;
  from_age?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  oid?: InputMaybe<Scalars['Int']['input']>;
  to_age?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "agegroup" */
export type Agegroup_Sum_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  from_age?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  to_age?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "agegroup" */
export type Agegroup_Var_Pop_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  from_age?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  to_age?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "agegroup" */
export type Agegroup_Var_Samp_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  from_age?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  to_age?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "agegroup" */
export type Agegroup_Variance_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  from_age?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  to_age?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "clubs" */
export type Clubs = {
  __typename?: 'clubs';
  city: Scalars['String']['output'];
  code: Scalars['String']['output'];
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  /** An array relationship */
  competitors: Array<Competitor>;
  /** An aggregate relationship */
  competitors_aggregate: Competitor_Aggregate;
  country_code: Scalars['String']['output'];
  country_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  oid: Scalars['Int']['output'];
  region_name: Scalars['String']['output'];
  short_name: Scalars['String']['output'];
};


/** columns and relationships of "clubs" */
export type ClubsCompetitorsArgs = {
  distinct_on?: InputMaybe<Array<Competitor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Competitor_Order_By>>;
  where?: InputMaybe<Competitor_Bool_Exp>;
};


/** columns and relationships of "clubs" */
export type ClubsCompetitors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Competitor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Competitor_Order_By>>;
  where?: InputMaybe<Competitor_Bool_Exp>;
};

/** order by aggregate values of table "clubs" */
export type Clubs_Aggregate_Order_By = {
  avg?: InputMaybe<Clubs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Clubs_Max_Order_By>;
  min?: InputMaybe<Clubs_Min_Order_By>;
  stddev?: InputMaybe<Clubs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Clubs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Clubs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Clubs_Sum_Order_By>;
  var_pop?: InputMaybe<Clubs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Clubs_Var_Samp_Order_By>;
  variance?: InputMaybe<Clubs_Variance_Order_By>;
};

/** order by avg() on columns of table "clubs" */
export type Clubs_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "clubs". All fields are combined with a logical 'AND'. */
export type Clubs_Bool_Exp = {
  _and?: InputMaybe<Array<Clubs_Bool_Exp>>;
  _not?: InputMaybe<Clubs_Bool_Exp>;
  _or?: InputMaybe<Array<Clubs_Bool_Exp>>;
  city?: InputMaybe<String_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  competitors?: InputMaybe<Competitor_Bool_Exp>;
  competitors_aggregate?: InputMaybe<Competitor_Aggregate_Bool_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  country_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  oid?: InputMaybe<Int_Comparison_Exp>;
  region_name?: InputMaybe<String_Comparison_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "clubs" */
export type Clubs_Max_Order_By = {
  city?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  competition_id?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  region_name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "clubs" */
export type Clubs_Min_Order_By = {
  city?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  competition_id?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  region_name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "clubs". */
export type Clubs_Order_By = {
  city?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  competitors_aggregate?: InputMaybe<Competitor_Aggregate_Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  region_name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
};

/** select columns of table "clubs" */
export enum Clubs_Select_Column {
  /** column name */
  City = 'city',
  /** column name */
  Code = 'code',
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryName = 'country_name',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Oid = 'oid',
  /** column name */
  RegionName = 'region_name',
  /** column name */
  ShortName = 'short_name'
}

/** order by stddev() on columns of table "clubs" */
export type Clubs_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "clubs" */
export type Clubs_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "clubs" */
export type Clubs_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "clubs" */
export type Clubs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Clubs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Clubs_Stream_Cursor_Value_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  country_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oid?: InputMaybe<Scalars['Int']['input']>;
  region_name?: InputMaybe<Scalars['String']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "clubs" */
export type Clubs_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "clubs" */
export type Clubs_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "clubs" */
export type Clubs_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "clubs" */
export type Clubs_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** columns and relationships of "combined_competitions" */
export type Combined_Competitions = {
  __typename?: 'combined_competitions';
  /** An object relationship */
  competition?: Maybe<Competitions>;
  competition_id: Scalars['uuid']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  group_number: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by aggregate values of table "combined_competitions" */
export type Combined_Competitions_Aggregate_Order_By = {
  avg?: InputMaybe<Combined_Competitions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Combined_Competitions_Max_Order_By>;
  min?: InputMaybe<Combined_Competitions_Min_Order_By>;
  stddev?: InputMaybe<Combined_Competitions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Combined_Competitions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Combined_Competitions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Combined_Competitions_Sum_Order_By>;
  var_pop?: InputMaybe<Combined_Competitions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Combined_Competitions_Var_Samp_Order_By>;
  variance?: InputMaybe<Combined_Competitions_Variance_Order_By>;
};

/** order by avg() on columns of table "combined_competitions" */
export type Combined_Competitions_Avg_Order_By = {
  group_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "combined_competitions". All fields are combined with a logical 'AND'. */
export type Combined_Competitions_Bool_Exp = {
  _and?: InputMaybe<Array<Combined_Competitions_Bool_Exp>>;
  _not?: InputMaybe<Combined_Competitions_Bool_Exp>;
  _or?: InputMaybe<Array<Combined_Competitions_Bool_Exp>>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  group_number?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "combined_competitions" */
export type Combined_Competitions_Max_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  group_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "combined_competitions" */
export type Combined_Competitions_Min_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  group_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "combined_competitions". */
export type Combined_Competitions_Order_By = {
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  group_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "combined_competitions" */
export enum Combined_Competitions_Select_Column {
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroupNumber = 'group_number',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "combined_competitions" */
export type Combined_Competitions_Stddev_Order_By = {
  group_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "combined_competitions" */
export type Combined_Competitions_Stddev_Pop_Order_By = {
  group_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "combined_competitions" */
export type Combined_Competitions_Stddev_Samp_Order_By = {
  group_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "combined_competitions" */
export type Combined_Competitions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Combined_Competitions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Combined_Competitions_Stream_Cursor_Value_Input = {
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_number?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "combined_competitions" */
export type Combined_Competitions_Sum_Order_By = {
  group_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "combined_competitions" */
export type Combined_Competitions_Var_Pop_Order_By = {
  group_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "combined_competitions" */
export type Combined_Competitions_Var_Samp_Order_By = {
  group_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "combined_competitions" */
export type Combined_Competitions_Variance_Order_By = {
  group_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "competition_session" */
export type Competition_Session = {
  __typename?: 'competition_session';
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  day: Scalars['Int']['output'];
  /** An array relationship */
  file_archives: Array<File_Archive>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  oid: Scalars['Int']['output'];
  start_time: Scalars['timestamptz']['output'];
  superlive_seo_link?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  time_program_entries: Array<Time_Program_Entry>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "competition_session" */
export type Competition_SessionFile_ArchivesArgs = {
  distinct_on?: InputMaybe<Array<File_Archive_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Archive_Order_By>>;
  where?: InputMaybe<File_Archive_Bool_Exp>;
};


/** columns and relationships of "competition_session" */
export type Competition_SessionTime_Program_EntriesArgs = {
  distinct_on?: InputMaybe<Array<Time_Program_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Time_Program_Entry_Order_By>>;
  where?: InputMaybe<Time_Program_Entry_Bool_Exp>;
};

/** order by aggregate values of table "competition_session" */
export type Competition_Session_Aggregate_Order_By = {
  avg?: InputMaybe<Competition_Session_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Competition_Session_Max_Order_By>;
  min?: InputMaybe<Competition_Session_Min_Order_By>;
  stddev?: InputMaybe<Competition_Session_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Competition_Session_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Competition_Session_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Competition_Session_Sum_Order_By>;
  var_pop?: InputMaybe<Competition_Session_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Competition_Session_Var_Samp_Order_By>;
  variance?: InputMaybe<Competition_Session_Variance_Order_By>;
};

/** order by avg() on columns of table "competition_session" */
export type Competition_Session_Avg_Order_By = {
  day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "competition_session". All fields are combined with a logical 'AND'. */
export type Competition_Session_Bool_Exp = {
  _and?: InputMaybe<Array<Competition_Session_Bool_Exp>>;
  _not?: InputMaybe<Competition_Session_Bool_Exp>;
  _or?: InputMaybe<Array<Competition_Session_Bool_Exp>>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  day?: InputMaybe<Int_Comparison_Exp>;
  file_archives?: InputMaybe<File_Archive_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<Int_Comparison_Exp>;
  oid?: InputMaybe<Int_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  superlive_seo_link?: InputMaybe<String_Comparison_Exp>;
  time_program_entries?: InputMaybe<Time_Program_Entry_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "competition_session" */
export type Competition_Session_Max_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  superlive_seo_link?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "competition_session" */
export type Competition_Session_Min_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  superlive_seo_link?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "competition_session". */
export type Competition_Session_Order_By = {
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  file_archives_aggregate?: InputMaybe<File_Archive_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  superlive_seo_link?: InputMaybe<Order_By>;
  time_program_entries_aggregate?: InputMaybe<Time_Program_Entry_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "competition_session" */
export enum Competition_Session_Select_Column {
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Day = 'day',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  Oid = 'oid',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  SuperliveSeoLink = 'superlive_seo_link',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "competition_session" */
export type Competition_Session_Stddev_Order_By = {
  day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "competition_session" */
export type Competition_Session_Stddev_Pop_Order_By = {
  day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "competition_session" */
export type Competition_Session_Stddev_Samp_Order_By = {
  day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "competition_session" */
export type Competition_Session_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Competition_Session_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Competition_Session_Stream_Cursor_Value_Input = {
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  day?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  oid?: InputMaybe<Scalars['Int']['input']>;
  start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  superlive_seo_link?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "competition_session" */
export type Competition_Session_Sum_Order_By = {
  day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "competition_session" */
export type Competition_Session_Var_Pop_Order_By = {
  day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "competition_session" */
export type Competition_Session_Var_Samp_Order_By = {
  day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "competition_session" */
export type Competition_Session_Variance_Order_By = {
  day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** columns and relationships of "competitions" */
export type Competitions = {
  __typename?: 'competitions';
  /** An array relationship */
  agegroups: Array<Agegroup>;
  beta: Scalars['Boolean']['output'];
  city?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  clubs: Array<Clubs>;
  /** An array relationship */
  combined_competitions: Array<Combined_Competitions>;
  combined_group?: Maybe<Scalars['Int']['output']>;
  combined_type: Scalars['Int']['output'];
  competition_level: Scalars['Int']['output'];
  /** An array relationship */
  competition_sessions: Array<Competition_Session>;
  /** An array relationship */
  competitors: Array<Competitor>;
  /** An aggregate relationship */
  competitors_aggregate: Competitor_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  current_heats: Array<Current_Heat>;
  endDate: Scalars['date']['output'];
  /** An array relationship */
  entries: Array<Entry>;
  /** An array relationship */
  entry_list_types: Array<Entry_List_Type>;
  /** An array relationship */
  entry_ranks: Array<Entry_Rank>;
  /** An array relationship */
  event_records: Array<Event_Records>;
  /** An array relationship */
  events: Array<Events>;
  /** An array relationship */
  file_archives: Array<File_Archive>;
  head_official?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  heat: Array<Heat>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  lanes: Array<Lane>;
  large_image?: Maybe<Scalars['String']['output']>;
  locked: Scalars['Boolean']['output'];
  manual_live_sort_order: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nation_code?: Maybe<Scalars['String']['output']>;
  organizer?: Maybe<Scalars['String']['output']>;
  organizer_logo?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  point_list_rows: Array<Point_List_Row>;
  /** An array relationship */
  point_lists: Array<Point_List>;
  pool_name?: Maybe<Scalars['String']['output']>;
  pool_type: Scalars['Int']['output'];
  qualify_from?: Maybe<Scalars['date']['output']>;
  qualify_until?: Maybe<Scalars['date']['output']>;
  /** An array relationship */
  ranks: Array<Rank>;
  /** An array relationship */
  relay_competitors: Array<Relay_Competitor>;
  /** An array relationship */
  rounds: Array<Round>;
  seo_text: Scalars['String']['output'];
  show_age: Scalars['Boolean']['output'];
  small_image?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  sponsors: Array<Sponsor>;
  /** An array relationship */
  starred_competitions: Array<Subscriptions_Starred_Competition>;
  startDate: Scalars['date']['output'];
  /** An array relationship */
  sub_results: Array<Sub_Results>;
  /** An array relationship */
  summary_types: Array<Summary_Type>;
  superlive: Scalars['Boolean']['output'];
  tempus_relay: Scalars['Boolean']['output'];
  test: Scalars['Boolean']['output'];
  /** An array relationship */
  time_program_entries: Array<Time_Program_Entry>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "competitions" */
export type CompetitionsAgegroupsArgs = {
  distinct_on?: InputMaybe<Array<Agegroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agegroup_Order_By>>;
  where?: InputMaybe<Agegroup_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsClubsArgs = {
  distinct_on?: InputMaybe<Array<Clubs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clubs_Order_By>>;
  where?: InputMaybe<Clubs_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsCombined_CompetitionsArgs = {
  distinct_on?: InputMaybe<Array<Combined_Competitions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Combined_Competitions_Order_By>>;
  where?: InputMaybe<Combined_Competitions_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsCompetition_SessionsArgs = {
  distinct_on?: InputMaybe<Array<Competition_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Competition_Session_Order_By>>;
  where?: InputMaybe<Competition_Session_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsCompetitorsArgs = {
  distinct_on?: InputMaybe<Array<Competitor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Competitor_Order_By>>;
  where?: InputMaybe<Competitor_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsCompetitors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Competitor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Competitor_Order_By>>;
  where?: InputMaybe<Competitor_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsCurrent_HeatsArgs = {
  distinct_on?: InputMaybe<Array<Current_Heat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Current_Heat_Order_By>>;
  where?: InputMaybe<Current_Heat_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsEntriesArgs = {
  distinct_on?: InputMaybe<Array<Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entry_Order_By>>;
  where?: InputMaybe<Entry_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsEntry_List_TypesArgs = {
  distinct_on?: InputMaybe<Array<Entry_List_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entry_List_Type_Order_By>>;
  where?: InputMaybe<Entry_List_Type_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsEntry_RanksArgs = {
  distinct_on?: InputMaybe<Array<Entry_Rank_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entry_Rank_Order_By>>;
  where?: InputMaybe<Entry_Rank_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsEvent_RecordsArgs = {
  distinct_on?: InputMaybe<Array<Event_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Records_Order_By>>;
  where?: InputMaybe<Event_Records_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsFile_ArchivesArgs = {
  distinct_on?: InputMaybe<Array<File_Archive_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Archive_Order_By>>;
  where?: InputMaybe<File_Archive_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsHeatArgs = {
  distinct_on?: InputMaybe<Array<Heat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Heat_Order_By>>;
  where?: InputMaybe<Heat_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsLanesArgs = {
  distinct_on?: InputMaybe<Array<Lane_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lane_Order_By>>;
  where?: InputMaybe<Lane_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsPoint_List_RowsArgs = {
  distinct_on?: InputMaybe<Array<Point_List_Row_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Point_List_Row_Order_By>>;
  where?: InputMaybe<Point_List_Row_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsPoint_ListsArgs = {
  distinct_on?: InputMaybe<Array<Point_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Point_List_Order_By>>;
  where?: InputMaybe<Point_List_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsRanksArgs = {
  distinct_on?: InputMaybe<Array<Rank_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rank_Order_By>>;
  where?: InputMaybe<Rank_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsRelay_CompetitorsArgs = {
  distinct_on?: InputMaybe<Array<Relay_Competitor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relay_Competitor_Order_By>>;
  where?: InputMaybe<Relay_Competitor_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsRoundsArgs = {
  distinct_on?: InputMaybe<Array<Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Round_Order_By>>;
  where?: InputMaybe<Round_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsSponsorsArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sponsor_Order_By>>;
  where?: InputMaybe<Sponsor_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsStarred_CompetitionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Starred_Competition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Starred_Competition_Order_By>>;
  where?: InputMaybe<Subscriptions_Starred_Competition_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsSub_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Sub_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sub_Results_Order_By>>;
  where?: InputMaybe<Sub_Results_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsSummary_TypesArgs = {
  distinct_on?: InputMaybe<Array<Summary_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Summary_Type_Order_By>>;
  where?: InputMaybe<Summary_Type_Bool_Exp>;
};


/** columns and relationships of "competitions" */
export type CompetitionsTime_Program_EntriesArgs = {
  distinct_on?: InputMaybe<Array<Time_Program_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Time_Program_Entry_Order_By>>;
  where?: InputMaybe<Time_Program_Entry_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "competitions". All fields are combined with a logical 'AND'. */
export type Competitions_Bool_Exp = {
  _and?: InputMaybe<Array<Competitions_Bool_Exp>>;
  _not?: InputMaybe<Competitions_Bool_Exp>;
  _or?: InputMaybe<Array<Competitions_Bool_Exp>>;
  agegroups?: InputMaybe<Agegroup_Bool_Exp>;
  beta?: InputMaybe<Boolean_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  clubs?: InputMaybe<Clubs_Bool_Exp>;
  combined_competitions?: InputMaybe<Combined_Competitions_Bool_Exp>;
  combined_group?: InputMaybe<Int_Comparison_Exp>;
  combined_type?: InputMaybe<Int_Comparison_Exp>;
  competition_level?: InputMaybe<Int_Comparison_Exp>;
  competition_sessions?: InputMaybe<Competition_Session_Bool_Exp>;
  competitors?: InputMaybe<Competitor_Bool_Exp>;
  competitors_aggregate?: InputMaybe<Competitor_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_heats?: InputMaybe<Current_Heat_Bool_Exp>;
  endDate?: InputMaybe<Date_Comparison_Exp>;
  entries?: InputMaybe<Entry_Bool_Exp>;
  entry_list_types?: InputMaybe<Entry_List_Type_Bool_Exp>;
  entry_ranks?: InputMaybe<Entry_Rank_Bool_Exp>;
  event_records?: InputMaybe<Event_Records_Bool_Exp>;
  events?: InputMaybe<Events_Bool_Exp>;
  file_archives?: InputMaybe<File_Archive_Bool_Exp>;
  head_official?: InputMaybe<String_Comparison_Exp>;
  heat?: InputMaybe<Heat_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lanes?: InputMaybe<Lane_Bool_Exp>;
  large_image?: InputMaybe<String_Comparison_Exp>;
  locked?: InputMaybe<Boolean_Comparison_Exp>;
  manual_live_sort_order?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  nation_code?: InputMaybe<String_Comparison_Exp>;
  organizer?: InputMaybe<String_Comparison_Exp>;
  organizer_logo?: InputMaybe<String_Comparison_Exp>;
  point_list_rows?: InputMaybe<Point_List_Row_Bool_Exp>;
  point_lists?: InputMaybe<Point_List_Bool_Exp>;
  pool_name?: InputMaybe<String_Comparison_Exp>;
  pool_type?: InputMaybe<Int_Comparison_Exp>;
  qualify_from?: InputMaybe<Date_Comparison_Exp>;
  qualify_until?: InputMaybe<Date_Comparison_Exp>;
  ranks?: InputMaybe<Rank_Bool_Exp>;
  relay_competitors?: InputMaybe<Relay_Competitor_Bool_Exp>;
  rounds?: InputMaybe<Round_Bool_Exp>;
  seo_text?: InputMaybe<String_Comparison_Exp>;
  show_age?: InputMaybe<Boolean_Comparison_Exp>;
  small_image?: InputMaybe<String_Comparison_Exp>;
  sponsors?: InputMaybe<Sponsor_Bool_Exp>;
  starred_competitions?: InputMaybe<Subscriptions_Starred_Competition_Bool_Exp>;
  startDate?: InputMaybe<Date_Comparison_Exp>;
  sub_results?: InputMaybe<Sub_Results_Bool_Exp>;
  summary_types?: InputMaybe<Summary_Type_Bool_Exp>;
  superlive?: InputMaybe<Boolean_Comparison_Exp>;
  tempus_relay?: InputMaybe<Boolean_Comparison_Exp>;
  test?: InputMaybe<Boolean_Comparison_Exp>;
  time_program_entries?: InputMaybe<Time_Program_Entry_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "competitions". */
export type Competitions_Order_By = {
  agegroups_aggregate?: InputMaybe<Agegroup_Aggregate_Order_By>;
  beta?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  clubs_aggregate?: InputMaybe<Clubs_Aggregate_Order_By>;
  combined_competitions_aggregate?: InputMaybe<Combined_Competitions_Aggregate_Order_By>;
  combined_group?: InputMaybe<Order_By>;
  combined_type?: InputMaybe<Order_By>;
  competition_level?: InputMaybe<Order_By>;
  competition_sessions_aggregate?: InputMaybe<Competition_Session_Aggregate_Order_By>;
  competitors_aggregate?: InputMaybe<Competitor_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_heats_aggregate?: InputMaybe<Current_Heat_Aggregate_Order_By>;
  endDate?: InputMaybe<Order_By>;
  entries_aggregate?: InputMaybe<Entry_Aggregate_Order_By>;
  entry_list_types_aggregate?: InputMaybe<Entry_List_Type_Aggregate_Order_By>;
  entry_ranks_aggregate?: InputMaybe<Entry_Rank_Aggregate_Order_By>;
  event_records_aggregate?: InputMaybe<Event_Records_Aggregate_Order_By>;
  events_aggregate?: InputMaybe<Events_Aggregate_Order_By>;
  file_archives_aggregate?: InputMaybe<File_Archive_Aggregate_Order_By>;
  head_official?: InputMaybe<Order_By>;
  heat_aggregate?: InputMaybe<Heat_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  lanes_aggregate?: InputMaybe<Lane_Aggregate_Order_By>;
  large_image?: InputMaybe<Order_By>;
  locked?: InputMaybe<Order_By>;
  manual_live_sort_order?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nation_code?: InputMaybe<Order_By>;
  organizer?: InputMaybe<Order_By>;
  organizer_logo?: InputMaybe<Order_By>;
  point_list_rows_aggregate?: InputMaybe<Point_List_Row_Aggregate_Order_By>;
  point_lists_aggregate?: InputMaybe<Point_List_Aggregate_Order_By>;
  pool_name?: InputMaybe<Order_By>;
  pool_type?: InputMaybe<Order_By>;
  qualify_from?: InputMaybe<Order_By>;
  qualify_until?: InputMaybe<Order_By>;
  ranks_aggregate?: InputMaybe<Rank_Aggregate_Order_By>;
  relay_competitors_aggregate?: InputMaybe<Relay_Competitor_Aggregate_Order_By>;
  rounds_aggregate?: InputMaybe<Round_Aggregate_Order_By>;
  seo_text?: InputMaybe<Order_By>;
  show_age?: InputMaybe<Order_By>;
  small_image?: InputMaybe<Order_By>;
  sponsors_aggregate?: InputMaybe<Sponsor_Aggregate_Order_By>;
  starred_competitions_aggregate?: InputMaybe<Subscriptions_Starred_Competition_Aggregate_Order_By>;
  startDate?: InputMaybe<Order_By>;
  sub_results_aggregate?: InputMaybe<Sub_Results_Aggregate_Order_By>;
  summary_types_aggregate?: InputMaybe<Summary_Type_Aggregate_Order_By>;
  superlive?: InputMaybe<Order_By>;
  tempus_relay?: InputMaybe<Order_By>;
  test?: InputMaybe<Order_By>;
  time_program_entries_aggregate?: InputMaybe<Time_Program_Entry_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "competitions" */
export enum Competitions_Select_Column {
  /** column name */
  Beta = 'beta',
  /** column name */
  City = 'city',
  /** column name */
  CombinedGroup = 'combined_group',
  /** column name */
  CombinedType = 'combined_type',
  /** column name */
  CompetitionLevel = 'competition_level',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  HeadOfficial = 'head_official',
  /** column name */
  Id = 'id',
  /** column name */
  LargeImage = 'large_image',
  /** column name */
  Locked = 'locked',
  /** column name */
  ManualLiveSortOrder = 'manual_live_sort_order',
  /** column name */
  Name = 'name',
  /** column name */
  NationCode = 'nation_code',
  /** column name */
  Organizer = 'organizer',
  /** column name */
  OrganizerLogo = 'organizer_logo',
  /** column name */
  PoolName = 'pool_name',
  /** column name */
  PoolType = 'pool_type',
  /** column name */
  QualifyFrom = 'qualify_from',
  /** column name */
  QualifyUntil = 'qualify_until',
  /** column name */
  SeoText = 'seo_text',
  /** column name */
  ShowAge = 'show_age',
  /** column name */
  SmallImage = 'small_image',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Superlive = 'superlive',
  /** column name */
  TempusRelay = 'tempus_relay',
  /** column name */
  Test = 'test',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "competitions" */
export type Competitions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Competitions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Competitions_Stream_Cursor_Value_Input = {
  beta?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  combined_group?: InputMaybe<Scalars['Int']['input']>;
  combined_type?: InputMaybe<Scalars['Int']['input']>;
  competition_level?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['date']['input']>;
  head_official?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  large_image?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  manual_live_sort_order?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nation_code?: InputMaybe<Scalars['String']['input']>;
  organizer?: InputMaybe<Scalars['String']['input']>;
  organizer_logo?: InputMaybe<Scalars['String']['input']>;
  pool_name?: InputMaybe<Scalars['String']['input']>;
  pool_type?: InputMaybe<Scalars['Int']['input']>;
  qualify_from?: InputMaybe<Scalars['date']['input']>;
  qualify_until?: InputMaybe<Scalars['date']['input']>;
  seo_text?: InputMaybe<Scalars['String']['input']>;
  show_age?: InputMaybe<Scalars['Boolean']['input']>;
  small_image?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['date']['input']>;
  superlive?: InputMaybe<Scalars['Boolean']['input']>;
  tempus_relay?: InputMaybe<Scalars['Boolean']['input']>;
  test?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "competitor" */
export type Competitor = {
  __typename?: 'competitor';
  age: Scalars['Int']['output'];
  birthday: Scalars['date']['output'];
  /** An object relationship */
  club?: Maybe<Clubs>;
  club_oid: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  country_code: Scalars['String']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  entries: Array<Entry>;
  first_name: Scalars['String']['output'];
  full_name?: Maybe<Scalars['String']['output']>;
  full_name_reversed?: Maybe<Scalars['String']['output']>;
  gender_number: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  is_para: Scalars['Boolean']['output'];
  is_relay: Scalars['Boolean']['output'];
  /** An array relationship */
  lanes: Array<Lane>;
  last_name: Scalars['String']['output'];
  not_in_competition: Scalars['Boolean']['output'];
  oid: Scalars['Int']['output'];
  para_class_breast?: Maybe<Scalars['String']['output']>;
  para_class_free?: Maybe<Scalars['String']['output']>;
  para_class_medley?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  relay_competitors: Array<Relay_Competitor>;
  /** An array relationship */
  starred_competition_swimmers: Array<Subscriptions_Starred_Competition_Swimmers>;
  /** An array relationship */
  starred_global_swimmers: Array<Subscriptions_Starred_Global_Swimmers>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "competitor" */
export type CompetitorEntriesArgs = {
  distinct_on?: InputMaybe<Array<Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entry_Order_By>>;
  where?: InputMaybe<Entry_Bool_Exp>;
};


/** columns and relationships of "competitor" */
export type CompetitorLanesArgs = {
  distinct_on?: InputMaybe<Array<Lane_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lane_Order_By>>;
  where?: InputMaybe<Lane_Bool_Exp>;
};


/** columns and relationships of "competitor" */
export type CompetitorRelay_CompetitorsArgs = {
  distinct_on?: InputMaybe<Array<Relay_Competitor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relay_Competitor_Order_By>>;
  where?: InputMaybe<Relay_Competitor_Bool_Exp>;
};


/** columns and relationships of "competitor" */
export type CompetitorStarred_Competition_SwimmersArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Starred_Competition_Swimmers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Starred_Competition_Swimmers_Order_By>>;
  where?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Bool_Exp>;
};


/** columns and relationships of "competitor" */
export type CompetitorStarred_Global_SwimmersArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Starred_Global_Swimmers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Starred_Global_Swimmers_Order_By>>;
  where?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Bool_Exp>;
};

/** aggregated selection of "competitor" */
export type Competitor_Aggregate = {
  __typename?: 'competitor_aggregate';
  aggregate?: Maybe<Competitor_Aggregate_Fields>;
  nodes: Array<Competitor>;
};

export type Competitor_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Competitor_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Competitor_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Competitor_Aggregate_Bool_Exp_Count>;
};

export type Competitor_Aggregate_Bool_Exp_Bool_And = {
  arguments: Competitor_Select_Column_Competitor_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Competitor_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Competitor_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Competitor_Select_Column_Competitor_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Competitor_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Competitor_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Competitor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Competitor_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "competitor" */
export type Competitor_Aggregate_Fields = {
  __typename?: 'competitor_aggregate_fields';
  avg?: Maybe<Competitor_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Competitor_Max_Fields>;
  min?: Maybe<Competitor_Min_Fields>;
  stddev?: Maybe<Competitor_Stddev_Fields>;
  stddev_pop?: Maybe<Competitor_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Competitor_Stddev_Samp_Fields>;
  sum?: Maybe<Competitor_Sum_Fields>;
  var_pop?: Maybe<Competitor_Var_Pop_Fields>;
  var_samp?: Maybe<Competitor_Var_Samp_Fields>;
  variance?: Maybe<Competitor_Variance_Fields>;
};


/** aggregate fields of "competitor" */
export type Competitor_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Competitor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "competitor" */
export type Competitor_Aggregate_Order_By = {
  avg?: InputMaybe<Competitor_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Competitor_Max_Order_By>;
  min?: InputMaybe<Competitor_Min_Order_By>;
  stddev?: InputMaybe<Competitor_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Competitor_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Competitor_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Competitor_Sum_Order_By>;
  var_pop?: InputMaybe<Competitor_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Competitor_Var_Samp_Order_By>;
  variance?: InputMaybe<Competitor_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Competitor_Avg_Fields = {
  __typename?: 'competitor_avg_fields';
  age?: Maybe<Scalars['Float']['output']>;
  club_oid?: Maybe<Scalars['Float']['output']>;
  gender_number?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oid?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "competitor" */
export type Competitor_Avg_Order_By = {
  age?: InputMaybe<Order_By>;
  club_oid?: InputMaybe<Order_By>;
  gender_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "competitor". All fields are combined with a logical 'AND'. */
export type Competitor_Bool_Exp = {
  _and?: InputMaybe<Array<Competitor_Bool_Exp>>;
  _not?: InputMaybe<Competitor_Bool_Exp>;
  _or?: InputMaybe<Array<Competitor_Bool_Exp>>;
  age?: InputMaybe<Int_Comparison_Exp>;
  birthday?: InputMaybe<Date_Comparison_Exp>;
  club?: InputMaybe<Clubs_Bool_Exp>;
  club_oid?: InputMaybe<Int_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entries?: InputMaybe<Entry_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  full_name_reversed?: InputMaybe<String_Comparison_Exp>;
  gender_number?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_para?: InputMaybe<Boolean_Comparison_Exp>;
  is_relay?: InputMaybe<Boolean_Comparison_Exp>;
  lanes?: InputMaybe<Lane_Bool_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  not_in_competition?: InputMaybe<Boolean_Comparison_Exp>;
  oid?: InputMaybe<Int_Comparison_Exp>;
  para_class_breast?: InputMaybe<String_Comparison_Exp>;
  para_class_free?: InputMaybe<String_Comparison_Exp>;
  para_class_medley?: InputMaybe<String_Comparison_Exp>;
  relay_competitors?: InputMaybe<Relay_Competitor_Bool_Exp>;
  starred_competition_swimmers?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Bool_Exp>;
  starred_global_swimmers?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Competitor_Max_Fields = {
  __typename?: 'competitor_max_fields';
  age?: Maybe<Scalars['Int']['output']>;
  birthday?: Maybe<Scalars['date']['output']>;
  club_oid?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  competition_id?: Maybe<Scalars['uuid']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  full_name_reversed?: Maybe<Scalars['String']['output']>;
  gender_number?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  oid?: Maybe<Scalars['Int']['output']>;
  para_class_breast?: Maybe<Scalars['String']['output']>;
  para_class_free?: Maybe<Scalars['String']['output']>;
  para_class_medley?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "competitor" */
export type Competitor_Max_Order_By = {
  age?: InputMaybe<Order_By>;
  birthday?: InputMaybe<Order_By>;
  club_oid?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  competition_id?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  para_class_breast?: InputMaybe<Order_By>;
  para_class_free?: InputMaybe<Order_By>;
  para_class_medley?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Competitor_Min_Fields = {
  __typename?: 'competitor_min_fields';
  age?: Maybe<Scalars['Int']['output']>;
  birthday?: Maybe<Scalars['date']['output']>;
  club_oid?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  competition_id?: Maybe<Scalars['uuid']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  full_name_reversed?: Maybe<Scalars['String']['output']>;
  gender_number?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  oid?: Maybe<Scalars['Int']['output']>;
  para_class_breast?: Maybe<Scalars['String']['output']>;
  para_class_free?: Maybe<Scalars['String']['output']>;
  para_class_medley?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "competitor" */
export type Competitor_Min_Order_By = {
  age?: InputMaybe<Order_By>;
  birthday?: InputMaybe<Order_By>;
  club_oid?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  competition_id?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  para_class_breast?: InputMaybe<Order_By>;
  para_class_free?: InputMaybe<Order_By>;
  para_class_medley?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "competitor". */
export type Competitor_Order_By = {
  age?: InputMaybe<Order_By>;
  birthday?: InputMaybe<Order_By>;
  club?: InputMaybe<Clubs_Order_By>;
  club_oid?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entries_aggregate?: InputMaybe<Entry_Aggregate_Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  full_name_reversed?: InputMaybe<Order_By>;
  gender_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_para?: InputMaybe<Order_By>;
  is_relay?: InputMaybe<Order_By>;
  lanes_aggregate?: InputMaybe<Lane_Aggregate_Order_By>;
  last_name?: InputMaybe<Order_By>;
  not_in_competition?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  para_class_breast?: InputMaybe<Order_By>;
  para_class_free?: InputMaybe<Order_By>;
  para_class_medley?: InputMaybe<Order_By>;
  relay_competitors_aggregate?: InputMaybe<Relay_Competitor_Aggregate_Order_By>;
  starred_competition_swimmers_aggregate?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Aggregate_Order_By>;
  starred_global_swimmers_aggregate?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "competitor" */
export enum Competitor_Select_Column {
  /** column name */
  Age = 'age',
  /** column name */
  Birthday = 'birthday',
  /** column name */
  ClubOid = 'club_oid',
  /** column name */
  Code = 'code',
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  GenderNumber = 'gender_number',
  /** column name */
  Id = 'id',
  /** column name */
  IsPara = 'is_para',
  /** column name */
  IsRelay = 'is_relay',
  /** column name */
  LastName = 'last_name',
  /** column name */
  NotInCompetition = 'not_in_competition',
  /** column name */
  Oid = 'oid',
  /** column name */
  ParaClassBreast = 'para_class_breast',
  /** column name */
  ParaClassFree = 'para_class_free',
  /** column name */
  ParaClassMedley = 'para_class_medley',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "competitor_aggregate_bool_exp_bool_and_arguments_columns" columns of table "competitor" */
export enum Competitor_Select_Column_Competitor_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsPara = 'is_para',
  /** column name */
  IsRelay = 'is_relay',
  /** column name */
  NotInCompetition = 'not_in_competition'
}

/** select "competitor_aggregate_bool_exp_bool_or_arguments_columns" columns of table "competitor" */
export enum Competitor_Select_Column_Competitor_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsPara = 'is_para',
  /** column name */
  IsRelay = 'is_relay',
  /** column name */
  NotInCompetition = 'not_in_competition'
}

/** aggregate stddev on columns */
export type Competitor_Stddev_Fields = {
  __typename?: 'competitor_stddev_fields';
  age?: Maybe<Scalars['Float']['output']>;
  club_oid?: Maybe<Scalars['Float']['output']>;
  gender_number?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oid?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "competitor" */
export type Competitor_Stddev_Order_By = {
  age?: InputMaybe<Order_By>;
  club_oid?: InputMaybe<Order_By>;
  gender_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Competitor_Stddev_Pop_Fields = {
  __typename?: 'competitor_stddev_pop_fields';
  age?: Maybe<Scalars['Float']['output']>;
  club_oid?: Maybe<Scalars['Float']['output']>;
  gender_number?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oid?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "competitor" */
export type Competitor_Stddev_Pop_Order_By = {
  age?: InputMaybe<Order_By>;
  club_oid?: InputMaybe<Order_By>;
  gender_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Competitor_Stddev_Samp_Fields = {
  __typename?: 'competitor_stddev_samp_fields';
  age?: Maybe<Scalars['Float']['output']>;
  club_oid?: Maybe<Scalars['Float']['output']>;
  gender_number?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oid?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "competitor" */
export type Competitor_Stddev_Samp_Order_By = {
  age?: InputMaybe<Order_By>;
  club_oid?: InputMaybe<Order_By>;
  gender_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "competitor" */
export type Competitor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Competitor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Competitor_Stream_Cursor_Value_Input = {
  age?: InputMaybe<Scalars['Int']['input']>;
  birthday?: InputMaybe<Scalars['date']['input']>;
  club_oid?: InputMaybe<Scalars['Int']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender_number?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_para?: InputMaybe<Scalars['Boolean']['input']>;
  is_relay?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  not_in_competition?: InputMaybe<Scalars['Boolean']['input']>;
  oid?: InputMaybe<Scalars['Int']['input']>;
  para_class_breast?: InputMaybe<Scalars['String']['input']>;
  para_class_free?: InputMaybe<Scalars['String']['input']>;
  para_class_medley?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Competitor_Sum_Fields = {
  __typename?: 'competitor_sum_fields';
  age?: Maybe<Scalars['Int']['output']>;
  club_oid?: Maybe<Scalars['Int']['output']>;
  gender_number?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  oid?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "competitor" */
export type Competitor_Sum_Order_By = {
  age?: InputMaybe<Order_By>;
  club_oid?: InputMaybe<Order_By>;
  gender_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Competitor_Var_Pop_Fields = {
  __typename?: 'competitor_var_pop_fields';
  age?: Maybe<Scalars['Float']['output']>;
  club_oid?: Maybe<Scalars['Float']['output']>;
  gender_number?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oid?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "competitor" */
export type Competitor_Var_Pop_Order_By = {
  age?: InputMaybe<Order_By>;
  club_oid?: InputMaybe<Order_By>;
  gender_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Competitor_Var_Samp_Fields = {
  __typename?: 'competitor_var_samp_fields';
  age?: Maybe<Scalars['Float']['output']>;
  club_oid?: Maybe<Scalars['Float']['output']>;
  gender_number?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oid?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "competitor" */
export type Competitor_Var_Samp_Order_By = {
  age?: InputMaybe<Order_By>;
  club_oid?: InputMaybe<Order_By>;
  gender_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Competitor_Variance_Fields = {
  __typename?: 'competitor_variance_fields';
  age?: Maybe<Scalars['Float']['output']>;
  club_oid?: Maybe<Scalars['Float']['output']>;
  gender_number?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  oid?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "competitor" */
export type Competitor_Variance_Order_By = {
  age?: InputMaybe<Order_By>;
  club_oid?: InputMaybe<Order_By>;
  gender_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** columns and relationships of "current_heat" */
export type Current_Heat = {
  __typename?: 'current_heat';
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  /** An object relationship */
  heat?: Maybe<Heat>;
  heat_oid: Scalars['Int']['output'];
  heat_type: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  pool_number: Scalars['Int']['output'];
  /** An object relationship */
  round?: Maybe<Round>;
  round_oid: Scalars['Int']['output'];
  /** An object relationship */
  time_program_entry?: Maybe<Time_Program_Entry>;
  time_program_entry_oid: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by aggregate values of table "current_heat" */
export type Current_Heat_Aggregate_Order_By = {
  avg?: InputMaybe<Current_Heat_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Current_Heat_Max_Order_By>;
  min?: InputMaybe<Current_Heat_Min_Order_By>;
  stddev?: InputMaybe<Current_Heat_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Current_Heat_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Current_Heat_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Current_Heat_Sum_Order_By>;
  var_pop?: InputMaybe<Current_Heat_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Current_Heat_Var_Samp_Order_By>;
  variance?: InputMaybe<Current_Heat_Variance_Order_By>;
};

/** order by avg() on columns of table "current_heat" */
export type Current_Heat_Avg_Order_By = {
  heat_oid?: InputMaybe<Order_By>;
  heat_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pool_number?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  time_program_entry_oid?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "current_heat". All fields are combined with a logical 'AND'. */
export type Current_Heat_Bool_Exp = {
  _and?: InputMaybe<Array<Current_Heat_Bool_Exp>>;
  _not?: InputMaybe<Current_Heat_Bool_Exp>;
  _or?: InputMaybe<Array<Current_Heat_Bool_Exp>>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  heat?: InputMaybe<Heat_Bool_Exp>;
  heat_oid?: InputMaybe<Int_Comparison_Exp>;
  heat_type?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  pool_number?: InputMaybe<Int_Comparison_Exp>;
  round?: InputMaybe<Round_Bool_Exp>;
  round_oid?: InputMaybe<Int_Comparison_Exp>;
  time_program_entry?: InputMaybe<Time_Program_Entry_Bool_Exp>;
  time_program_entry_oid?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "current_heat" */
export type Current_Heat_Max_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  heat_oid?: InputMaybe<Order_By>;
  heat_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pool_number?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  time_program_entry_oid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "current_heat" */
export type Current_Heat_Min_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  heat_oid?: InputMaybe<Order_By>;
  heat_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pool_number?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  time_program_entry_oid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "current_heat". */
export type Current_Heat_Order_By = {
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  heat?: InputMaybe<Heat_Order_By>;
  heat_oid?: InputMaybe<Order_By>;
  heat_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pool_number?: InputMaybe<Order_By>;
  round?: InputMaybe<Round_Order_By>;
  round_oid?: InputMaybe<Order_By>;
  time_program_entry?: InputMaybe<Time_Program_Entry_Order_By>;
  time_program_entry_oid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "current_heat" */
export enum Current_Heat_Select_Column {
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  HeatOid = 'heat_oid',
  /** column name */
  HeatType = 'heat_type',
  /** column name */
  Id = 'id',
  /** column name */
  PoolNumber = 'pool_number',
  /** column name */
  RoundOid = 'round_oid',
  /** column name */
  TimeProgramEntryOid = 'time_program_entry_oid',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "current_heat" */
export type Current_Heat_Stddev_Order_By = {
  heat_oid?: InputMaybe<Order_By>;
  heat_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pool_number?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  time_program_entry_oid?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "current_heat" */
export type Current_Heat_Stddev_Pop_Order_By = {
  heat_oid?: InputMaybe<Order_By>;
  heat_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pool_number?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  time_program_entry_oid?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "current_heat" */
export type Current_Heat_Stddev_Samp_Order_By = {
  heat_oid?: InputMaybe<Order_By>;
  heat_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pool_number?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  time_program_entry_oid?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "current_heat" */
export type Current_Heat_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Current_Heat_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Current_Heat_Stream_Cursor_Value_Input = {
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  heat_oid?: InputMaybe<Scalars['Int']['input']>;
  heat_type?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  pool_number?: InputMaybe<Scalars['Int']['input']>;
  round_oid?: InputMaybe<Scalars['Int']['input']>;
  time_program_entry_oid?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "current_heat" */
export type Current_Heat_Sum_Order_By = {
  heat_oid?: InputMaybe<Order_By>;
  heat_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pool_number?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  time_program_entry_oid?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "current_heat" */
export type Current_Heat_Var_Pop_Order_By = {
  heat_oid?: InputMaybe<Order_By>;
  heat_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pool_number?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  time_program_entry_oid?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "current_heat" */
export type Current_Heat_Var_Samp_Order_By = {
  heat_oid?: InputMaybe<Order_By>;
  heat_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pool_number?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  time_program_entry_oid?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "current_heat" */
export type Current_Heat_Variance_Order_By = {
  heat_oid?: InputMaybe<Order_By>;
  heat_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pool_number?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  time_program_entry_oid?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "entry" */
export type Entry = {
  __typename?: 'entry';
  auto_withdrawn: Scalars['Boolean']['output'];
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  /** An object relationship */
  competitor?: Maybe<Competitor>;
  competitor_oid: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  entry_pool: Scalars['Int']['output'];
  /** An array relationship */
  entry_ranks: Array<Entry_Rank>;
  entry_time: Scalars['Int']['output'];
  entry_time_text: Scalars['String']['output'];
  /** An object relationship */
  event?: Maybe<Events>;
  event_oid: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  late_entry: Scalars['Boolean']['output'];
  not_in_competition: Scalars['Boolean']['output'];
  oid: Scalars['Int']['output'];
  original_entry_pool: Scalars['Int']['output'];
  random_value: Scalars['Int']['output'];
  ranking: Scalars['Int']['output'];
  relay_age: Scalars['Int']['output'];
  /** An array relationship */
  relay_competitors: Array<Relay_Competitor>;
  reserve: Scalars['Boolean']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  withdrawn: Scalars['Boolean']['output'];
};


/** columns and relationships of "entry" */
export type EntryEntry_RanksArgs = {
  distinct_on?: InputMaybe<Array<Entry_Rank_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entry_Rank_Order_By>>;
  where?: InputMaybe<Entry_Rank_Bool_Exp>;
};


/** columns and relationships of "entry" */
export type EntryRelay_CompetitorsArgs = {
  distinct_on?: InputMaybe<Array<Relay_Competitor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relay_Competitor_Order_By>>;
  where?: InputMaybe<Relay_Competitor_Bool_Exp>;
};

/** order by aggregate values of table "entry" */
export type Entry_Aggregate_Order_By = {
  avg?: InputMaybe<Entry_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Entry_Max_Order_By>;
  min?: InputMaybe<Entry_Min_Order_By>;
  stddev?: InputMaybe<Entry_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Entry_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Entry_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Entry_Sum_Order_By>;
  var_pop?: InputMaybe<Entry_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Entry_Var_Samp_Order_By>;
  variance?: InputMaybe<Entry_Variance_Order_By>;
};

/** order by avg() on columns of table "entry" */
export type Entry_Avg_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  entry_pool?: InputMaybe<Order_By>;
  entry_time?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  original_entry_pool?: InputMaybe<Order_By>;
  random_value?: InputMaybe<Order_By>;
  ranking?: InputMaybe<Order_By>;
  relay_age?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "entry". All fields are combined with a logical 'AND'. */
export type Entry_Bool_Exp = {
  _and?: InputMaybe<Array<Entry_Bool_Exp>>;
  _not?: InputMaybe<Entry_Bool_Exp>;
  _or?: InputMaybe<Array<Entry_Bool_Exp>>;
  auto_withdrawn?: InputMaybe<Boolean_Comparison_Exp>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  competitor?: InputMaybe<Competitor_Bool_Exp>;
  competitor_oid?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entry_pool?: InputMaybe<Int_Comparison_Exp>;
  entry_ranks?: InputMaybe<Entry_Rank_Bool_Exp>;
  entry_time?: InputMaybe<Int_Comparison_Exp>;
  entry_time_text?: InputMaybe<String_Comparison_Exp>;
  event?: InputMaybe<Events_Bool_Exp>;
  event_oid?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  late_entry?: InputMaybe<Boolean_Comparison_Exp>;
  not_in_competition?: InputMaybe<Boolean_Comparison_Exp>;
  oid?: InputMaybe<Int_Comparison_Exp>;
  original_entry_pool?: InputMaybe<Int_Comparison_Exp>;
  random_value?: InputMaybe<Int_Comparison_Exp>;
  ranking?: InputMaybe<Int_Comparison_Exp>;
  relay_age?: InputMaybe<Int_Comparison_Exp>;
  relay_competitors?: InputMaybe<Relay_Competitor_Bool_Exp>;
  reserve?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  withdrawn?: InputMaybe<Boolean_Comparison_Exp>;
};

/** columns and relationships of "entry_list_type" */
export type Entry_List_Type = {
  __typename?: 'entry_list_type';
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  entries_count: Scalars['Int']['output'];
  /** An array relationship */
  entry_ranks: Array<Entry_Rank>;
  entry_type: Scalars['Int']['output'];
  /** An object relationship */
  event?: Maybe<Events>;
  event_oid: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  oid: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  sort_by_name: Scalars['Boolean']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "entry_list_type" */
export type Entry_List_TypeEntry_RanksArgs = {
  distinct_on?: InputMaybe<Array<Entry_Rank_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entry_Rank_Order_By>>;
  where?: InputMaybe<Entry_Rank_Bool_Exp>;
};

/** order by aggregate values of table "entry_list_type" */
export type Entry_List_Type_Aggregate_Order_By = {
  avg?: InputMaybe<Entry_List_Type_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Entry_List_Type_Max_Order_By>;
  min?: InputMaybe<Entry_List_Type_Min_Order_By>;
  stddev?: InputMaybe<Entry_List_Type_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Entry_List_Type_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Entry_List_Type_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Entry_List_Type_Sum_Order_By>;
  var_pop?: InputMaybe<Entry_List_Type_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Entry_List_Type_Var_Samp_Order_By>;
  variance?: InputMaybe<Entry_List_Type_Variance_Order_By>;
};

/** order by avg() on columns of table "entry_list_type" */
export type Entry_List_Type_Avg_Order_By = {
  entries_count?: InputMaybe<Order_By>;
  entry_type?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "entry_list_type". All fields are combined with a logical 'AND'. */
export type Entry_List_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Entry_List_Type_Bool_Exp>>;
  _not?: InputMaybe<Entry_List_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Entry_List_Type_Bool_Exp>>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entries_count?: InputMaybe<Int_Comparison_Exp>;
  entry_ranks?: InputMaybe<Entry_Rank_Bool_Exp>;
  entry_type?: InputMaybe<Int_Comparison_Exp>;
  event?: InputMaybe<Events_Bool_Exp>;
  event_oid?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  oid?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  sort_by_name?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "entry_list_type" */
export type Entry_List_Type_Max_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entries_count?: InputMaybe<Order_By>;
  entry_type?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "entry_list_type" */
export type Entry_List_Type_Min_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entries_count?: InputMaybe<Order_By>;
  entry_type?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "entry_list_type". */
export type Entry_List_Type_Order_By = {
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entries_count?: InputMaybe<Order_By>;
  entry_ranks_aggregate?: InputMaybe<Entry_Rank_Aggregate_Order_By>;
  entry_type?: InputMaybe<Order_By>;
  event?: InputMaybe<Events_Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  sort_by_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "entry_list_type" */
export enum Entry_List_Type_Select_Column {
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntriesCount = 'entries_count',
  /** column name */
  EntryType = 'entry_type',
  /** column name */
  EventOid = 'event_oid',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Oid = 'oid',
  /** column name */
  Order = 'order',
  /** column name */
  SortByName = 'sort_by_name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "entry_list_type" */
export type Entry_List_Type_Stddev_Order_By = {
  entries_count?: InputMaybe<Order_By>;
  entry_type?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "entry_list_type" */
export type Entry_List_Type_Stddev_Pop_Order_By = {
  entries_count?: InputMaybe<Order_By>;
  entry_type?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "entry_list_type" */
export type Entry_List_Type_Stddev_Samp_Order_By = {
  entries_count?: InputMaybe<Order_By>;
  entry_type?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "entry_list_type" */
export type Entry_List_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Entry_List_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Entry_List_Type_Stream_Cursor_Value_Input = {
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entries_count?: InputMaybe<Scalars['Int']['input']>;
  entry_type?: InputMaybe<Scalars['Int']['input']>;
  event_oid?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oid?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  sort_by_name?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "entry_list_type" */
export type Entry_List_Type_Sum_Order_By = {
  entries_count?: InputMaybe<Order_By>;
  entry_type?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "entry_list_type" */
export type Entry_List_Type_Var_Pop_Order_By = {
  entries_count?: InputMaybe<Order_By>;
  entry_type?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "entry_list_type" */
export type Entry_List_Type_Var_Samp_Order_By = {
  entries_count?: InputMaybe<Order_By>;
  entry_type?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "entry_list_type" */
export type Entry_List_Type_Variance_Order_By = {
  entries_count?: InputMaybe<Order_By>;
  entry_type?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "entry" */
export type Entry_Max_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entry_pool?: InputMaybe<Order_By>;
  entry_time?: InputMaybe<Order_By>;
  entry_time_text?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  original_entry_pool?: InputMaybe<Order_By>;
  random_value?: InputMaybe<Order_By>;
  ranking?: InputMaybe<Order_By>;
  relay_age?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "entry" */
export type Entry_Min_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entry_pool?: InputMaybe<Order_By>;
  entry_time?: InputMaybe<Order_By>;
  entry_time_text?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  original_entry_pool?: InputMaybe<Order_By>;
  random_value?: InputMaybe<Order_By>;
  ranking?: InputMaybe<Order_By>;
  relay_age?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "entry". */
export type Entry_Order_By = {
  auto_withdrawn?: InputMaybe<Order_By>;
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  competitor?: InputMaybe<Competitor_Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entry_pool?: InputMaybe<Order_By>;
  entry_ranks_aggregate?: InputMaybe<Entry_Rank_Aggregate_Order_By>;
  entry_time?: InputMaybe<Order_By>;
  entry_time_text?: InputMaybe<Order_By>;
  event?: InputMaybe<Events_Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  late_entry?: InputMaybe<Order_By>;
  not_in_competition?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  original_entry_pool?: InputMaybe<Order_By>;
  random_value?: InputMaybe<Order_By>;
  ranking?: InputMaybe<Order_By>;
  relay_age?: InputMaybe<Order_By>;
  relay_competitors_aggregate?: InputMaybe<Relay_Competitor_Aggregate_Order_By>;
  reserve?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  withdrawn?: InputMaybe<Order_By>;
};

/** columns and relationships of "entry_rank" */
export type Entry_Rank = {
  __typename?: 'entry_rank';
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  entry?: Maybe<Entry>;
  /** An object relationship */
  entry_list_type?: Maybe<Entry_List_Type>;
  entry_list_type_oid: Scalars['Int']['output'];
  entry_oid: Scalars['Int']['output'];
  entry_rank_type: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  oid: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "entry_rank" */
export type Entry_Rank_Aggregate_Order_By = {
  avg?: InputMaybe<Entry_Rank_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Entry_Rank_Max_Order_By>;
  min?: InputMaybe<Entry_Rank_Min_Order_By>;
  stddev?: InputMaybe<Entry_Rank_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Entry_Rank_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Entry_Rank_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Entry_Rank_Sum_Order_By>;
  var_pop?: InputMaybe<Entry_Rank_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Entry_Rank_Var_Samp_Order_By>;
  variance?: InputMaybe<Entry_Rank_Variance_Order_By>;
};

/** order by avg() on columns of table "entry_rank" */
export type Entry_Rank_Avg_Order_By = {
  entry_list_type_oid?: InputMaybe<Order_By>;
  entry_oid?: InputMaybe<Order_By>;
  entry_rank_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "entry_rank". All fields are combined with a logical 'AND'. */
export type Entry_Rank_Bool_Exp = {
  _and?: InputMaybe<Array<Entry_Rank_Bool_Exp>>;
  _not?: InputMaybe<Entry_Rank_Bool_Exp>;
  _or?: InputMaybe<Array<Entry_Rank_Bool_Exp>>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entry?: InputMaybe<Entry_Bool_Exp>;
  entry_list_type?: InputMaybe<Entry_List_Type_Bool_Exp>;
  entry_list_type_oid?: InputMaybe<Int_Comparison_Exp>;
  entry_oid?: InputMaybe<Int_Comparison_Exp>;
  entry_rank_type?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  oid?: InputMaybe<Int_Comparison_Exp>;
  rank?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "entry_rank" */
export type Entry_Rank_Max_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entry_list_type_oid?: InputMaybe<Order_By>;
  entry_oid?: InputMaybe<Order_By>;
  entry_rank_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "entry_rank" */
export type Entry_Rank_Min_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entry_list_type_oid?: InputMaybe<Order_By>;
  entry_oid?: InputMaybe<Order_By>;
  entry_rank_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "entry_rank". */
export type Entry_Rank_Order_By = {
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entry?: InputMaybe<Entry_Order_By>;
  entry_list_type?: InputMaybe<Entry_List_Type_Order_By>;
  entry_list_type_oid?: InputMaybe<Order_By>;
  entry_oid?: InputMaybe<Order_By>;
  entry_rank_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "entry_rank" */
export enum Entry_Rank_Select_Column {
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntryListTypeOid = 'entry_list_type_oid',
  /** column name */
  EntryOid = 'entry_oid',
  /** column name */
  EntryRankType = 'entry_rank_type',
  /** column name */
  Id = 'id',
  /** column name */
  Oid = 'oid',
  /** column name */
  Rank = 'rank',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "entry_rank" */
export type Entry_Rank_Stddev_Order_By = {
  entry_list_type_oid?: InputMaybe<Order_By>;
  entry_oid?: InputMaybe<Order_By>;
  entry_rank_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "entry_rank" */
export type Entry_Rank_Stddev_Pop_Order_By = {
  entry_list_type_oid?: InputMaybe<Order_By>;
  entry_oid?: InputMaybe<Order_By>;
  entry_rank_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "entry_rank" */
export type Entry_Rank_Stddev_Samp_Order_By = {
  entry_list_type_oid?: InputMaybe<Order_By>;
  entry_oid?: InputMaybe<Order_By>;
  entry_rank_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "entry_rank" */
export type Entry_Rank_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Entry_Rank_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Entry_Rank_Stream_Cursor_Value_Input = {
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entry_list_type_oid?: InputMaybe<Scalars['Int']['input']>;
  entry_oid?: InputMaybe<Scalars['Int']['input']>;
  entry_rank_type?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  oid?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "entry_rank" */
export type Entry_Rank_Sum_Order_By = {
  entry_list_type_oid?: InputMaybe<Order_By>;
  entry_oid?: InputMaybe<Order_By>;
  entry_rank_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "entry_rank" */
export type Entry_Rank_Var_Pop_Order_By = {
  entry_list_type_oid?: InputMaybe<Order_By>;
  entry_oid?: InputMaybe<Order_By>;
  entry_rank_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "entry_rank" */
export type Entry_Rank_Var_Samp_Order_By = {
  entry_list_type_oid?: InputMaybe<Order_By>;
  entry_oid?: InputMaybe<Order_By>;
  entry_rank_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "entry_rank" */
export type Entry_Rank_Variance_Order_By = {
  entry_list_type_oid?: InputMaybe<Order_By>;
  entry_oid?: InputMaybe<Order_By>;
  entry_rank_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** select columns of table "entry" */
export enum Entry_Select_Column {
  /** column name */
  AutoWithdrawn = 'auto_withdrawn',
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CompetitorOid = 'competitor_oid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntryPool = 'entry_pool',
  /** column name */
  EntryTime = 'entry_time',
  /** column name */
  EntryTimeText = 'entry_time_text',
  /** column name */
  EventOid = 'event_oid',
  /** column name */
  Id = 'id',
  /** column name */
  LateEntry = 'late_entry',
  /** column name */
  NotInCompetition = 'not_in_competition',
  /** column name */
  Oid = 'oid',
  /** column name */
  OriginalEntryPool = 'original_entry_pool',
  /** column name */
  RandomValue = 'random_value',
  /** column name */
  Ranking = 'ranking',
  /** column name */
  RelayAge = 'relay_age',
  /** column name */
  Reserve = 'reserve',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Withdrawn = 'withdrawn'
}

/** order by stddev() on columns of table "entry" */
export type Entry_Stddev_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  entry_pool?: InputMaybe<Order_By>;
  entry_time?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  original_entry_pool?: InputMaybe<Order_By>;
  random_value?: InputMaybe<Order_By>;
  ranking?: InputMaybe<Order_By>;
  relay_age?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "entry" */
export type Entry_Stddev_Pop_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  entry_pool?: InputMaybe<Order_By>;
  entry_time?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  original_entry_pool?: InputMaybe<Order_By>;
  random_value?: InputMaybe<Order_By>;
  ranking?: InputMaybe<Order_By>;
  relay_age?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "entry" */
export type Entry_Stddev_Samp_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  entry_pool?: InputMaybe<Order_By>;
  entry_time?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  original_entry_pool?: InputMaybe<Order_By>;
  random_value?: InputMaybe<Order_By>;
  ranking?: InputMaybe<Order_By>;
  relay_age?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "entry" */
export type Entry_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Entry_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Entry_Stream_Cursor_Value_Input = {
  auto_withdrawn?: InputMaybe<Scalars['Boolean']['input']>;
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  competitor_oid?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entry_pool?: InputMaybe<Scalars['Int']['input']>;
  entry_time?: InputMaybe<Scalars['Int']['input']>;
  entry_time_text?: InputMaybe<Scalars['String']['input']>;
  event_oid?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  late_entry?: InputMaybe<Scalars['Boolean']['input']>;
  not_in_competition?: InputMaybe<Scalars['Boolean']['input']>;
  oid?: InputMaybe<Scalars['Int']['input']>;
  original_entry_pool?: InputMaybe<Scalars['Int']['input']>;
  random_value?: InputMaybe<Scalars['Int']['input']>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
  relay_age?: InputMaybe<Scalars['Int']['input']>;
  reserve?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  withdrawn?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by sum() on columns of table "entry" */
export type Entry_Sum_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  entry_pool?: InputMaybe<Order_By>;
  entry_time?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  original_entry_pool?: InputMaybe<Order_By>;
  random_value?: InputMaybe<Order_By>;
  ranking?: InputMaybe<Order_By>;
  relay_age?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "entry" */
export type Entry_Var_Pop_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  entry_pool?: InputMaybe<Order_By>;
  entry_time?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  original_entry_pool?: InputMaybe<Order_By>;
  random_value?: InputMaybe<Order_By>;
  ranking?: InputMaybe<Order_By>;
  relay_age?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "entry" */
export type Entry_Var_Samp_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  entry_pool?: InputMaybe<Order_By>;
  entry_time?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  original_entry_pool?: InputMaybe<Order_By>;
  random_value?: InputMaybe<Order_By>;
  ranking?: InputMaybe<Order_By>;
  relay_age?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "entry" */
export type Entry_Variance_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  entry_pool?: InputMaybe<Order_By>;
  entry_time?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  original_entry_pool?: InputMaybe<Order_By>;
  random_value?: InputMaybe<Order_By>;
  ranking?: InputMaybe<Order_By>;
  relay_age?: InputMaybe<Order_By>;
};

/** columns and relationships of "event_records" */
export type Event_Records = {
  __typename?: 'event_records';
  birth_date?: Maybe<Scalars['date']['output']>;
  club?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  competition?: Maybe<Competitions>;
  competition_id: Scalars['uuid']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  event?: Maybe<Events>;
  event_oid: Scalars['Int']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  meet_location?: Maybe<Scalars['String']['output']>;
  meet_nation?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  record_abbreviation?: Maybe<Scalars['String']['output']>;
  record_date?: Maybe<Scalars['date']['output']>;
  record_name?: Maybe<Scalars['String']['output']>;
  swimmer_nation?: Maybe<Scalars['String']['output']>;
  time: Scalars['Int']['output'];
  time_text?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by aggregate values of table "event_records" */
export type Event_Records_Aggregate_Order_By = {
  avg?: InputMaybe<Event_Records_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Event_Records_Max_Order_By>;
  min?: InputMaybe<Event_Records_Min_Order_By>;
  stddev?: InputMaybe<Event_Records_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Event_Records_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Event_Records_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Event_Records_Sum_Order_By>;
  var_pop?: InputMaybe<Event_Records_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Event_Records_Var_Samp_Order_By>;
  variance?: InputMaybe<Event_Records_Variance_Order_By>;
};

/** order by avg() on columns of table "event_records" */
export type Event_Records_Avg_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "event_records". All fields are combined with a logical 'AND'. */
export type Event_Records_Bool_Exp = {
  _and?: InputMaybe<Array<Event_Records_Bool_Exp>>;
  _not?: InputMaybe<Event_Records_Bool_Exp>;
  _or?: InputMaybe<Array<Event_Records_Bool_Exp>>;
  birth_date?: InputMaybe<Date_Comparison_Exp>;
  club?: InputMaybe<String_Comparison_Exp>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Events_Bool_Exp>;
  event_oid?: InputMaybe<Int_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  meet_location?: InputMaybe<String_Comparison_Exp>;
  meet_nation?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  record_abbreviation?: InputMaybe<String_Comparison_Exp>;
  record_date?: InputMaybe<Date_Comparison_Exp>;
  record_name?: InputMaybe<String_Comparison_Exp>;
  swimmer_nation?: InputMaybe<String_Comparison_Exp>;
  time?: InputMaybe<Int_Comparison_Exp>;
  time_text?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "event_records" */
export type Event_Records_Max_Order_By = {
  birth_date?: InputMaybe<Order_By>;
  club?: InputMaybe<Order_By>;
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  meet_location?: InputMaybe<Order_By>;
  meet_nation?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  record_abbreviation?: InputMaybe<Order_By>;
  record_date?: InputMaybe<Order_By>;
  record_name?: InputMaybe<Order_By>;
  swimmer_nation?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  time_text?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "event_records" */
export type Event_Records_Min_Order_By = {
  birth_date?: InputMaybe<Order_By>;
  club?: InputMaybe<Order_By>;
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  meet_location?: InputMaybe<Order_By>;
  meet_nation?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  record_abbreviation?: InputMaybe<Order_By>;
  record_date?: InputMaybe<Order_By>;
  record_name?: InputMaybe<Order_By>;
  swimmer_nation?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  time_text?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "event_records". */
export type Event_Records_Order_By = {
  birth_date?: InputMaybe<Order_By>;
  club?: InputMaybe<Order_By>;
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event?: InputMaybe<Events_Order_By>;
  event_oid?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  meet_location?: InputMaybe<Order_By>;
  meet_nation?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  record_abbreviation?: InputMaybe<Order_By>;
  record_date?: InputMaybe<Order_By>;
  record_name?: InputMaybe<Order_By>;
  swimmer_nation?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  time_text?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "event_records" */
export enum Event_Records_Select_Column {
  /** column name */
  BirthDate = 'birth_date',
  /** column name */
  Club = 'club',
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventOid = 'event_oid',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  MeetLocation = 'meet_location',
  /** column name */
  MeetNation = 'meet_nation',
  /** column name */
  Order = 'order',
  /** column name */
  RecordAbbreviation = 'record_abbreviation',
  /** column name */
  RecordDate = 'record_date',
  /** column name */
  RecordName = 'record_name',
  /** column name */
  SwimmerNation = 'swimmer_nation',
  /** column name */
  Time = 'time',
  /** column name */
  TimeText = 'time_text',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "event_records" */
export type Event_Records_Stddev_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "event_records" */
export type Event_Records_Stddev_Pop_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "event_records" */
export type Event_Records_Stddev_Samp_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "event_records" */
export type Event_Records_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Event_Records_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Event_Records_Stream_Cursor_Value_Input = {
  birth_date?: InputMaybe<Scalars['date']['input']>;
  club?: InputMaybe<Scalars['String']['input']>;
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_oid?: InputMaybe<Scalars['Int']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  meet_location?: InputMaybe<Scalars['String']['input']>;
  meet_nation?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  record_abbreviation?: InputMaybe<Scalars['String']['input']>;
  record_date?: InputMaybe<Scalars['date']['input']>;
  record_name?: InputMaybe<Scalars['String']['input']>;
  swimmer_nation?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  time_text?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "event_records" */
export type Event_Records_Sum_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "event_records" */
export type Event_Records_Var_Pop_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "event_records" */
export type Event_Records_Var_Samp_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "event_records" */
export type Event_Records_Variance_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
};

/** columns and relationships of "events" */
export type Events = {
  __typename?: 'events';
  /** An array relationship */
  agegroups: Array<Agegroup>;
  athlete_count: Scalars['Int']['output'];
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  distance: Scalars['Int']['output'];
  /** An array relationship */
  entries: Array<Entry>;
  /** An array relationship */
  entry_list_types: Array<Entry_List_Type>;
  event_competition_level: Scalars['Int']['output'];
  /** An array relationship */
  event_records: Array<Event_Records>;
  event_type: Scalars['Int']['output'];
  gender_number: Scalars['Int']['output'];
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  is_masters_event: Scalars['Boolean']['output'];
  is_para_event: Scalars['Boolean']['output'];
  is_relay: Scalars['Boolean']['output'];
  max_age: Scalars['Int']['output'];
  min_age: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  oid: Scalars['Int']['output'];
  /** An array relationship */
  rounds: Array<Round>;
  /** An object relationship */
  sponsor?: Maybe<Sponsor>;
  sponsor_oid?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  use_pre_masters: Scalars['Boolean']['output'];
};


/** columns and relationships of "events" */
export type EventsAgegroupsArgs = {
  distinct_on?: InputMaybe<Array<Agegroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agegroup_Order_By>>;
  where?: InputMaybe<Agegroup_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEntriesArgs = {
  distinct_on?: InputMaybe<Array<Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entry_Order_By>>;
  where?: InputMaybe<Entry_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEntry_List_TypesArgs = {
  distinct_on?: InputMaybe<Array<Entry_List_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entry_List_Type_Order_By>>;
  where?: InputMaybe<Entry_List_Type_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEvent_RecordsArgs = {
  distinct_on?: InputMaybe<Array<Event_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Records_Order_By>>;
  where?: InputMaybe<Event_Records_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsRoundsArgs = {
  distinct_on?: InputMaybe<Array<Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Round_Order_By>>;
  where?: InputMaybe<Round_Bool_Exp>;
};

/** order by aggregate values of table "events" */
export type Events_Aggregate_Order_By = {
  avg?: InputMaybe<Events_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Events_Max_Order_By>;
  min?: InputMaybe<Events_Min_Order_By>;
  stddev?: InputMaybe<Events_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Events_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Events_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Events_Sum_Order_By>;
  var_pop?: InputMaybe<Events_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Events_Var_Samp_Order_By>;
  variance?: InputMaybe<Events_Variance_Order_By>;
};

/** order by avg() on columns of table "events" */
export type Events_Avg_Order_By = {
  athlete_count?: InputMaybe<Order_By>;
  distance?: InputMaybe<Order_By>;
  event_competition_level?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  gender_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_age?: InputMaybe<Order_By>;
  min_age?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  sponsor_oid?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "events". All fields are combined with a logical 'AND'. */
export type Events_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Bool_Exp>>;
  _not?: InputMaybe<Events_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Bool_Exp>>;
  agegroups?: InputMaybe<Agegroup_Bool_Exp>;
  athlete_count?: InputMaybe<Int_Comparison_Exp>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  distance?: InputMaybe<Int_Comparison_Exp>;
  entries?: InputMaybe<Entry_Bool_Exp>;
  entry_list_types?: InputMaybe<Entry_List_Type_Bool_Exp>;
  event_competition_level?: InputMaybe<Int_Comparison_Exp>;
  event_records?: InputMaybe<Event_Records_Bool_Exp>;
  event_type?: InputMaybe<Int_Comparison_Exp>;
  gender_number?: InputMaybe<Int_Comparison_Exp>;
  hidden?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_masters_event?: InputMaybe<Boolean_Comparison_Exp>;
  is_para_event?: InputMaybe<Boolean_Comparison_Exp>;
  is_relay?: InputMaybe<Boolean_Comparison_Exp>;
  max_age?: InputMaybe<Int_Comparison_Exp>;
  min_age?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<Int_Comparison_Exp>;
  oid?: InputMaybe<Int_Comparison_Exp>;
  rounds?: InputMaybe<Round_Bool_Exp>;
  sponsor?: InputMaybe<Sponsor_Bool_Exp>;
  sponsor_oid?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  use_pre_masters?: InputMaybe<Boolean_Comparison_Exp>;
};

/** order by max() on columns of table "events" */
export type Events_Max_Order_By = {
  athlete_count?: InputMaybe<Order_By>;
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  distance?: InputMaybe<Order_By>;
  event_competition_level?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  gender_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_age?: InputMaybe<Order_By>;
  min_age?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  sponsor_oid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "events" */
export type Events_Min_Order_By = {
  athlete_count?: InputMaybe<Order_By>;
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  distance?: InputMaybe<Order_By>;
  event_competition_level?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  gender_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_age?: InputMaybe<Order_By>;
  min_age?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  sponsor_oid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "events". */
export type Events_Order_By = {
  agegroups_aggregate?: InputMaybe<Agegroup_Aggregate_Order_By>;
  athlete_count?: InputMaybe<Order_By>;
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  distance?: InputMaybe<Order_By>;
  entries_aggregate?: InputMaybe<Entry_Aggregate_Order_By>;
  entry_list_types_aggregate?: InputMaybe<Entry_List_Type_Aggregate_Order_By>;
  event_competition_level?: InputMaybe<Order_By>;
  event_records_aggregate?: InputMaybe<Event_Records_Aggregate_Order_By>;
  event_type?: InputMaybe<Order_By>;
  gender_number?: InputMaybe<Order_By>;
  hidden?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_masters_event?: InputMaybe<Order_By>;
  is_para_event?: InputMaybe<Order_By>;
  is_relay?: InputMaybe<Order_By>;
  max_age?: InputMaybe<Order_By>;
  min_age?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rounds_aggregate?: InputMaybe<Round_Aggregate_Order_By>;
  sponsor?: InputMaybe<Sponsor_Order_By>;
  sponsor_oid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  use_pre_masters?: InputMaybe<Order_By>;
};

/** select columns of table "events" */
export enum Events_Select_Column {
  /** column name */
  AthleteCount = 'athlete_count',
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Distance = 'distance',
  /** column name */
  EventCompetitionLevel = 'event_competition_level',
  /** column name */
  EventType = 'event_type',
  /** column name */
  GenderNumber = 'gender_number',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  IsMastersEvent = 'is_masters_event',
  /** column name */
  IsParaEvent = 'is_para_event',
  /** column name */
  IsRelay = 'is_relay',
  /** column name */
  MaxAge = 'max_age',
  /** column name */
  MinAge = 'min_age',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  Oid = 'oid',
  /** column name */
  SponsorOid = 'sponsor_oid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsePreMasters = 'use_pre_masters'
}

/** order by stddev() on columns of table "events" */
export type Events_Stddev_Order_By = {
  athlete_count?: InputMaybe<Order_By>;
  distance?: InputMaybe<Order_By>;
  event_competition_level?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  gender_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_age?: InputMaybe<Order_By>;
  min_age?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  sponsor_oid?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "events" */
export type Events_Stddev_Pop_Order_By = {
  athlete_count?: InputMaybe<Order_By>;
  distance?: InputMaybe<Order_By>;
  event_competition_level?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  gender_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_age?: InputMaybe<Order_By>;
  min_age?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  sponsor_oid?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "events" */
export type Events_Stddev_Samp_Order_By = {
  athlete_count?: InputMaybe<Order_By>;
  distance?: InputMaybe<Order_By>;
  event_competition_level?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  gender_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_age?: InputMaybe<Order_By>;
  min_age?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  sponsor_oid?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "events" */
export type Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Stream_Cursor_Value_Input = {
  athlete_count?: InputMaybe<Scalars['Int']['input']>;
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  distance?: InputMaybe<Scalars['Int']['input']>;
  event_competition_level?: InputMaybe<Scalars['Int']['input']>;
  event_type?: InputMaybe<Scalars['Int']['input']>;
  gender_number?: InputMaybe<Scalars['Int']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_masters_event?: InputMaybe<Scalars['Boolean']['input']>;
  is_para_event?: InputMaybe<Scalars['Boolean']['input']>;
  is_relay?: InputMaybe<Scalars['Boolean']['input']>;
  max_age?: InputMaybe<Scalars['Int']['input']>;
  min_age?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  oid?: InputMaybe<Scalars['Int']['input']>;
  sponsor_oid?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_pre_masters?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by sum() on columns of table "events" */
export type Events_Sum_Order_By = {
  athlete_count?: InputMaybe<Order_By>;
  distance?: InputMaybe<Order_By>;
  event_competition_level?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  gender_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_age?: InputMaybe<Order_By>;
  min_age?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  sponsor_oid?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "events" */
export type Events_Var_Pop_Order_By = {
  athlete_count?: InputMaybe<Order_By>;
  distance?: InputMaybe<Order_By>;
  event_competition_level?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  gender_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_age?: InputMaybe<Order_By>;
  min_age?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  sponsor_oid?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "events" */
export type Events_Var_Samp_Order_By = {
  athlete_count?: InputMaybe<Order_By>;
  distance?: InputMaybe<Order_By>;
  event_competition_level?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  gender_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_age?: InputMaybe<Order_By>;
  min_age?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  sponsor_oid?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "events" */
export type Events_Variance_Order_By = {
  athlete_count?: InputMaybe<Order_By>;
  distance?: InputMaybe<Order_By>;
  event_competition_level?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  gender_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_age?: InputMaybe<Order_By>;
  min_age?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  sponsor_oid?: InputMaybe<Order_By>;
};

/** columns and relationships of "file_archive" */
export type File_Archive = {
  __typename?: 'file_archive';
  category_type: Scalars['Int']['output'];
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  /** An object relationship */
  competition_session?: Maybe<Competition_Session>;
  competition_session_oid?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  link?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  /** An object relationship */
  round?: Maybe<Round>;
  round_oid?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  visible: Scalars['Boolean']['output'];
};

/** order by aggregate values of table "file_archive" */
export type File_Archive_Aggregate_Order_By = {
  avg?: InputMaybe<File_Archive_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<File_Archive_Max_Order_By>;
  min?: InputMaybe<File_Archive_Min_Order_By>;
  stddev?: InputMaybe<File_Archive_Stddev_Order_By>;
  stddev_pop?: InputMaybe<File_Archive_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<File_Archive_Stddev_Samp_Order_By>;
  sum?: InputMaybe<File_Archive_Sum_Order_By>;
  var_pop?: InputMaybe<File_Archive_Var_Pop_Order_By>;
  var_samp?: InputMaybe<File_Archive_Var_Samp_Order_By>;
  variance?: InputMaybe<File_Archive_Variance_Order_By>;
};

/** order by avg() on columns of table "file_archive" */
export type File_Archive_Avg_Order_By = {
  category_type?: InputMaybe<Order_By>;
  competition_session_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "file_archive". All fields are combined with a logical 'AND'. */
export type File_Archive_Bool_Exp = {
  _and?: InputMaybe<Array<File_Archive_Bool_Exp>>;
  _not?: InputMaybe<File_Archive_Bool_Exp>;
  _or?: InputMaybe<Array<File_Archive_Bool_Exp>>;
  category_type?: InputMaybe<Int_Comparison_Exp>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  competition_session?: InputMaybe<Competition_Session_Bool_Exp>;
  competition_session_oid?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  link?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  round?: InputMaybe<Round_Bool_Exp>;
  round_oid?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  visible?: InputMaybe<Boolean_Comparison_Exp>;
};

/** order by max() on columns of table "file_archive" */
export type File_Archive_Max_Order_By = {
  category_type?: InputMaybe<Order_By>;
  competition_id?: InputMaybe<Order_By>;
  competition_session_oid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "file_archive" */
export type File_Archive_Min_Order_By = {
  category_type?: InputMaybe<Order_By>;
  competition_id?: InputMaybe<Order_By>;
  competition_session_oid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "file_archive". */
export type File_Archive_Order_By = {
  category_type?: InputMaybe<Order_By>;
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  competition_session?: InputMaybe<Competition_Session_Order_By>;
  competition_session_oid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  round?: InputMaybe<Round_Order_By>;
  round_oid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  visible?: InputMaybe<Order_By>;
};

/** select columns of table "file_archive" */
export enum File_Archive_Select_Column {
  /** column name */
  CategoryType = 'category_type',
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CompetitionSessionOid = 'competition_session_oid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Link = 'link',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  RoundOid = 'round_oid',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Visible = 'visible'
}

/** order by stddev() on columns of table "file_archive" */
export type File_Archive_Stddev_Order_By = {
  category_type?: InputMaybe<Order_By>;
  competition_session_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "file_archive" */
export type File_Archive_Stddev_Pop_Order_By = {
  category_type?: InputMaybe<Order_By>;
  competition_session_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "file_archive" */
export type File_Archive_Stddev_Samp_Order_By = {
  category_type?: InputMaybe<Order_By>;
  competition_session_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "file_archive" */
export type File_Archive_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: File_Archive_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type File_Archive_Stream_Cursor_Value_Input = {
  category_type?: InputMaybe<Scalars['Int']['input']>;
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  competition_session_oid?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  round_oid?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by sum() on columns of table "file_archive" */
export type File_Archive_Sum_Order_By = {
  category_type?: InputMaybe<Order_By>;
  competition_session_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "file_archive" */
export type File_Archive_Var_Pop_Order_By = {
  category_type?: InputMaybe<Order_By>;
  competition_session_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "file_archive" */
export type File_Archive_Var_Samp_Order_By = {
  category_type?: InputMaybe<Order_By>;
  competition_session_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "file_archive" */
export type File_Archive_Variance_Order_By = {
  category_type?: InputMaybe<Order_By>;
  competition_session_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
};

/** columns and relationships of "get_current_time" */
export type Get_Current_Time = {
  __typename?: 'get_current_time';
  time?: Maybe<Scalars['timestamptz']['output']>;
};

/** Boolean expression to filter rows from the table "get_current_time". All fields are combined with a logical 'AND'. */
export type Get_Current_Time_Bool_Exp = {
  _and?: InputMaybe<Array<Get_Current_Time_Bool_Exp>>;
  _not?: InputMaybe<Get_Current_Time_Bool_Exp>;
  _or?: InputMaybe<Array<Get_Current_Time_Bool_Exp>>;
  time?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "get_current_time". */
export type Get_Current_Time_Order_By = {
  time?: InputMaybe<Order_By>;
};

/** select columns of table "get_current_time" */
export enum Get_Current_Time_Select_Column {
  /** column name */
  Time = 'time'
}

/** Streaming cursor of the table "get_current_time" */
export type Get_Current_Time_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Get_Current_Time_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Get_Current_Time_Stream_Cursor_Value_Input = {
  time?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "heat" */
export type Heat = {
  __typename?: 'heat';
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  estimated_start_time: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An array relationship */
  lanes: Array<Lane>;
  name: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  oid: Scalars['Int']['output'];
  priority: Scalars['Int']['output'];
  /** An object relationship */
  round?: Maybe<Round>;
  round_oid: Scalars['Int']['output'];
  start_time: Scalars['timestamptz']['output'];
  status: Scalars['Int']['output'];
  /** An object relationship */
  time_program_entry?: Maybe<Time_Program_Entry>;
  time_program_entry_oid?: Maybe<Scalars['Int']['output']>;
  updated: Scalars['Boolean']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "heat" */
export type HeatLanesArgs = {
  distinct_on?: InputMaybe<Array<Lane_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lane_Order_By>>;
  where?: InputMaybe<Lane_Bool_Exp>;
};

/** order by aggregate values of table "heat" */
export type Heat_Aggregate_Order_By = {
  avg?: InputMaybe<Heat_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Heat_Max_Order_By>;
  min?: InputMaybe<Heat_Min_Order_By>;
  stddev?: InputMaybe<Heat_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Heat_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Heat_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Heat_Sum_Order_By>;
  var_pop?: InputMaybe<Heat_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Heat_Var_Samp_Order_By>;
  variance?: InputMaybe<Heat_Variance_Order_By>;
};

/** order by avg() on columns of table "heat" */
export type Heat_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  time_program_entry_oid?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "heat". All fields are combined with a logical 'AND'. */
export type Heat_Bool_Exp = {
  _and?: InputMaybe<Array<Heat_Bool_Exp>>;
  _not?: InputMaybe<Heat_Bool_Exp>;
  _or?: InputMaybe<Array<Heat_Bool_Exp>>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  estimated_start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lanes?: InputMaybe<Lane_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<Int_Comparison_Exp>;
  oid?: InputMaybe<Int_Comparison_Exp>;
  priority?: InputMaybe<Int_Comparison_Exp>;
  round?: InputMaybe<Round_Bool_Exp>;
  round_oid?: InputMaybe<Int_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<Int_Comparison_Exp>;
  time_program_entry?: InputMaybe<Time_Program_Entry_Bool_Exp>;
  time_program_entry_oid?: InputMaybe<Int_Comparison_Exp>;
  updated?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "heat" */
export type Heat_Max_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  estimated_start_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  time_program_entry_oid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "heat" */
export type Heat_Min_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  estimated_start_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  time_program_entry_oid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "heat". */
export type Heat_Order_By = {
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  estimated_start_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lanes_aggregate?: InputMaybe<Lane_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  round?: InputMaybe<Round_Order_By>;
  round_oid?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  time_program_entry?: InputMaybe<Time_Program_Entry_Order_By>;
  time_program_entry_oid?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "heat" */
export enum Heat_Select_Column {
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EstimatedStartTime = 'estimated_start_time',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  Oid = 'oid',
  /** column name */
  Priority = 'priority',
  /** column name */
  RoundOid = 'round_oid',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status',
  /** column name */
  TimeProgramEntryOid = 'time_program_entry_oid',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "heat" */
export type Heat_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  time_program_entry_oid?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "heat" */
export type Heat_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  time_program_entry_oid?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "heat" */
export type Heat_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  time_program_entry_oid?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "heat" */
export type Heat_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Heat_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Heat_Stream_Cursor_Value_Input = {
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  estimated_start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  oid?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  round_oid?: InputMaybe<Scalars['Int']['input']>;
  start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  time_program_entry_oid?: InputMaybe<Scalars['Int']['input']>;
  updated?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "heat" */
export type Heat_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  time_program_entry_oid?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "heat" */
export type Heat_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  time_program_entry_oid?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "heat" */
export type Heat_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  time_program_entry_oid?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "heat" */
export type Heat_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  time_program_entry_oid?: InputMaybe<Order_By>;
};

/** columns and relationships of "lane" */
export type Lane = {
  __typename?: 'lane';
  checked: Scalars['Boolean']['output'];
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  /** An object relationship */
  competitor?: Maybe<Competitor>;
  competitor_oid?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dnf: Scalars['Boolean']['output'];
  dns: Scalars['Boolean']['output'];
  dq_code?: Maybe<Scalars['String']['output']>;
  dq_description?: Maybe<Scalars['String']['output']>;
  dq_relay_swimmer: Scalars['Int']['output'];
  dsq: Scalars['Boolean']['output'];
  entry_pool: Scalars['Int']['output'];
  entry_time: Scalars['Int']['output'];
  entry_time_text: Scalars['String']['output'];
  fina_points: Scalars['Int']['output'];
  /** An object relationship */
  heat?: Maybe<Heat>;
  heat_oid: Scalars['Int']['output'];
  /** A computed field, executes function "get_heat_rank" */
  heat_rank?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  not_in_competition: Scalars['Boolean']['output'];
  note: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  oid: Scalars['Int']['output'];
  qualification: Scalars['String']['output'];
  /** An array relationship */
  ranks: Array<Rank>;
  reaction_time?: Maybe<Scalars['String']['output']>;
  relay_age: Scalars['Int']['output'];
  /** An array relationship */
  relay_competitors: Array<Relay_Competitor>;
  result_text: Scalars['String']['output'];
  result_value: Scalars['Int']['output'];
  /** An array relationship */
  sub_results: Array<Sub_Results>;
  swimmed_distance: Scalars['Int']['output'];
  /** A computed field, executes function "get_total_rank" */
  total_rank?: Maybe<Scalars['Int']['output']>;
  updated: Scalars['Boolean']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  wps_points: Scalars['Int']['output'];
};


/** columns and relationships of "lane" */
export type LaneRanksArgs = {
  distinct_on?: InputMaybe<Array<Rank_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rank_Order_By>>;
  where?: InputMaybe<Rank_Bool_Exp>;
};


/** columns and relationships of "lane" */
export type LaneRelay_CompetitorsArgs = {
  distinct_on?: InputMaybe<Array<Relay_Competitor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relay_Competitor_Order_By>>;
  where?: InputMaybe<Relay_Competitor_Bool_Exp>;
};


/** columns and relationships of "lane" */
export type LaneSub_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Sub_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sub_Results_Order_By>>;
  where?: InputMaybe<Sub_Results_Bool_Exp>;
};

/** order by aggregate values of table "lane" */
export type Lane_Aggregate_Order_By = {
  avg?: InputMaybe<Lane_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lane_Max_Order_By>;
  min?: InputMaybe<Lane_Min_Order_By>;
  stddev?: InputMaybe<Lane_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lane_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lane_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lane_Sum_Order_By>;
  var_pop?: InputMaybe<Lane_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lane_Var_Samp_Order_By>;
  variance?: InputMaybe<Lane_Variance_Order_By>;
};

/** order by avg() on columns of table "lane" */
export type Lane_Avg_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  dq_relay_swimmer?: InputMaybe<Order_By>;
  entry_pool?: InputMaybe<Order_By>;
  entry_time?: InputMaybe<Order_By>;
  fina_points?: InputMaybe<Order_By>;
  heat_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  relay_age?: InputMaybe<Order_By>;
  result_value?: InputMaybe<Order_By>;
  swimmed_distance?: InputMaybe<Order_By>;
  wps_points?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lane". All fields are combined with a logical 'AND'. */
export type Lane_Bool_Exp = {
  _and?: InputMaybe<Array<Lane_Bool_Exp>>;
  _not?: InputMaybe<Lane_Bool_Exp>;
  _or?: InputMaybe<Array<Lane_Bool_Exp>>;
  checked?: InputMaybe<Boolean_Comparison_Exp>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  competitor?: InputMaybe<Competitor_Bool_Exp>;
  competitor_oid?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dnf?: InputMaybe<Boolean_Comparison_Exp>;
  dns?: InputMaybe<Boolean_Comparison_Exp>;
  dq_code?: InputMaybe<String_Comparison_Exp>;
  dq_description?: InputMaybe<String_Comparison_Exp>;
  dq_relay_swimmer?: InputMaybe<Int_Comparison_Exp>;
  dsq?: InputMaybe<Boolean_Comparison_Exp>;
  entry_pool?: InputMaybe<Int_Comparison_Exp>;
  entry_time?: InputMaybe<Int_Comparison_Exp>;
  entry_time_text?: InputMaybe<String_Comparison_Exp>;
  fina_points?: InputMaybe<Int_Comparison_Exp>;
  heat?: InputMaybe<Heat_Bool_Exp>;
  heat_oid?: InputMaybe<Int_Comparison_Exp>;
  heat_rank?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  not_in_competition?: InputMaybe<Boolean_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<Int_Comparison_Exp>;
  oid?: InputMaybe<Int_Comparison_Exp>;
  qualification?: InputMaybe<String_Comparison_Exp>;
  ranks?: InputMaybe<Rank_Bool_Exp>;
  reaction_time?: InputMaybe<String_Comparison_Exp>;
  relay_age?: InputMaybe<Int_Comparison_Exp>;
  relay_competitors?: InputMaybe<Relay_Competitor_Bool_Exp>;
  result_text?: InputMaybe<String_Comparison_Exp>;
  result_value?: InputMaybe<Int_Comparison_Exp>;
  sub_results?: InputMaybe<Sub_Results_Bool_Exp>;
  swimmed_distance?: InputMaybe<Int_Comparison_Exp>;
  total_rank?: InputMaybe<Int_Comparison_Exp>;
  updated?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  wps_points?: InputMaybe<Int_Comparison_Exp>;
};

/** order by max() on columns of table "lane" */
export type Lane_Max_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dq_code?: InputMaybe<Order_By>;
  dq_description?: InputMaybe<Order_By>;
  dq_relay_swimmer?: InputMaybe<Order_By>;
  entry_pool?: InputMaybe<Order_By>;
  entry_time?: InputMaybe<Order_By>;
  entry_time_text?: InputMaybe<Order_By>;
  fina_points?: InputMaybe<Order_By>;
  heat_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  qualification?: InputMaybe<Order_By>;
  reaction_time?: InputMaybe<Order_By>;
  relay_age?: InputMaybe<Order_By>;
  result_text?: InputMaybe<Order_By>;
  result_value?: InputMaybe<Order_By>;
  swimmed_distance?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wps_points?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "lane" */
export type Lane_Min_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dq_code?: InputMaybe<Order_By>;
  dq_description?: InputMaybe<Order_By>;
  dq_relay_swimmer?: InputMaybe<Order_By>;
  entry_pool?: InputMaybe<Order_By>;
  entry_time?: InputMaybe<Order_By>;
  entry_time_text?: InputMaybe<Order_By>;
  fina_points?: InputMaybe<Order_By>;
  heat_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  qualification?: InputMaybe<Order_By>;
  reaction_time?: InputMaybe<Order_By>;
  relay_age?: InputMaybe<Order_By>;
  result_text?: InputMaybe<Order_By>;
  result_value?: InputMaybe<Order_By>;
  swimmed_distance?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wps_points?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "lane". */
export type Lane_Order_By = {
  checked?: InputMaybe<Order_By>;
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  competitor?: InputMaybe<Competitor_Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dnf?: InputMaybe<Order_By>;
  dns?: InputMaybe<Order_By>;
  dq_code?: InputMaybe<Order_By>;
  dq_description?: InputMaybe<Order_By>;
  dq_relay_swimmer?: InputMaybe<Order_By>;
  dsq?: InputMaybe<Order_By>;
  entry_pool?: InputMaybe<Order_By>;
  entry_time?: InputMaybe<Order_By>;
  entry_time_text?: InputMaybe<Order_By>;
  fina_points?: InputMaybe<Order_By>;
  heat?: InputMaybe<Heat_Order_By>;
  heat_oid?: InputMaybe<Order_By>;
  heat_rank?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  not_in_competition?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  qualification?: InputMaybe<Order_By>;
  ranks_aggregate?: InputMaybe<Rank_Aggregate_Order_By>;
  reaction_time?: InputMaybe<Order_By>;
  relay_age?: InputMaybe<Order_By>;
  relay_competitors_aggregate?: InputMaybe<Relay_Competitor_Aggregate_Order_By>;
  result_text?: InputMaybe<Order_By>;
  result_value?: InputMaybe<Order_By>;
  sub_results_aggregate?: InputMaybe<Sub_Results_Aggregate_Order_By>;
  swimmed_distance?: InputMaybe<Order_By>;
  total_rank?: InputMaybe<Order_By>;
  updated?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wps_points?: InputMaybe<Order_By>;
};

/** select columns of table "lane" */
export enum Lane_Select_Column {
  /** column name */
  Checked = 'checked',
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CompetitorOid = 'competitor_oid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Dnf = 'dnf',
  /** column name */
  Dns = 'dns',
  /** column name */
  DqCode = 'dq_code',
  /** column name */
  DqDescription = 'dq_description',
  /** column name */
  DqRelaySwimmer = 'dq_relay_swimmer',
  /** column name */
  Dsq = 'dsq',
  /** column name */
  EntryPool = 'entry_pool',
  /** column name */
  EntryTime = 'entry_time',
  /** column name */
  EntryTimeText = 'entry_time_text',
  /** column name */
  FinaPoints = 'fina_points',
  /** column name */
  HeatOid = 'heat_oid',
  /** column name */
  Id = 'id',
  /** column name */
  NotInCompetition = 'not_in_competition',
  /** column name */
  Note = 'note',
  /** column name */
  Number = 'number',
  /** column name */
  Oid = 'oid',
  /** column name */
  Qualification = 'qualification',
  /** column name */
  ReactionTime = 'reaction_time',
  /** column name */
  RelayAge = 'relay_age',
  /** column name */
  ResultText = 'result_text',
  /** column name */
  ResultValue = 'result_value',
  /** column name */
  SwimmedDistance = 'swimmed_distance',
  /** column name */
  Updated = 'updated',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WpsPoints = 'wps_points'
}

/** order by stddev() on columns of table "lane" */
export type Lane_Stddev_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  dq_relay_swimmer?: InputMaybe<Order_By>;
  entry_pool?: InputMaybe<Order_By>;
  entry_time?: InputMaybe<Order_By>;
  fina_points?: InputMaybe<Order_By>;
  heat_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  relay_age?: InputMaybe<Order_By>;
  result_value?: InputMaybe<Order_By>;
  swimmed_distance?: InputMaybe<Order_By>;
  wps_points?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "lane" */
export type Lane_Stddev_Pop_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  dq_relay_swimmer?: InputMaybe<Order_By>;
  entry_pool?: InputMaybe<Order_By>;
  entry_time?: InputMaybe<Order_By>;
  fina_points?: InputMaybe<Order_By>;
  heat_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  relay_age?: InputMaybe<Order_By>;
  result_value?: InputMaybe<Order_By>;
  swimmed_distance?: InputMaybe<Order_By>;
  wps_points?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "lane" */
export type Lane_Stddev_Samp_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  dq_relay_swimmer?: InputMaybe<Order_By>;
  entry_pool?: InputMaybe<Order_By>;
  entry_time?: InputMaybe<Order_By>;
  fina_points?: InputMaybe<Order_By>;
  heat_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  relay_age?: InputMaybe<Order_By>;
  result_value?: InputMaybe<Order_By>;
  swimmed_distance?: InputMaybe<Order_By>;
  wps_points?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lane" */
export type Lane_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lane_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lane_Stream_Cursor_Value_Input = {
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  competitor_oid?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dnf?: InputMaybe<Scalars['Boolean']['input']>;
  dns?: InputMaybe<Scalars['Boolean']['input']>;
  dq_code?: InputMaybe<Scalars['String']['input']>;
  dq_description?: InputMaybe<Scalars['String']['input']>;
  dq_relay_swimmer?: InputMaybe<Scalars['Int']['input']>;
  dsq?: InputMaybe<Scalars['Boolean']['input']>;
  entry_pool?: InputMaybe<Scalars['Int']['input']>;
  entry_time?: InputMaybe<Scalars['Int']['input']>;
  entry_time_text?: InputMaybe<Scalars['String']['input']>;
  fina_points?: InputMaybe<Scalars['Int']['input']>;
  heat_oid?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  not_in_competition?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  oid?: InputMaybe<Scalars['Int']['input']>;
  qualification?: InputMaybe<Scalars['String']['input']>;
  reaction_time?: InputMaybe<Scalars['String']['input']>;
  relay_age?: InputMaybe<Scalars['Int']['input']>;
  result_text?: InputMaybe<Scalars['String']['input']>;
  result_value?: InputMaybe<Scalars['Int']['input']>;
  swimmed_distance?: InputMaybe<Scalars['Int']['input']>;
  updated?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  wps_points?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "lane" */
export type Lane_Sum_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  dq_relay_swimmer?: InputMaybe<Order_By>;
  entry_pool?: InputMaybe<Order_By>;
  entry_time?: InputMaybe<Order_By>;
  fina_points?: InputMaybe<Order_By>;
  heat_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  relay_age?: InputMaybe<Order_By>;
  result_value?: InputMaybe<Order_By>;
  swimmed_distance?: InputMaybe<Order_By>;
  wps_points?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "lane" */
export type Lane_Var_Pop_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  dq_relay_swimmer?: InputMaybe<Order_By>;
  entry_pool?: InputMaybe<Order_By>;
  entry_time?: InputMaybe<Order_By>;
  fina_points?: InputMaybe<Order_By>;
  heat_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  relay_age?: InputMaybe<Order_By>;
  result_value?: InputMaybe<Order_By>;
  swimmed_distance?: InputMaybe<Order_By>;
  wps_points?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "lane" */
export type Lane_Var_Samp_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  dq_relay_swimmer?: InputMaybe<Order_By>;
  entry_pool?: InputMaybe<Order_By>;
  entry_time?: InputMaybe<Order_By>;
  fina_points?: InputMaybe<Order_By>;
  heat_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  relay_age?: InputMaybe<Order_By>;
  result_value?: InputMaybe<Order_By>;
  swimmed_distance?: InputMaybe<Order_By>;
  wps_points?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "lane" */
export type Lane_Variance_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  dq_relay_swimmer?: InputMaybe<Order_By>;
  entry_pool?: InputMaybe<Order_By>;
  entry_time?: InputMaybe<Order_By>;
  fina_points?: InputMaybe<Order_By>;
  heat_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  relay_age?: InputMaybe<Order_By>;
  result_value?: InputMaybe<Order_By>;
  swimmed_distance?: InputMaybe<Order_By>;
  wps_points?: InputMaybe<Order_By>;
};

/** Swimify event types */
export type Lookup_Event_Type = {
  __typename?: 'lookup_event_type';
  event_type_id: Scalars['Int']['output'];
  id: Scalars['bigint']['output'];
  is_relay: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "lookup.event_type". All fields are combined with a logical 'AND'. */
export type Lookup_Event_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Lookup_Event_Type_Bool_Exp>>;
  _not?: InputMaybe<Lookup_Event_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Lookup_Event_Type_Bool_Exp>>;
  event_type_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  is_relay?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "lookup.event_type". */
export type Lookup_Event_Type_Order_By = {
  event_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_relay?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "lookup.event_type" */
export enum Lookup_Event_Type_Select_Column {
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsRelay = 'is_relay',
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "lookup_event_type" */
export type Lookup_Event_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lookup_Event_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lookup_Event_Type_Stream_Cursor_Value_Input = {
  event_type_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  is_relay?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "subscriptions.starred_competition" */
  delete_subscriptions_starred_competition?: Maybe<Subscriptions_Starred_Competition_Mutation_Response>;
  /** delete single row from the table: "subscriptions.starred_competition" */
  delete_subscriptions_starred_competition_by_pk?: Maybe<Subscriptions_Starred_Competition>;
  /** delete data from the table: "subscriptions.starred_competition_swimmers" */
  delete_subscriptions_starred_competition_swimmers?: Maybe<Subscriptions_Starred_Competition_Swimmers_Mutation_Response>;
  /** delete single row from the table: "subscriptions.starred_competition_swimmers" */
  delete_subscriptions_starred_competition_swimmers_by_pk?: Maybe<Subscriptions_Starred_Competition_Swimmers>;
  /** delete data from the table: "subscriptions.starred_global_swimmers" */
  delete_subscriptions_starred_global_swimmers?: Maybe<Subscriptions_Starred_Global_Swimmers_Mutation_Response>;
  /** delete single row from the table: "subscriptions.starred_global_swimmers" */
  delete_subscriptions_starred_global_swimmers_by_pk?: Maybe<Subscriptions_Starred_Global_Swimmers>;
  /** delete data from the table: "subscriptions.subscriber_device" */
  delete_subscriptions_subscriber_device?: Maybe<Subscriptions_Subscriber_Device_Mutation_Response>;
  /** delete single row from the table: "subscriptions.subscriber_device" */
  delete_subscriptions_subscriber_device_by_pk?: Maybe<Subscriptions_Subscriber_Device>;
  /** insert data into the table: "subscriptions.starred_competition" */
  insert_subscriptions_starred_competition?: Maybe<Subscriptions_Starred_Competition_Mutation_Response>;
  /** insert a single row into the table: "subscriptions.starred_competition" */
  insert_subscriptions_starred_competition_one?: Maybe<Subscriptions_Starred_Competition>;
  /** insert data into the table: "subscriptions.starred_competition_swimmers" */
  insert_subscriptions_starred_competition_swimmers?: Maybe<Subscriptions_Starred_Competition_Swimmers_Mutation_Response>;
  /** insert a single row into the table: "subscriptions.starred_competition_swimmers" */
  insert_subscriptions_starred_competition_swimmers_one?: Maybe<Subscriptions_Starred_Competition_Swimmers>;
  /** insert data into the table: "subscriptions.starred_global_swimmers" */
  insert_subscriptions_starred_global_swimmers?: Maybe<Subscriptions_Starred_Global_Swimmers_Mutation_Response>;
  /** insert a single row into the table: "subscriptions.starred_global_swimmers" */
  insert_subscriptions_starred_global_swimmers_one?: Maybe<Subscriptions_Starred_Global_Swimmers>;
  /** insert data into the table: "subscriptions.subscriber_device" */
  insert_subscriptions_subscriber_device?: Maybe<Subscriptions_Subscriber_Device_Mutation_Response>;
  /** insert a single row into the table: "subscriptions.subscriber_device" */
  insert_subscriptions_subscriber_device_one?: Maybe<Subscriptions_Subscriber_Device>;
  /** update data of the table: "subscriptions.starred_competition" */
  update_subscriptions_starred_competition?: Maybe<Subscriptions_Starred_Competition_Mutation_Response>;
  /** update single row of the table: "subscriptions.starred_competition" */
  update_subscriptions_starred_competition_by_pk?: Maybe<Subscriptions_Starred_Competition>;
  /** update multiples rows of table: "subscriptions.starred_competition" */
  update_subscriptions_starred_competition_many?: Maybe<Array<Maybe<Subscriptions_Starred_Competition_Mutation_Response>>>;
  /** update data of the table: "subscriptions.starred_competition_swimmers" */
  update_subscriptions_starred_competition_swimmers?: Maybe<Subscriptions_Starred_Competition_Swimmers_Mutation_Response>;
  /** update single row of the table: "subscriptions.starred_competition_swimmers" */
  update_subscriptions_starred_competition_swimmers_by_pk?: Maybe<Subscriptions_Starred_Competition_Swimmers>;
  /** update multiples rows of table: "subscriptions.starred_competition_swimmers" */
  update_subscriptions_starred_competition_swimmers_many?: Maybe<Array<Maybe<Subscriptions_Starred_Competition_Swimmers_Mutation_Response>>>;
  /** update data of the table: "subscriptions.starred_global_swimmers" */
  update_subscriptions_starred_global_swimmers?: Maybe<Subscriptions_Starred_Global_Swimmers_Mutation_Response>;
  /** update single row of the table: "subscriptions.starred_global_swimmers" */
  update_subscriptions_starred_global_swimmers_by_pk?: Maybe<Subscriptions_Starred_Global_Swimmers>;
  /** update multiples rows of table: "subscriptions.starred_global_swimmers" */
  update_subscriptions_starred_global_swimmers_many?: Maybe<Array<Maybe<Subscriptions_Starred_Global_Swimmers_Mutation_Response>>>;
  /** update data of the table: "subscriptions.subscriber_device" */
  update_subscriptions_subscriber_device?: Maybe<Subscriptions_Subscriber_Device_Mutation_Response>;
  /** update single row of the table: "subscriptions.subscriber_device" */
  update_subscriptions_subscriber_device_by_pk?: Maybe<Subscriptions_Subscriber_Device>;
  /** update multiples rows of table: "subscriptions.subscriber_device" */
  update_subscriptions_subscriber_device_many?: Maybe<Array<Maybe<Subscriptions_Subscriber_Device_Mutation_Response>>>;
  verify_subscription_purchase?: Maybe<SubscriberOutput>;
};


/** mutation root */
export type Mutation_RootDelete_Subscriptions_Starred_CompetitionArgs = {
  where: Subscriptions_Starred_Competition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscriptions_Starred_Competition_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Subscriptions_Starred_Competition_SwimmersArgs = {
  where: Subscriptions_Starred_Competition_Swimmers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscriptions_Starred_Competition_Swimmers_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Subscriptions_Starred_Global_SwimmersArgs = {
  where: Subscriptions_Starred_Global_Swimmers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscriptions_Starred_Global_Swimmers_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Subscriptions_Subscriber_DeviceArgs = {
  where: Subscriptions_Subscriber_Device_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscriptions_Subscriber_Device_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootInsert_Subscriptions_Starred_CompetitionArgs = {
  objects: Array<Subscriptions_Starred_Competition_Insert_Input>;
  on_conflict?: InputMaybe<Subscriptions_Starred_Competition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscriptions_Starred_Competition_OneArgs = {
  object: Subscriptions_Starred_Competition_Insert_Input;
  on_conflict?: InputMaybe<Subscriptions_Starred_Competition_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscriptions_Starred_Competition_SwimmersArgs = {
  objects: Array<Subscriptions_Starred_Competition_Swimmers_Insert_Input>;
  on_conflict?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscriptions_Starred_Competition_Swimmers_OneArgs = {
  object: Subscriptions_Starred_Competition_Swimmers_Insert_Input;
  on_conflict?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscriptions_Starred_Global_SwimmersArgs = {
  objects: Array<Subscriptions_Starred_Global_Swimmers_Insert_Input>;
  on_conflict?: InputMaybe<Subscriptions_Starred_Global_Swimmers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscriptions_Starred_Global_Swimmers_OneArgs = {
  object: Subscriptions_Starred_Global_Swimmers_Insert_Input;
  on_conflict?: InputMaybe<Subscriptions_Starred_Global_Swimmers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscriptions_Subscriber_DeviceArgs = {
  objects: Array<Subscriptions_Subscriber_Device_Insert_Input>;
  on_conflict?: InputMaybe<Subscriptions_Subscriber_Device_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscriptions_Subscriber_Device_OneArgs = {
  object: Subscriptions_Subscriber_Device_Insert_Input;
  on_conflict?: InputMaybe<Subscriptions_Subscriber_Device_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_Starred_CompetitionArgs = {
  _set?: InputMaybe<Subscriptions_Starred_Competition_Set_Input>;
  where: Subscriptions_Starred_Competition_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_Starred_Competition_By_PkArgs = {
  _set?: InputMaybe<Subscriptions_Starred_Competition_Set_Input>;
  pk_columns: Subscriptions_Starred_Competition_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_Starred_Competition_ManyArgs = {
  updates: Array<Subscriptions_Starred_Competition_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_Starred_Competition_SwimmersArgs = {
  _inc?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Set_Input>;
  where: Subscriptions_Starred_Competition_Swimmers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_Starred_Competition_Swimmers_By_PkArgs = {
  _inc?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Set_Input>;
  pk_columns: Subscriptions_Starred_Competition_Swimmers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_Starred_Competition_Swimmers_ManyArgs = {
  updates: Array<Subscriptions_Starred_Competition_Swimmers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_Starred_Global_SwimmersArgs = {
  _inc?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Set_Input>;
  where: Subscriptions_Starred_Global_Swimmers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_Starred_Global_Swimmers_By_PkArgs = {
  _inc?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Inc_Input>;
  _set?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Set_Input>;
  pk_columns: Subscriptions_Starred_Global_Swimmers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_Starred_Global_Swimmers_ManyArgs = {
  updates: Array<Subscriptions_Starred_Global_Swimmers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_Subscriber_DeviceArgs = {
  _set?: InputMaybe<Subscriptions_Subscriber_Device_Set_Input>;
  where: Subscriptions_Subscriber_Device_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_Subscriber_Device_By_PkArgs = {
  _set?: InputMaybe<Subscriptions_Subscriber_Device_Set_Input>;
  pk_columns: Subscriptions_Subscriber_Device_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_Subscriber_Device_ManyArgs = {
  updates: Array<Subscriptions_Subscriber_Device_Updates>;
};


/** mutation root */
export type Mutation_RootVerify_Subscription_PurchaseArgs = {
  app_user_id: Scalars['String']['input'];
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "point_list" */
export type Point_List = {
  __typename?: 'point_list';
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['Int']['output'];
  list_type: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  oid: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  /** An array relationship */
  point_list_rows: Array<Point_List_Row>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  visible: Scalars['Boolean']['output'];
};


/** columns and relationships of "point_list" */
export type Point_ListPoint_List_RowsArgs = {
  distinct_on?: InputMaybe<Array<Point_List_Row_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Point_List_Row_Order_By>>;
  where?: InputMaybe<Point_List_Row_Bool_Exp>;
};

/** order by aggregate values of table "point_list" */
export type Point_List_Aggregate_Order_By = {
  avg?: InputMaybe<Point_List_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Point_List_Max_Order_By>;
  min?: InputMaybe<Point_List_Min_Order_By>;
  stddev?: InputMaybe<Point_List_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Point_List_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Point_List_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Point_List_Sum_Order_By>;
  var_pop?: InputMaybe<Point_List_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Point_List_Var_Samp_Order_By>;
  variance?: InputMaybe<Point_List_Variance_Order_By>;
};

/** order by avg() on columns of table "point_list" */
export type Point_List_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  list_type?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "point_list". All fields are combined with a logical 'AND'. */
export type Point_List_Bool_Exp = {
  _and?: InputMaybe<Array<Point_List_Bool_Exp>>;
  _not?: InputMaybe<Point_List_Bool_Exp>;
  _or?: InputMaybe<Array<Point_List_Bool_Exp>>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  list_type?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  oid?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  point_list_rows?: InputMaybe<Point_List_Row_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  visible?: InputMaybe<Boolean_Comparison_Exp>;
};

/** order by max() on columns of table "point_list" */
export type Point_List_Max_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  list_type?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "point_list" */
export type Point_List_Min_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  list_type?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "point_list". */
export type Point_List_Order_By = {
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  list_type?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  point_list_rows_aggregate?: InputMaybe<Point_List_Row_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  visible?: InputMaybe<Order_By>;
};

/** columns and relationships of "point_list_row" */
export type Point_List_Row = {
  __typename?: 'point_list_row';
  age?: Maybe<Scalars['Int']['output']>;
  born?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  club?: Maybe<Clubs>;
  club_name?: Maybe<Scalars['String']['output']>;
  club_nation_code?: Maybe<Scalars['String']['output']>;
  club_oid?: Maybe<Scalars['Int']['output']>;
  club_points?: Maybe<Scalars['numeric']['output']>;
  club_short_name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  /** An object relationship */
  competitor?: Maybe<Competitor>;
  competitor_nation_code?: Maybe<Scalars['String']['output']>;
  competitor_oid?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  fina_points?: Maybe<Scalars['Int']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  group_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  license?: Maybe<Scalars['String']['output']>;
  medal_bronze?: Maybe<Scalars['Int']['output']>;
  medal_gold?: Maybe<Scalars['Int']['output']>;
  medal_silver?: Maybe<Scalars['Int']['output']>;
  medal_total?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  pcoll_average_points?: Maybe<Scalars['numeric']['output']>;
  pcoll_total_points?: Maybe<Scalars['Int']['output']>;
  pcollind_bonus_points?: Maybe<Scalars['Int']['output']>;
  pcollind_earned_points?: Maybe<Scalars['Int']['output']>;
  pcollind_total_points?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  point_list?: Maybe<Point_List>;
  point_list_oid: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by aggregate values of table "point_list_row" */
export type Point_List_Row_Aggregate_Order_By = {
  avg?: InputMaybe<Point_List_Row_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Point_List_Row_Max_Order_By>;
  min?: InputMaybe<Point_List_Row_Min_Order_By>;
  stddev?: InputMaybe<Point_List_Row_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Point_List_Row_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Point_List_Row_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Point_List_Row_Sum_Order_By>;
  var_pop?: InputMaybe<Point_List_Row_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Point_List_Row_Var_Samp_Order_By>;
  variance?: InputMaybe<Point_List_Row_Variance_Order_By>;
};

/** order by avg() on columns of table "point_list_row" */
export type Point_List_Row_Avg_Order_By = {
  age?: InputMaybe<Order_By>;
  born?: InputMaybe<Order_By>;
  club_oid?: InputMaybe<Order_By>;
  club_points?: InputMaybe<Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  fina_points?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  medal_bronze?: InputMaybe<Order_By>;
  medal_gold?: InputMaybe<Order_By>;
  medal_silver?: InputMaybe<Order_By>;
  medal_total?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  pcoll_average_points?: InputMaybe<Order_By>;
  pcoll_total_points?: InputMaybe<Order_By>;
  pcollind_bonus_points?: InputMaybe<Order_By>;
  pcollind_earned_points?: InputMaybe<Order_By>;
  pcollind_total_points?: InputMaybe<Order_By>;
  point_list_oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "point_list_row". All fields are combined with a logical 'AND'. */
export type Point_List_Row_Bool_Exp = {
  _and?: InputMaybe<Array<Point_List_Row_Bool_Exp>>;
  _not?: InputMaybe<Point_List_Row_Bool_Exp>;
  _or?: InputMaybe<Array<Point_List_Row_Bool_Exp>>;
  age?: InputMaybe<Int_Comparison_Exp>;
  born?: InputMaybe<Int_Comparison_Exp>;
  club?: InputMaybe<Clubs_Bool_Exp>;
  club_name?: InputMaybe<String_Comparison_Exp>;
  club_nation_code?: InputMaybe<String_Comparison_Exp>;
  club_oid?: InputMaybe<Int_Comparison_Exp>;
  club_points?: InputMaybe<Numeric_Comparison_Exp>;
  club_short_name?: InputMaybe<String_Comparison_Exp>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  competitor?: InputMaybe<Competitor_Bool_Exp>;
  competitor_nation_code?: InputMaybe<String_Comparison_Exp>;
  competitor_oid?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fina_points?: InputMaybe<Int_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  group_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  license?: InputMaybe<String_Comparison_Exp>;
  medal_bronze?: InputMaybe<Int_Comparison_Exp>;
  medal_gold?: InputMaybe<Int_Comparison_Exp>;
  medal_silver?: InputMaybe<Int_Comparison_Exp>;
  medal_total?: InputMaybe<Int_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  pcoll_average_points?: InputMaybe<Numeric_Comparison_Exp>;
  pcoll_total_points?: InputMaybe<Int_Comparison_Exp>;
  pcollind_bonus_points?: InputMaybe<Int_Comparison_Exp>;
  pcollind_earned_points?: InputMaybe<Int_Comparison_Exp>;
  pcollind_total_points?: InputMaybe<Int_Comparison_Exp>;
  point_list?: InputMaybe<Point_List_Bool_Exp>;
  point_list_oid?: InputMaybe<Int_Comparison_Exp>;
  rank?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "point_list_row" */
export type Point_List_Row_Max_Order_By = {
  age?: InputMaybe<Order_By>;
  born?: InputMaybe<Order_By>;
  club_name?: InputMaybe<Order_By>;
  club_nation_code?: InputMaybe<Order_By>;
  club_oid?: InputMaybe<Order_By>;
  club_points?: InputMaybe<Order_By>;
  club_short_name?: InputMaybe<Order_By>;
  competition_id?: InputMaybe<Order_By>;
  competitor_nation_code?: InputMaybe<Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fina_points?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  group_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  license?: InputMaybe<Order_By>;
  medal_bronze?: InputMaybe<Order_By>;
  medal_gold?: InputMaybe<Order_By>;
  medal_silver?: InputMaybe<Order_By>;
  medal_total?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  pcoll_average_points?: InputMaybe<Order_By>;
  pcoll_total_points?: InputMaybe<Order_By>;
  pcollind_bonus_points?: InputMaybe<Order_By>;
  pcollind_earned_points?: InputMaybe<Order_By>;
  pcollind_total_points?: InputMaybe<Order_By>;
  point_list_oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "point_list_row" */
export type Point_List_Row_Min_Order_By = {
  age?: InputMaybe<Order_By>;
  born?: InputMaybe<Order_By>;
  club_name?: InputMaybe<Order_By>;
  club_nation_code?: InputMaybe<Order_By>;
  club_oid?: InputMaybe<Order_By>;
  club_points?: InputMaybe<Order_By>;
  club_short_name?: InputMaybe<Order_By>;
  competition_id?: InputMaybe<Order_By>;
  competitor_nation_code?: InputMaybe<Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fina_points?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  group_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  license?: InputMaybe<Order_By>;
  medal_bronze?: InputMaybe<Order_By>;
  medal_gold?: InputMaybe<Order_By>;
  medal_silver?: InputMaybe<Order_By>;
  medal_total?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  pcoll_average_points?: InputMaybe<Order_By>;
  pcoll_total_points?: InputMaybe<Order_By>;
  pcollind_bonus_points?: InputMaybe<Order_By>;
  pcollind_earned_points?: InputMaybe<Order_By>;
  pcollind_total_points?: InputMaybe<Order_By>;
  point_list_oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "point_list_row". */
export type Point_List_Row_Order_By = {
  age?: InputMaybe<Order_By>;
  born?: InputMaybe<Order_By>;
  club?: InputMaybe<Clubs_Order_By>;
  club_name?: InputMaybe<Order_By>;
  club_nation_code?: InputMaybe<Order_By>;
  club_oid?: InputMaybe<Order_By>;
  club_points?: InputMaybe<Order_By>;
  club_short_name?: InputMaybe<Order_By>;
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  competitor?: InputMaybe<Competitor_Order_By>;
  competitor_nation_code?: InputMaybe<Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fina_points?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  group_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  license?: InputMaybe<Order_By>;
  medal_bronze?: InputMaybe<Order_By>;
  medal_gold?: InputMaybe<Order_By>;
  medal_silver?: InputMaybe<Order_By>;
  medal_total?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  pcoll_average_points?: InputMaybe<Order_By>;
  pcoll_total_points?: InputMaybe<Order_By>;
  pcollind_bonus_points?: InputMaybe<Order_By>;
  pcollind_earned_points?: InputMaybe<Order_By>;
  pcollind_total_points?: InputMaybe<Order_By>;
  point_list?: InputMaybe<Point_List_Order_By>;
  point_list_oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "point_list_row" */
export enum Point_List_Row_Select_Column {
  /** column name */
  Age = 'age',
  /** column name */
  Born = 'born',
  /** column name */
  ClubName = 'club_name',
  /** column name */
  ClubNationCode = 'club_nation_code',
  /** column name */
  ClubOid = 'club_oid',
  /** column name */
  ClubPoints = 'club_points',
  /** column name */
  ClubShortName = 'club_short_name',
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CompetitorNationCode = 'competitor_nation_code',
  /** column name */
  CompetitorOid = 'competitor_oid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FinaPoints = 'fina_points',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  GroupName = 'group_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  License = 'license',
  /** column name */
  MedalBronze = 'medal_bronze',
  /** column name */
  MedalGold = 'medal_gold',
  /** column name */
  MedalSilver = 'medal_silver',
  /** column name */
  MedalTotal = 'medal_total',
  /** column name */
  Note = 'note',
  /** column name */
  Order = 'order',
  /** column name */
  PcollAveragePoints = 'pcoll_average_points',
  /** column name */
  PcollTotalPoints = 'pcoll_total_points',
  /** column name */
  PcollindBonusPoints = 'pcollind_bonus_points',
  /** column name */
  PcollindEarnedPoints = 'pcollind_earned_points',
  /** column name */
  PcollindTotalPoints = 'pcollind_total_points',
  /** column name */
  PointListOid = 'point_list_oid',
  /** column name */
  Rank = 'rank',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "point_list_row" */
export type Point_List_Row_Stddev_Order_By = {
  age?: InputMaybe<Order_By>;
  born?: InputMaybe<Order_By>;
  club_oid?: InputMaybe<Order_By>;
  club_points?: InputMaybe<Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  fina_points?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  medal_bronze?: InputMaybe<Order_By>;
  medal_gold?: InputMaybe<Order_By>;
  medal_silver?: InputMaybe<Order_By>;
  medal_total?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  pcoll_average_points?: InputMaybe<Order_By>;
  pcoll_total_points?: InputMaybe<Order_By>;
  pcollind_bonus_points?: InputMaybe<Order_By>;
  pcollind_earned_points?: InputMaybe<Order_By>;
  pcollind_total_points?: InputMaybe<Order_By>;
  point_list_oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "point_list_row" */
export type Point_List_Row_Stddev_Pop_Order_By = {
  age?: InputMaybe<Order_By>;
  born?: InputMaybe<Order_By>;
  club_oid?: InputMaybe<Order_By>;
  club_points?: InputMaybe<Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  fina_points?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  medal_bronze?: InputMaybe<Order_By>;
  medal_gold?: InputMaybe<Order_By>;
  medal_silver?: InputMaybe<Order_By>;
  medal_total?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  pcoll_average_points?: InputMaybe<Order_By>;
  pcoll_total_points?: InputMaybe<Order_By>;
  pcollind_bonus_points?: InputMaybe<Order_By>;
  pcollind_earned_points?: InputMaybe<Order_By>;
  pcollind_total_points?: InputMaybe<Order_By>;
  point_list_oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "point_list_row" */
export type Point_List_Row_Stddev_Samp_Order_By = {
  age?: InputMaybe<Order_By>;
  born?: InputMaybe<Order_By>;
  club_oid?: InputMaybe<Order_By>;
  club_points?: InputMaybe<Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  fina_points?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  medal_bronze?: InputMaybe<Order_By>;
  medal_gold?: InputMaybe<Order_By>;
  medal_silver?: InputMaybe<Order_By>;
  medal_total?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  pcoll_average_points?: InputMaybe<Order_By>;
  pcoll_total_points?: InputMaybe<Order_By>;
  pcollind_bonus_points?: InputMaybe<Order_By>;
  pcollind_earned_points?: InputMaybe<Order_By>;
  pcollind_total_points?: InputMaybe<Order_By>;
  point_list_oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "point_list_row" */
export type Point_List_Row_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Point_List_Row_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Point_List_Row_Stream_Cursor_Value_Input = {
  age?: InputMaybe<Scalars['Int']['input']>;
  born?: InputMaybe<Scalars['Int']['input']>;
  club_name?: InputMaybe<Scalars['String']['input']>;
  club_nation_code?: InputMaybe<Scalars['String']['input']>;
  club_oid?: InputMaybe<Scalars['Int']['input']>;
  club_points?: InputMaybe<Scalars['numeric']['input']>;
  club_short_name?: InputMaybe<Scalars['String']['input']>;
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  competitor_nation_code?: InputMaybe<Scalars['String']['input']>;
  competitor_oid?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  fina_points?: InputMaybe<Scalars['Int']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  group_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  medal_bronze?: InputMaybe<Scalars['Int']['input']>;
  medal_gold?: InputMaybe<Scalars['Int']['input']>;
  medal_silver?: InputMaybe<Scalars['Int']['input']>;
  medal_total?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  pcoll_average_points?: InputMaybe<Scalars['numeric']['input']>;
  pcoll_total_points?: InputMaybe<Scalars['Int']['input']>;
  pcollind_bonus_points?: InputMaybe<Scalars['Int']['input']>;
  pcollind_earned_points?: InputMaybe<Scalars['Int']['input']>;
  pcollind_total_points?: InputMaybe<Scalars['Int']['input']>;
  point_list_oid?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "point_list_row" */
export type Point_List_Row_Sum_Order_By = {
  age?: InputMaybe<Order_By>;
  born?: InputMaybe<Order_By>;
  club_oid?: InputMaybe<Order_By>;
  club_points?: InputMaybe<Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  fina_points?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  medal_bronze?: InputMaybe<Order_By>;
  medal_gold?: InputMaybe<Order_By>;
  medal_silver?: InputMaybe<Order_By>;
  medal_total?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  pcoll_average_points?: InputMaybe<Order_By>;
  pcoll_total_points?: InputMaybe<Order_By>;
  pcollind_bonus_points?: InputMaybe<Order_By>;
  pcollind_earned_points?: InputMaybe<Order_By>;
  pcollind_total_points?: InputMaybe<Order_By>;
  point_list_oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "point_list_row" */
export type Point_List_Row_Var_Pop_Order_By = {
  age?: InputMaybe<Order_By>;
  born?: InputMaybe<Order_By>;
  club_oid?: InputMaybe<Order_By>;
  club_points?: InputMaybe<Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  fina_points?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  medal_bronze?: InputMaybe<Order_By>;
  medal_gold?: InputMaybe<Order_By>;
  medal_silver?: InputMaybe<Order_By>;
  medal_total?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  pcoll_average_points?: InputMaybe<Order_By>;
  pcoll_total_points?: InputMaybe<Order_By>;
  pcollind_bonus_points?: InputMaybe<Order_By>;
  pcollind_earned_points?: InputMaybe<Order_By>;
  pcollind_total_points?: InputMaybe<Order_By>;
  point_list_oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "point_list_row" */
export type Point_List_Row_Var_Samp_Order_By = {
  age?: InputMaybe<Order_By>;
  born?: InputMaybe<Order_By>;
  club_oid?: InputMaybe<Order_By>;
  club_points?: InputMaybe<Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  fina_points?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  medal_bronze?: InputMaybe<Order_By>;
  medal_gold?: InputMaybe<Order_By>;
  medal_silver?: InputMaybe<Order_By>;
  medal_total?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  pcoll_average_points?: InputMaybe<Order_By>;
  pcoll_total_points?: InputMaybe<Order_By>;
  pcollind_bonus_points?: InputMaybe<Order_By>;
  pcollind_earned_points?: InputMaybe<Order_By>;
  pcollind_total_points?: InputMaybe<Order_By>;
  point_list_oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "point_list_row" */
export type Point_List_Row_Variance_Order_By = {
  age?: InputMaybe<Order_By>;
  born?: InputMaybe<Order_By>;
  club_oid?: InputMaybe<Order_By>;
  club_points?: InputMaybe<Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  fina_points?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  medal_bronze?: InputMaybe<Order_By>;
  medal_gold?: InputMaybe<Order_By>;
  medal_silver?: InputMaybe<Order_By>;
  medal_total?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  pcoll_average_points?: InputMaybe<Order_By>;
  pcoll_total_points?: InputMaybe<Order_By>;
  pcollind_bonus_points?: InputMaybe<Order_By>;
  pcollind_earned_points?: InputMaybe<Order_By>;
  pcollind_total_points?: InputMaybe<Order_By>;
  point_list_oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** select columns of table "point_list" */
export enum Point_List_Select_Column {
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ListType = 'list_type',
  /** column name */
  Name = 'name',
  /** column name */
  Oid = 'oid',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Visible = 'visible'
}

/** order by stddev() on columns of table "point_list" */
export type Point_List_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  list_type?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "point_list" */
export type Point_List_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  list_type?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "point_list" */
export type Point_List_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  list_type?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "point_list" */
export type Point_List_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Point_List_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Point_List_Stream_Cursor_Value_Input = {
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  list_type?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oid?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by sum() on columns of table "point_list" */
export type Point_List_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  list_type?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "point_list" */
export type Point_List_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  list_type?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "point_list" */
export type Point_List_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  list_type?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "point_list" */
export type Point_List_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  list_type?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "agegroup" */
  agegroup: Array<Agegroup>;
  /** fetch data from the table: "agegroup" using primary key columns */
  agegroup_by_pk?: Maybe<Agegroup>;
  /** An array relationship */
  clubs: Array<Clubs>;
  /** fetch data from the table: "clubs" using primary key columns */
  clubs_by_pk?: Maybe<Clubs>;
  /** An array relationship */
  combined_competitions: Array<Combined_Competitions>;
  /** fetch data from the table: "combined_competitions" using primary key columns */
  combined_competitions_by_pk?: Maybe<Combined_Competitions>;
  /** fetch data from the table: "competition_session" */
  competition_session: Array<Competition_Session>;
  /** fetch data from the table: "competition_session" using primary key columns */
  competition_session_by_pk?: Maybe<Competition_Session>;
  /** fetch data from the table: "competitions" */
  competitions: Array<Competitions>;
  /** fetch data from the table: "competitions" using primary key columns */
  competitions_by_pk?: Maybe<Competitions>;
  /** fetch data from the table: "competitor" */
  competitor: Array<Competitor>;
  /** fetch aggregated fields from the table: "competitor" */
  competitor_aggregate: Competitor_Aggregate;
  /** fetch data from the table: "competitor" using primary key columns */
  competitor_by_pk?: Maybe<Competitor>;
  /** fetch data from the table: "current_heat" */
  current_heat: Array<Current_Heat>;
  /** fetch data from the table: "current_heat" using primary key columns */
  current_heat_by_pk?: Maybe<Current_Heat>;
  /** fetch data from the table: "entry" */
  entry: Array<Entry>;
  /** fetch data from the table: "entry" using primary key columns */
  entry_by_pk?: Maybe<Entry>;
  /** fetch data from the table: "entry_list_type" */
  entry_list_type: Array<Entry_List_Type>;
  /** fetch data from the table: "entry_list_type" using primary key columns */
  entry_list_type_by_pk?: Maybe<Entry_List_Type>;
  /** fetch data from the table: "entry_rank" */
  entry_rank: Array<Entry_Rank>;
  /** fetch data from the table: "entry_rank" using primary key columns */
  entry_rank_by_pk?: Maybe<Entry_Rank>;
  /** An array relationship */
  event_records: Array<Event_Records>;
  /** fetch data from the table: "event_records" using primary key columns */
  event_records_by_pk?: Maybe<Event_Records>;
  /** An array relationship */
  events: Array<Events>;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: Maybe<Events>;
  /** fetch data from the table: "file_archive" */
  file_archive: Array<File_Archive>;
  /** fetch data from the table: "file_archive" using primary key columns */
  file_archive_by_pk?: Maybe<File_Archive>;
  /** fetch data from the table: "get_current_time" */
  get_current_time: Array<Get_Current_Time>;
  get_unsynced_changes_count?: Maybe<CountOutput>;
  /** An array relationship */
  heat: Array<Heat>;
  /** fetch data from the table: "heat" using primary key columns */
  heat_by_pk?: Maybe<Heat>;
  /** fetch data from the table: "lane" */
  lane: Array<Lane>;
  /** fetch data from the table: "lane" using primary key columns */
  lane_by_pk?: Maybe<Lane>;
  /** fetch data from the table: "lookup.event_type" */
  lookup_event_type: Array<Lookup_Event_Type>;
  /** fetch data from the table: "lookup.event_type" using primary key columns */
  lookup_event_type_by_pk?: Maybe<Lookup_Event_Type>;
  /** fetch data from the table: "point_list" */
  point_list: Array<Point_List>;
  /** fetch data from the table: "point_list" using primary key columns */
  point_list_by_pk?: Maybe<Point_List>;
  /** fetch data from the table: "point_list_row" */
  point_list_row: Array<Point_List_Row>;
  /** fetch data from the table: "point_list_row" using primary key columns */
  point_list_row_by_pk?: Maybe<Point_List_Row>;
  /** fetch data from the table: "rank" */
  rank: Array<Rank>;
  /** fetch data from the table: "rank" using primary key columns */
  rank_by_pk?: Maybe<Rank>;
  /** fetch data from the table: "relay_competitor" */
  relay_competitor: Array<Relay_Competitor>;
  /** fetch data from the table: "relay_competitor" using primary key columns */
  relay_competitor_by_pk?: Maybe<Relay_Competitor>;
  /** fetch data from the table: "round" */
  round: Array<Round>;
  /** fetch data from the table: "round" using primary key columns */
  round_by_pk?: Maybe<Round>;
  /** fetch data from the table: "sponsor" */
  sponsor: Array<Sponsor>;
  /** fetch data from the table: "sponsor" using primary key columns */
  sponsor_by_pk?: Maybe<Sponsor>;
  /** An array relationship */
  sub_results: Array<Sub_Results>;
  /** fetch data from the table: "sub_results" using primary key columns */
  sub_results_by_pk?: Maybe<Sub_Results>;
  /** fetch data from the table: "subscriptions.starred_competition" */
  subscriptions_starred_competition: Array<Subscriptions_Starred_Competition>;
  /** fetch data from the table: "subscriptions.starred_competition" using primary key columns */
  subscriptions_starred_competition_by_pk?: Maybe<Subscriptions_Starred_Competition>;
  /** fetch data from the table: "subscriptions.starred_competition_swimmers" */
  subscriptions_starred_competition_swimmers: Array<Subscriptions_Starred_Competition_Swimmers>;
  /** fetch data from the table: "subscriptions.starred_competition_swimmers" using primary key columns */
  subscriptions_starred_competition_swimmers_by_pk?: Maybe<Subscriptions_Starred_Competition_Swimmers>;
  /** fetch data from the table: "subscriptions.starred_global_swimmers" */
  subscriptions_starred_global_swimmers: Array<Subscriptions_Starred_Global_Swimmers>;
  /** fetch data from the table: "subscriptions.starred_global_swimmers" using primary key columns */
  subscriptions_starred_global_swimmers_by_pk?: Maybe<Subscriptions_Starred_Global_Swimmers>;
  /** fetch data from the table: "subscriptions.subscriber" */
  subscriptions_subscriber: Array<Subscriptions_Subscriber>;
  /** fetch data from the table: "subscriptions.subscriber" using primary key columns */
  subscriptions_subscriber_by_pk?: Maybe<Subscriptions_Subscriber>;
  /** fetch data from the table: "subscriptions.subscriber_device" */
  subscriptions_subscriber_device: Array<Subscriptions_Subscriber_Device>;
  /** fetch data from the table: "subscriptions.subscriber_device" using primary key columns */
  subscriptions_subscriber_device_by_pk?: Maybe<Subscriptions_Subscriber_Device>;
  /** fetch data from the table: "summary_type" */
  summary_type: Array<Summary_Type>;
  /** fetch data from the table: "summary_type" using primary key columns */
  summary_type_by_pk?: Maybe<Summary_Type>;
  /** fetch data from the table: "time_program_entry" */
  time_program_entry: Array<Time_Program_Entry>;
  /** fetch data from the table: "time_program_entry" using primary key columns */
  time_program_entry_by_pk?: Maybe<Time_Program_Entry>;
};


export type Query_RootAgegroupArgs = {
  distinct_on?: InputMaybe<Array<Agegroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agegroup_Order_By>>;
  where?: InputMaybe<Agegroup_Bool_Exp>;
};


export type Query_RootAgegroup_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootClubsArgs = {
  distinct_on?: InputMaybe<Array<Clubs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clubs_Order_By>>;
  where?: InputMaybe<Clubs_Bool_Exp>;
};


export type Query_RootClubs_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootCombined_CompetitionsArgs = {
  distinct_on?: InputMaybe<Array<Combined_Competitions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Combined_Competitions_Order_By>>;
  where?: InputMaybe<Combined_Competitions_Bool_Exp>;
};


export type Query_RootCombined_Competitions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootCompetition_SessionArgs = {
  distinct_on?: InputMaybe<Array<Competition_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Competition_Session_Order_By>>;
  where?: InputMaybe<Competition_Session_Bool_Exp>;
};


export type Query_RootCompetition_Session_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootCompetitionsArgs = {
  distinct_on?: InputMaybe<Array<Competitions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Competitions_Order_By>>;
  where?: InputMaybe<Competitions_Bool_Exp>;
};


export type Query_RootCompetitions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCompetitorArgs = {
  distinct_on?: InputMaybe<Array<Competitor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Competitor_Order_By>>;
  where?: InputMaybe<Competitor_Bool_Exp>;
};


export type Query_RootCompetitor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Competitor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Competitor_Order_By>>;
  where?: InputMaybe<Competitor_Bool_Exp>;
};


export type Query_RootCompetitor_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootCurrent_HeatArgs = {
  distinct_on?: InputMaybe<Array<Current_Heat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Current_Heat_Order_By>>;
  where?: InputMaybe<Current_Heat_Bool_Exp>;
};


export type Query_RootCurrent_Heat_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootEntryArgs = {
  distinct_on?: InputMaybe<Array<Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entry_Order_By>>;
  where?: InputMaybe<Entry_Bool_Exp>;
};


export type Query_RootEntry_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootEntry_List_TypeArgs = {
  distinct_on?: InputMaybe<Array<Entry_List_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entry_List_Type_Order_By>>;
  where?: InputMaybe<Entry_List_Type_Bool_Exp>;
};


export type Query_RootEntry_List_Type_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootEntry_RankArgs = {
  distinct_on?: InputMaybe<Array<Entry_Rank_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entry_Rank_Order_By>>;
  where?: InputMaybe<Entry_Rank_Bool_Exp>;
};


export type Query_RootEntry_Rank_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootEvent_RecordsArgs = {
  distinct_on?: InputMaybe<Array<Event_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Records_Order_By>>;
  where?: InputMaybe<Event_Records_Bool_Exp>;
};


export type Query_RootEvent_Records_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Query_RootEvents_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootFile_ArchiveArgs = {
  distinct_on?: InputMaybe<Array<File_Archive_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Archive_Order_By>>;
  where?: InputMaybe<File_Archive_Bool_Exp>;
};


export type Query_RootFile_Archive_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootGet_Current_TimeArgs = {
  distinct_on?: InputMaybe<Array<Get_Current_Time_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Get_Current_Time_Order_By>>;
  where?: InputMaybe<Get_Current_Time_Bool_Exp>;
};


export type Query_RootGet_Unsynced_Changes_CountArgs = {
  competition_id: Scalars['uuid']['input'];
};


export type Query_RootHeatArgs = {
  distinct_on?: InputMaybe<Array<Heat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Heat_Order_By>>;
  where?: InputMaybe<Heat_Bool_Exp>;
};


export type Query_RootHeat_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootLaneArgs = {
  distinct_on?: InputMaybe<Array<Lane_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lane_Order_By>>;
  where?: InputMaybe<Lane_Bool_Exp>;
};


export type Query_RootLane_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootLookup_Event_TypeArgs = {
  distinct_on?: InputMaybe<Array<Lookup_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookup_Event_Type_Order_By>>;
  where?: InputMaybe<Lookup_Event_Type_Bool_Exp>;
};


export type Query_RootLookup_Event_Type_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootPoint_ListArgs = {
  distinct_on?: InputMaybe<Array<Point_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Point_List_Order_By>>;
  where?: InputMaybe<Point_List_Bool_Exp>;
};


export type Query_RootPoint_List_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootPoint_List_RowArgs = {
  distinct_on?: InputMaybe<Array<Point_List_Row_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Point_List_Row_Order_By>>;
  where?: InputMaybe<Point_List_Row_Bool_Exp>;
};


export type Query_RootPoint_List_Row_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootRankArgs = {
  distinct_on?: InputMaybe<Array<Rank_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rank_Order_By>>;
  where?: InputMaybe<Rank_Bool_Exp>;
};


export type Query_RootRank_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootRelay_CompetitorArgs = {
  distinct_on?: InputMaybe<Array<Relay_Competitor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relay_Competitor_Order_By>>;
  where?: InputMaybe<Relay_Competitor_Bool_Exp>;
};


export type Query_RootRelay_Competitor_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootRoundArgs = {
  distinct_on?: InputMaybe<Array<Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Round_Order_By>>;
  where?: InputMaybe<Round_Bool_Exp>;
};


export type Query_RootRound_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootSponsorArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sponsor_Order_By>>;
  where?: InputMaybe<Sponsor_Bool_Exp>;
};


export type Query_RootSponsor_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootSub_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Sub_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sub_Results_Order_By>>;
  where?: InputMaybe<Sub_Results_Bool_Exp>;
};


export type Query_RootSub_Results_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootSubscriptions_Starred_CompetitionArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Starred_Competition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Starred_Competition_Order_By>>;
  where?: InputMaybe<Subscriptions_Starred_Competition_Bool_Exp>;
};


export type Query_RootSubscriptions_Starred_Competition_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootSubscriptions_Starred_Competition_SwimmersArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Starred_Competition_Swimmers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Starred_Competition_Swimmers_Order_By>>;
  where?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Bool_Exp>;
};


export type Query_RootSubscriptions_Starred_Competition_Swimmers_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootSubscriptions_Starred_Global_SwimmersArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Starred_Global_Swimmers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Starred_Global_Swimmers_Order_By>>;
  where?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Bool_Exp>;
};


export type Query_RootSubscriptions_Starred_Global_Swimmers_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootSubscriptions_SubscriberArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriber_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriber_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriber_Bool_Exp>;
};


export type Query_RootSubscriptions_Subscriber_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSubscriptions_Subscriber_DeviceArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriber_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriber_Device_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriber_Device_Bool_Exp>;
};


export type Query_RootSubscriptions_Subscriber_Device_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootSummary_TypeArgs = {
  distinct_on?: InputMaybe<Array<Summary_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Summary_Type_Order_By>>;
  where?: InputMaybe<Summary_Type_Bool_Exp>;
};


export type Query_RootSummary_Type_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootTime_Program_EntryArgs = {
  distinct_on?: InputMaybe<Array<Time_Program_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Time_Program_Entry_Order_By>>;
  where?: InputMaybe<Time_Program_Entry_Bool_Exp>;
};


export type Query_RootTime_Program_Entry_By_PkArgs = {
  id: Scalars['Int']['input'];
};

/** columns and relationships of "rank" */
export type Rank = {
  __typename?: 'rank';
  /** An object relationship */
  agegroup?: Maybe<Agegroup>;
  agegroup_oid?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  lane?: Maybe<Lane>;
  lane_oid: Scalars['Int']['output'];
  oid: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
  /** An object relationship */
  summary_type?: Maybe<Summary_Type>;
  summary_type_oid?: Maybe<Scalars['Int']['output']>;
  type: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "rank" */
export type Rank_Aggregate_Order_By = {
  avg?: InputMaybe<Rank_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rank_Max_Order_By>;
  min?: InputMaybe<Rank_Min_Order_By>;
  stddev?: InputMaybe<Rank_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rank_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rank_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rank_Sum_Order_By>;
  var_pop?: InputMaybe<Rank_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rank_Var_Samp_Order_By>;
  variance?: InputMaybe<Rank_Variance_Order_By>;
};

/** order by avg() on columns of table "rank" */
export type Rank_Avg_Order_By = {
  agegroup_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  summary_type_oid?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rank". All fields are combined with a logical 'AND'. */
export type Rank_Bool_Exp = {
  _and?: InputMaybe<Array<Rank_Bool_Exp>>;
  _not?: InputMaybe<Rank_Bool_Exp>;
  _or?: InputMaybe<Array<Rank_Bool_Exp>>;
  agegroup?: InputMaybe<Agegroup_Bool_Exp>;
  agegroup_oid?: InputMaybe<Int_Comparison_Exp>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lane?: InputMaybe<Lane_Bool_Exp>;
  lane_oid?: InputMaybe<Int_Comparison_Exp>;
  oid?: InputMaybe<Int_Comparison_Exp>;
  rank?: InputMaybe<Int_Comparison_Exp>;
  summary_type?: InputMaybe<Summary_Type_Bool_Exp>;
  summary_type_oid?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "rank" */
export type Rank_Max_Order_By = {
  agegroup_oid?: InputMaybe<Order_By>;
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  summary_type_oid?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "rank" */
export type Rank_Min_Order_By = {
  agegroup_oid?: InputMaybe<Order_By>;
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  summary_type_oid?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "rank". */
export type Rank_Order_By = {
  agegroup?: InputMaybe<Agegroup_Order_By>;
  agegroup_oid?: InputMaybe<Order_By>;
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane?: InputMaybe<Lane_Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  summary_type?: InputMaybe<Summary_Type_Order_By>;
  summary_type_oid?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "rank" */
export enum Rank_Select_Column {
  /** column name */
  AgegroupOid = 'agegroup_oid',
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LaneOid = 'lane_oid',
  /** column name */
  Oid = 'oid',
  /** column name */
  Rank = 'rank',
  /** column name */
  SummaryTypeOid = 'summary_type_oid',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "rank" */
export type Rank_Stddev_Order_By = {
  agegroup_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  summary_type_oid?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "rank" */
export type Rank_Stddev_Pop_Order_By = {
  agegroup_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  summary_type_oid?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "rank" */
export type Rank_Stddev_Samp_Order_By = {
  agegroup_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  summary_type_oid?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "rank" */
export type Rank_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rank_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rank_Stream_Cursor_Value_Input = {
  agegroup_oid?: InputMaybe<Scalars['Int']['input']>;
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lane_oid?: InputMaybe<Scalars['Int']['input']>;
  oid?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  summary_type_oid?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "rank" */
export type Rank_Sum_Order_By = {
  agegroup_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  summary_type_oid?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "rank" */
export type Rank_Var_Pop_Order_By = {
  agegroup_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  summary_type_oid?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "rank" */
export type Rank_Var_Samp_Order_By = {
  agegroup_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  summary_type_oid?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "rank" */
export type Rank_Variance_Order_By = {
  agegroup_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  summary_type_oid?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** columns and relationships of "relay_competitor" */
export type Relay_Competitor = {
  __typename?: 'relay_competitor';
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  /** An object relationship */
  competitor?: Maybe<Competitor>;
  competitor_oid?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  entry?: Maybe<Entry>;
  entry_oid?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  lane?: Maybe<Lane>;
  lane_oid?: Maybe<Scalars['Int']['output']>;
  oid: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "relay_competitor" */
export type Relay_Competitor_Aggregate_Order_By = {
  avg?: InputMaybe<Relay_Competitor_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Relay_Competitor_Max_Order_By>;
  min?: InputMaybe<Relay_Competitor_Min_Order_By>;
  stddev?: InputMaybe<Relay_Competitor_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Relay_Competitor_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Relay_Competitor_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Relay_Competitor_Sum_Order_By>;
  var_pop?: InputMaybe<Relay_Competitor_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Relay_Competitor_Var_Samp_Order_By>;
  variance?: InputMaybe<Relay_Competitor_Variance_Order_By>;
};

/** order by avg() on columns of table "relay_competitor" */
export type Relay_Competitor_Avg_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  entry_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "relay_competitor". All fields are combined with a logical 'AND'. */
export type Relay_Competitor_Bool_Exp = {
  _and?: InputMaybe<Array<Relay_Competitor_Bool_Exp>>;
  _not?: InputMaybe<Relay_Competitor_Bool_Exp>;
  _or?: InputMaybe<Array<Relay_Competitor_Bool_Exp>>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  competitor?: InputMaybe<Competitor_Bool_Exp>;
  competitor_oid?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  entry?: InputMaybe<Entry_Bool_Exp>;
  entry_oid?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lane?: InputMaybe<Lane_Bool_Exp>;
  lane_oid?: InputMaybe<Int_Comparison_Exp>;
  oid?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "relay_competitor" */
export type Relay_Competitor_Max_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entry_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "relay_competitor" */
export type Relay_Competitor_Min_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entry_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "relay_competitor". */
export type Relay_Competitor_Order_By = {
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  competitor?: InputMaybe<Competitor_Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  entry?: InputMaybe<Entry_Order_By>;
  entry_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane?: InputMaybe<Lane_Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "relay_competitor" */
export enum Relay_Competitor_Select_Column {
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CompetitorOid = 'competitor_oid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EntryOid = 'entry_oid',
  /** column name */
  Id = 'id',
  /** column name */
  LaneOid = 'lane_oid',
  /** column name */
  Oid = 'oid',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "relay_competitor" */
export type Relay_Competitor_Stddev_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  entry_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "relay_competitor" */
export type Relay_Competitor_Stddev_Pop_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  entry_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "relay_competitor" */
export type Relay_Competitor_Stddev_Samp_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  entry_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "relay_competitor" */
export type Relay_Competitor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Relay_Competitor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Relay_Competitor_Stream_Cursor_Value_Input = {
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  competitor_oid?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entry_oid?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lane_oid?: InputMaybe<Scalars['Int']['input']>;
  oid?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "relay_competitor" */
export type Relay_Competitor_Sum_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  entry_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "relay_competitor" */
export type Relay_Competitor_Var_Pop_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  entry_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "relay_competitor" */
export type Relay_Competitor_Var_Samp_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  entry_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "relay_competitor" */
export type Relay_Competitor_Variance_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  entry_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "round" */
export type Round = {
  __typename?: 'round';
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  event?: Maybe<Events>;
  event_oid: Scalars['Int']['output'];
  /** An array relationship */
  file_archives: Array<File_Archive>;
  /** An array relationship */
  heats: Array<Heat>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  official_at?: Maybe<Scalars['timestamptz']['output']>;
  oid: Scalars['Int']['output'];
  round_type: Scalars['Int']['output'];
  sort_order: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  /** An array relationship */
  summary_types: Array<Summary_Type>;
  /** An array relationship */
  time_program_entries: Array<Time_Program_Entry>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "round" */
export type RoundFile_ArchivesArgs = {
  distinct_on?: InputMaybe<Array<File_Archive_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Archive_Order_By>>;
  where?: InputMaybe<File_Archive_Bool_Exp>;
};


/** columns and relationships of "round" */
export type RoundHeatsArgs = {
  distinct_on?: InputMaybe<Array<Heat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Heat_Order_By>>;
  where?: InputMaybe<Heat_Bool_Exp>;
};


/** columns and relationships of "round" */
export type RoundSummary_TypesArgs = {
  distinct_on?: InputMaybe<Array<Summary_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Summary_Type_Order_By>>;
  where?: InputMaybe<Summary_Type_Bool_Exp>;
};


/** columns and relationships of "round" */
export type RoundTime_Program_EntriesArgs = {
  distinct_on?: InputMaybe<Array<Time_Program_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Time_Program_Entry_Order_By>>;
  where?: InputMaybe<Time_Program_Entry_Bool_Exp>;
};

/** order by aggregate values of table "round" */
export type Round_Aggregate_Order_By = {
  avg?: InputMaybe<Round_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Round_Max_Order_By>;
  min?: InputMaybe<Round_Min_Order_By>;
  stddev?: InputMaybe<Round_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Round_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Round_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Round_Sum_Order_By>;
  var_pop?: InputMaybe<Round_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Round_Var_Samp_Order_By>;
  variance?: InputMaybe<Round_Variance_Order_By>;
};

/** order by avg() on columns of table "round" */
export type Round_Avg_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  round_type?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "round". All fields are combined with a logical 'AND'. */
export type Round_Bool_Exp = {
  _and?: InputMaybe<Array<Round_Bool_Exp>>;
  _not?: InputMaybe<Round_Bool_Exp>;
  _or?: InputMaybe<Array<Round_Bool_Exp>>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Events_Bool_Exp>;
  event_oid?: InputMaybe<Int_Comparison_Exp>;
  file_archives?: InputMaybe<File_Archive_Bool_Exp>;
  heats?: InputMaybe<Heat_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  official_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  oid?: InputMaybe<Int_Comparison_Exp>;
  round_type?: InputMaybe<Int_Comparison_Exp>;
  sort_order?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<Int_Comparison_Exp>;
  summary_types?: InputMaybe<Summary_Type_Bool_Exp>;
  time_program_entries?: InputMaybe<Time_Program_Entry_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "round" */
export type Round_Max_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  official_at?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  round_type?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "round" */
export type Round_Min_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  official_at?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  round_type?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "round". */
export type Round_Order_By = {
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event?: InputMaybe<Events_Order_By>;
  event_oid?: InputMaybe<Order_By>;
  file_archives_aggregate?: InputMaybe<File_Archive_Aggregate_Order_By>;
  heats_aggregate?: InputMaybe<Heat_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  official_at?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  round_type?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  summary_types_aggregate?: InputMaybe<Summary_Type_Aggregate_Order_By>;
  time_program_entries_aggregate?: InputMaybe<Time_Program_Entry_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "round" */
export enum Round_Select_Column {
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventOid = 'event_oid',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OfficialAt = 'official_at',
  /** column name */
  Oid = 'oid',
  /** column name */
  RoundType = 'round_type',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "round" */
export type Round_Stddev_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  round_type?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "round" */
export type Round_Stddev_Pop_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  round_type?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "round" */
export type Round_Stddev_Samp_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  round_type?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "round" */
export type Round_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Round_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Round_Stream_Cursor_Value_Input = {
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_oid?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  official_at?: InputMaybe<Scalars['timestamptz']['input']>;
  oid?: InputMaybe<Scalars['Int']['input']>;
  round_type?: InputMaybe<Scalars['Int']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "round" */
export type Round_Sum_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  round_type?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "round" */
export type Round_Var_Pop_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  round_type?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "round" */
export type Round_Var_Samp_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  round_type?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "round" */
export type Round_Variance_Order_By = {
  event_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  round_type?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** columns and relationships of "sponsor" */
export type Sponsor = {
  __typename?: 'sponsor';
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  /** An array relationship */
  events: Array<Events>;
  id: Scalars['Int']['output'];
  img?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  oid: Scalars['Int']['output'];
};


/** columns and relationships of "sponsor" */
export type SponsorEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};

/** order by aggregate values of table "sponsor" */
export type Sponsor_Aggregate_Order_By = {
  avg?: InputMaybe<Sponsor_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sponsor_Max_Order_By>;
  min?: InputMaybe<Sponsor_Min_Order_By>;
  stddev?: InputMaybe<Sponsor_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sponsor_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sponsor_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sponsor_Sum_Order_By>;
  var_pop?: InputMaybe<Sponsor_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sponsor_Var_Samp_Order_By>;
  variance?: InputMaybe<Sponsor_Variance_Order_By>;
};

/** order by avg() on columns of table "sponsor" */
export type Sponsor_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sponsor". All fields are combined with a logical 'AND'. */
export type Sponsor_Bool_Exp = {
  _and?: InputMaybe<Array<Sponsor_Bool_Exp>>;
  _not?: InputMaybe<Sponsor_Bool_Exp>;
  _or?: InputMaybe<Array<Sponsor_Bool_Exp>>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  events?: InputMaybe<Events_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  img?: InputMaybe<String_Comparison_Exp>;
  link?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  oid?: InputMaybe<Int_Comparison_Exp>;
};

/** order by max() on columns of table "sponsor" */
export type Sponsor_Max_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  img?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "sponsor" */
export type Sponsor_Min_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  img?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "sponsor". */
export type Sponsor_Order_By = {
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  events_aggregate?: InputMaybe<Events_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  img?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** select columns of table "sponsor" */
export enum Sponsor_Select_Column {
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  Id = 'id',
  /** column name */
  Img = 'img',
  /** column name */
  Link = 'link',
  /** column name */
  Name = 'name',
  /** column name */
  Oid = 'oid'
}

/** order by stddev() on columns of table "sponsor" */
export type Sponsor_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "sponsor" */
export type Sponsor_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "sponsor" */
export type Sponsor_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sponsor" */
export type Sponsor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sponsor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sponsor_Stream_Cursor_Value_Input = {
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oid?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "sponsor" */
export type Sponsor_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "sponsor" */
export type Sponsor_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "sponsor" */
export type Sponsor_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "sponsor" */
export type Sponsor_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
};

/** columns and relationships of "sub_results" */
export type Sub_Results = {
  __typename?: 'sub_results';
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  done_at: Scalars['Int']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  lane?: Maybe<Lane>;
  lane_oid: Scalars['Int']['output'];
  oid: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  relay_competitor_order: Scalars['Int']['output'];
  result_value: Scalars['Int']['output'];
  result_value_text: Scalars['String']['output'];
  split_diff: Scalars['Int']['output'];
  split_diff_text: Scalars['String']['output'];
  take_over: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "sub_results" */
export type Sub_Results_Aggregate_Order_By = {
  avg?: InputMaybe<Sub_Results_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Sub_Results_Max_Order_By>;
  min?: InputMaybe<Sub_Results_Min_Order_By>;
  stddev?: InputMaybe<Sub_Results_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Sub_Results_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Sub_Results_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Sub_Results_Sum_Order_By>;
  var_pop?: InputMaybe<Sub_Results_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Sub_Results_Var_Samp_Order_By>;
  variance?: InputMaybe<Sub_Results_Variance_Order_By>;
};

/** order by avg() on columns of table "sub_results" */
export type Sub_Results_Avg_Order_By = {
  done_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  relay_competitor_order?: InputMaybe<Order_By>;
  result_value?: InputMaybe<Order_By>;
  split_diff?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sub_results". All fields are combined with a logical 'AND'. */
export type Sub_Results_Bool_Exp = {
  _and?: InputMaybe<Array<Sub_Results_Bool_Exp>>;
  _not?: InputMaybe<Sub_Results_Bool_Exp>;
  _or?: InputMaybe<Array<Sub_Results_Bool_Exp>>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  done_at?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lane?: InputMaybe<Lane_Bool_Exp>;
  lane_oid?: InputMaybe<Int_Comparison_Exp>;
  oid?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  relay_competitor_order?: InputMaybe<Int_Comparison_Exp>;
  result_value?: InputMaybe<Int_Comparison_Exp>;
  result_value_text?: InputMaybe<String_Comparison_Exp>;
  split_diff?: InputMaybe<Int_Comparison_Exp>;
  split_diff_text?: InputMaybe<String_Comparison_Exp>;
  take_over?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "sub_results" */
export type Sub_Results_Max_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  done_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  relay_competitor_order?: InputMaybe<Order_By>;
  result_value?: InputMaybe<Order_By>;
  result_value_text?: InputMaybe<Order_By>;
  split_diff?: InputMaybe<Order_By>;
  split_diff_text?: InputMaybe<Order_By>;
  take_over?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "sub_results" */
export type Sub_Results_Min_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  done_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  relay_competitor_order?: InputMaybe<Order_By>;
  result_value?: InputMaybe<Order_By>;
  result_value_text?: InputMaybe<Order_By>;
  split_diff?: InputMaybe<Order_By>;
  split_diff_text?: InputMaybe<Order_By>;
  take_over?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "sub_results". */
export type Sub_Results_Order_By = {
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  done_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane?: InputMaybe<Lane_Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  relay_competitor_order?: InputMaybe<Order_By>;
  result_value?: InputMaybe<Order_By>;
  result_value_text?: InputMaybe<Order_By>;
  split_diff?: InputMaybe<Order_By>;
  split_diff_text?: InputMaybe<Order_By>;
  take_over?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "sub_results" */
export enum Sub_Results_Select_Column {
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DoneAt = 'done_at',
  /** column name */
  Id = 'id',
  /** column name */
  LaneOid = 'lane_oid',
  /** column name */
  Oid = 'oid',
  /** column name */
  Order = 'order',
  /** column name */
  RelayCompetitorOrder = 'relay_competitor_order',
  /** column name */
  ResultValue = 'result_value',
  /** column name */
  ResultValueText = 'result_value_text',
  /** column name */
  SplitDiff = 'split_diff',
  /** column name */
  SplitDiffText = 'split_diff_text',
  /** column name */
  TakeOver = 'take_over',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "sub_results" */
export type Sub_Results_Stddev_Order_By = {
  done_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  relay_competitor_order?: InputMaybe<Order_By>;
  result_value?: InputMaybe<Order_By>;
  split_diff?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "sub_results" */
export type Sub_Results_Stddev_Pop_Order_By = {
  done_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  relay_competitor_order?: InputMaybe<Order_By>;
  result_value?: InputMaybe<Order_By>;
  split_diff?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "sub_results" */
export type Sub_Results_Stddev_Samp_Order_By = {
  done_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  relay_competitor_order?: InputMaybe<Order_By>;
  result_value?: InputMaybe<Order_By>;
  split_diff?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sub_results" */
export type Sub_Results_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Sub_Results_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Sub_Results_Stream_Cursor_Value_Input = {
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  done_at?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lane_oid?: InputMaybe<Scalars['Int']['input']>;
  oid?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  relay_competitor_order?: InputMaybe<Scalars['Int']['input']>;
  result_value?: InputMaybe<Scalars['Int']['input']>;
  result_value_text?: InputMaybe<Scalars['String']['input']>;
  split_diff?: InputMaybe<Scalars['Int']['input']>;
  split_diff_text?: InputMaybe<Scalars['String']['input']>;
  take_over?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "sub_results" */
export type Sub_Results_Sum_Order_By = {
  done_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  relay_competitor_order?: InputMaybe<Order_By>;
  result_value?: InputMaybe<Order_By>;
  split_diff?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "sub_results" */
export type Sub_Results_Var_Pop_Order_By = {
  done_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  relay_competitor_order?: InputMaybe<Order_By>;
  result_value?: InputMaybe<Order_By>;
  split_diff?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "sub_results" */
export type Sub_Results_Var_Samp_Order_By = {
  done_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  relay_competitor_order?: InputMaybe<Order_By>;
  result_value?: InputMaybe<Order_By>;
  split_diff?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "sub_results" */
export type Sub_Results_Variance_Order_By = {
  done_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lane_oid?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  relay_competitor_order?: InputMaybe<Order_By>;
  result_value?: InputMaybe<Order_By>;
  split_diff?: InputMaybe<Order_By>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "agegroup" */
  agegroup: Array<Agegroup>;
  /** fetch data from the table: "agegroup" using primary key columns */
  agegroup_by_pk?: Maybe<Agegroup>;
  /** fetch data from the table in a streaming manner: "agegroup" */
  agegroup_stream: Array<Agegroup>;
  /** An array relationship */
  clubs: Array<Clubs>;
  /** fetch data from the table: "clubs" using primary key columns */
  clubs_by_pk?: Maybe<Clubs>;
  /** fetch data from the table in a streaming manner: "clubs" */
  clubs_stream: Array<Clubs>;
  /** An array relationship */
  combined_competitions: Array<Combined_Competitions>;
  /** fetch data from the table: "combined_competitions" using primary key columns */
  combined_competitions_by_pk?: Maybe<Combined_Competitions>;
  /** fetch data from the table in a streaming manner: "combined_competitions" */
  combined_competitions_stream: Array<Combined_Competitions>;
  /** fetch data from the table: "competition_session" */
  competition_session: Array<Competition_Session>;
  /** fetch data from the table: "competition_session" using primary key columns */
  competition_session_by_pk?: Maybe<Competition_Session>;
  /** fetch data from the table in a streaming manner: "competition_session" */
  competition_session_stream: Array<Competition_Session>;
  /** fetch data from the table: "competitions" */
  competitions: Array<Competitions>;
  /** fetch data from the table: "competitions" using primary key columns */
  competitions_by_pk?: Maybe<Competitions>;
  /** fetch data from the table in a streaming manner: "competitions" */
  competitions_stream: Array<Competitions>;
  /** fetch data from the table: "competitor" */
  competitor: Array<Competitor>;
  /** fetch aggregated fields from the table: "competitor" */
  competitor_aggregate: Competitor_Aggregate;
  /** fetch data from the table: "competitor" using primary key columns */
  competitor_by_pk?: Maybe<Competitor>;
  /** fetch data from the table in a streaming manner: "competitor" */
  competitor_stream: Array<Competitor>;
  /** fetch data from the table: "current_heat" */
  current_heat: Array<Current_Heat>;
  /** fetch data from the table: "current_heat" using primary key columns */
  current_heat_by_pk?: Maybe<Current_Heat>;
  /** fetch data from the table in a streaming manner: "current_heat" */
  current_heat_stream: Array<Current_Heat>;
  /** fetch data from the table: "entry" */
  entry: Array<Entry>;
  /** fetch data from the table: "entry" using primary key columns */
  entry_by_pk?: Maybe<Entry>;
  /** fetch data from the table: "entry_list_type" */
  entry_list_type: Array<Entry_List_Type>;
  /** fetch data from the table: "entry_list_type" using primary key columns */
  entry_list_type_by_pk?: Maybe<Entry_List_Type>;
  /** fetch data from the table in a streaming manner: "entry_list_type" */
  entry_list_type_stream: Array<Entry_List_Type>;
  /** fetch data from the table: "entry_rank" */
  entry_rank: Array<Entry_Rank>;
  /** fetch data from the table: "entry_rank" using primary key columns */
  entry_rank_by_pk?: Maybe<Entry_Rank>;
  /** fetch data from the table in a streaming manner: "entry_rank" */
  entry_rank_stream: Array<Entry_Rank>;
  /** fetch data from the table in a streaming manner: "entry" */
  entry_stream: Array<Entry>;
  /** An array relationship */
  event_records: Array<Event_Records>;
  /** fetch data from the table: "event_records" using primary key columns */
  event_records_by_pk?: Maybe<Event_Records>;
  /** fetch data from the table in a streaming manner: "event_records" */
  event_records_stream: Array<Event_Records>;
  /** An array relationship */
  events: Array<Events>;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: Maybe<Events>;
  /** fetch data from the table in a streaming manner: "events" */
  events_stream: Array<Events>;
  /** fetch data from the table: "file_archive" */
  file_archive: Array<File_Archive>;
  /** fetch data from the table: "file_archive" using primary key columns */
  file_archive_by_pk?: Maybe<File_Archive>;
  /** fetch data from the table in a streaming manner: "file_archive" */
  file_archive_stream: Array<File_Archive>;
  /** fetch data from the table: "get_current_time" */
  get_current_time: Array<Get_Current_Time>;
  /** fetch data from the table in a streaming manner: "get_current_time" */
  get_current_time_stream: Array<Get_Current_Time>;
  /** An array relationship */
  heat: Array<Heat>;
  /** fetch data from the table: "heat" using primary key columns */
  heat_by_pk?: Maybe<Heat>;
  /** fetch data from the table in a streaming manner: "heat" */
  heat_stream: Array<Heat>;
  /** fetch data from the table: "lane" */
  lane: Array<Lane>;
  /** fetch data from the table: "lane" using primary key columns */
  lane_by_pk?: Maybe<Lane>;
  /** fetch data from the table in a streaming manner: "lane" */
  lane_stream: Array<Lane>;
  /** fetch data from the table: "lookup.event_type" */
  lookup_event_type: Array<Lookup_Event_Type>;
  /** fetch data from the table: "lookup.event_type" using primary key columns */
  lookup_event_type_by_pk?: Maybe<Lookup_Event_Type>;
  /** fetch data from the table in a streaming manner: "lookup.event_type" */
  lookup_event_type_stream: Array<Lookup_Event_Type>;
  /** fetch data from the table: "point_list" */
  point_list: Array<Point_List>;
  /** fetch data from the table: "point_list" using primary key columns */
  point_list_by_pk?: Maybe<Point_List>;
  /** fetch data from the table: "point_list_row" */
  point_list_row: Array<Point_List_Row>;
  /** fetch data from the table: "point_list_row" using primary key columns */
  point_list_row_by_pk?: Maybe<Point_List_Row>;
  /** fetch data from the table in a streaming manner: "point_list_row" */
  point_list_row_stream: Array<Point_List_Row>;
  /** fetch data from the table in a streaming manner: "point_list" */
  point_list_stream: Array<Point_List>;
  /** fetch data from the table: "rank" */
  rank: Array<Rank>;
  /** fetch data from the table: "rank" using primary key columns */
  rank_by_pk?: Maybe<Rank>;
  /** fetch data from the table in a streaming manner: "rank" */
  rank_stream: Array<Rank>;
  /** fetch data from the table: "relay_competitor" */
  relay_competitor: Array<Relay_Competitor>;
  /** fetch data from the table: "relay_competitor" using primary key columns */
  relay_competitor_by_pk?: Maybe<Relay_Competitor>;
  /** fetch data from the table in a streaming manner: "relay_competitor" */
  relay_competitor_stream: Array<Relay_Competitor>;
  /** fetch data from the table: "round" */
  round: Array<Round>;
  /** fetch data from the table: "round" using primary key columns */
  round_by_pk?: Maybe<Round>;
  /** fetch data from the table in a streaming manner: "round" */
  round_stream: Array<Round>;
  /** fetch data from the table: "sponsor" */
  sponsor: Array<Sponsor>;
  /** fetch data from the table: "sponsor" using primary key columns */
  sponsor_by_pk?: Maybe<Sponsor>;
  /** fetch data from the table in a streaming manner: "sponsor" */
  sponsor_stream: Array<Sponsor>;
  /** An array relationship */
  sub_results: Array<Sub_Results>;
  /** fetch data from the table: "sub_results" using primary key columns */
  sub_results_by_pk?: Maybe<Sub_Results>;
  /** fetch data from the table in a streaming manner: "sub_results" */
  sub_results_stream: Array<Sub_Results>;
  /** fetch data from the table: "subscriptions.starred_competition" */
  subscriptions_starred_competition: Array<Subscriptions_Starred_Competition>;
  /** fetch data from the table: "subscriptions.starred_competition" using primary key columns */
  subscriptions_starred_competition_by_pk?: Maybe<Subscriptions_Starred_Competition>;
  /** fetch data from the table in a streaming manner: "subscriptions.starred_competition" */
  subscriptions_starred_competition_stream: Array<Subscriptions_Starred_Competition>;
  /** fetch data from the table: "subscriptions.starred_competition_swimmers" */
  subscriptions_starred_competition_swimmers: Array<Subscriptions_Starred_Competition_Swimmers>;
  /** fetch data from the table: "subscriptions.starred_competition_swimmers" using primary key columns */
  subscriptions_starred_competition_swimmers_by_pk?: Maybe<Subscriptions_Starred_Competition_Swimmers>;
  /** fetch data from the table in a streaming manner: "subscriptions.starred_competition_swimmers" */
  subscriptions_starred_competition_swimmers_stream: Array<Subscriptions_Starred_Competition_Swimmers>;
  /** fetch data from the table: "subscriptions.starred_global_swimmers" */
  subscriptions_starred_global_swimmers: Array<Subscriptions_Starred_Global_Swimmers>;
  /** fetch data from the table: "subscriptions.starred_global_swimmers" using primary key columns */
  subscriptions_starred_global_swimmers_by_pk?: Maybe<Subscriptions_Starred_Global_Swimmers>;
  /** fetch data from the table in a streaming manner: "subscriptions.starred_global_swimmers" */
  subscriptions_starred_global_swimmers_stream: Array<Subscriptions_Starred_Global_Swimmers>;
  /** fetch data from the table: "subscriptions.subscriber" */
  subscriptions_subscriber: Array<Subscriptions_Subscriber>;
  /** fetch data from the table: "subscriptions.subscriber" using primary key columns */
  subscriptions_subscriber_by_pk?: Maybe<Subscriptions_Subscriber>;
  /** fetch data from the table: "subscriptions.subscriber_device" */
  subscriptions_subscriber_device: Array<Subscriptions_Subscriber_Device>;
  /** fetch data from the table: "subscriptions.subscriber_device" using primary key columns */
  subscriptions_subscriber_device_by_pk?: Maybe<Subscriptions_Subscriber_Device>;
  /** fetch data from the table in a streaming manner: "subscriptions.subscriber_device" */
  subscriptions_subscriber_device_stream: Array<Subscriptions_Subscriber_Device>;
  /** fetch data from the table in a streaming manner: "subscriptions.subscriber" */
  subscriptions_subscriber_stream: Array<Subscriptions_Subscriber>;
  /** fetch data from the table: "summary_type" */
  summary_type: Array<Summary_Type>;
  /** fetch data from the table: "summary_type" using primary key columns */
  summary_type_by_pk?: Maybe<Summary_Type>;
  /** fetch data from the table in a streaming manner: "summary_type" */
  summary_type_stream: Array<Summary_Type>;
  /** fetch data from the table: "time_program_entry" */
  time_program_entry: Array<Time_Program_Entry>;
  /** fetch data from the table: "time_program_entry" using primary key columns */
  time_program_entry_by_pk?: Maybe<Time_Program_Entry>;
  /** fetch data from the table in a streaming manner: "time_program_entry" */
  time_program_entry_stream: Array<Time_Program_Entry>;
};


export type Subscription_RootAgegroupArgs = {
  distinct_on?: InputMaybe<Array<Agegroup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agegroup_Order_By>>;
  where?: InputMaybe<Agegroup_Bool_Exp>;
};


export type Subscription_RootAgegroup_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootAgegroup_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Agegroup_Stream_Cursor_Input>>;
  where?: InputMaybe<Agegroup_Bool_Exp>;
};


export type Subscription_RootClubsArgs = {
  distinct_on?: InputMaybe<Array<Clubs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Clubs_Order_By>>;
  where?: InputMaybe<Clubs_Bool_Exp>;
};


export type Subscription_RootClubs_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootClubs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Clubs_Stream_Cursor_Input>>;
  where?: InputMaybe<Clubs_Bool_Exp>;
};


export type Subscription_RootCombined_CompetitionsArgs = {
  distinct_on?: InputMaybe<Array<Combined_Competitions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Combined_Competitions_Order_By>>;
  where?: InputMaybe<Combined_Competitions_Bool_Exp>;
};


export type Subscription_RootCombined_Competitions_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootCombined_Competitions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Combined_Competitions_Stream_Cursor_Input>>;
  where?: InputMaybe<Combined_Competitions_Bool_Exp>;
};


export type Subscription_RootCompetition_SessionArgs = {
  distinct_on?: InputMaybe<Array<Competition_Session_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Competition_Session_Order_By>>;
  where?: InputMaybe<Competition_Session_Bool_Exp>;
};


export type Subscription_RootCompetition_Session_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootCompetition_Session_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Competition_Session_Stream_Cursor_Input>>;
  where?: InputMaybe<Competition_Session_Bool_Exp>;
};


export type Subscription_RootCompetitionsArgs = {
  distinct_on?: InputMaybe<Array<Competitions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Competitions_Order_By>>;
  where?: InputMaybe<Competitions_Bool_Exp>;
};


export type Subscription_RootCompetitions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCompetitions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Competitions_Stream_Cursor_Input>>;
  where?: InputMaybe<Competitions_Bool_Exp>;
};


export type Subscription_RootCompetitorArgs = {
  distinct_on?: InputMaybe<Array<Competitor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Competitor_Order_By>>;
  where?: InputMaybe<Competitor_Bool_Exp>;
};


export type Subscription_RootCompetitor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Competitor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Competitor_Order_By>>;
  where?: InputMaybe<Competitor_Bool_Exp>;
};


export type Subscription_RootCompetitor_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootCompetitor_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Competitor_Stream_Cursor_Input>>;
  where?: InputMaybe<Competitor_Bool_Exp>;
};


export type Subscription_RootCurrent_HeatArgs = {
  distinct_on?: InputMaybe<Array<Current_Heat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Current_Heat_Order_By>>;
  where?: InputMaybe<Current_Heat_Bool_Exp>;
};


export type Subscription_RootCurrent_Heat_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootCurrent_Heat_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Current_Heat_Stream_Cursor_Input>>;
  where?: InputMaybe<Current_Heat_Bool_Exp>;
};


export type Subscription_RootEntryArgs = {
  distinct_on?: InputMaybe<Array<Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entry_Order_By>>;
  where?: InputMaybe<Entry_Bool_Exp>;
};


export type Subscription_RootEntry_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootEntry_List_TypeArgs = {
  distinct_on?: InputMaybe<Array<Entry_List_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entry_List_Type_Order_By>>;
  where?: InputMaybe<Entry_List_Type_Bool_Exp>;
};


export type Subscription_RootEntry_List_Type_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootEntry_List_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Entry_List_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Entry_List_Type_Bool_Exp>;
};


export type Subscription_RootEntry_RankArgs = {
  distinct_on?: InputMaybe<Array<Entry_Rank_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entry_Rank_Order_By>>;
  where?: InputMaybe<Entry_Rank_Bool_Exp>;
};


export type Subscription_RootEntry_Rank_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootEntry_Rank_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Entry_Rank_Stream_Cursor_Input>>;
  where?: InputMaybe<Entry_Rank_Bool_Exp>;
};


export type Subscription_RootEntry_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Entry_Stream_Cursor_Input>>;
  where?: InputMaybe<Entry_Bool_Exp>;
};


export type Subscription_RootEvent_RecordsArgs = {
  distinct_on?: InputMaybe<Array<Event_Records_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Records_Order_By>>;
  where?: InputMaybe<Event_Records_Bool_Exp>;
};


export type Subscription_RootEvent_Records_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootEvent_Records_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Event_Records_Stream_Cursor_Input>>;
  where?: InputMaybe<Event_Records_Bool_Exp>;
};


export type Subscription_RootEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootEvents_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootEvents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootFile_ArchiveArgs = {
  distinct_on?: InputMaybe<Array<File_Archive_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<File_Archive_Order_By>>;
  where?: InputMaybe<File_Archive_Bool_Exp>;
};


export type Subscription_RootFile_Archive_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFile_Archive_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<File_Archive_Stream_Cursor_Input>>;
  where?: InputMaybe<File_Archive_Bool_Exp>;
};


export type Subscription_RootGet_Current_TimeArgs = {
  distinct_on?: InputMaybe<Array<Get_Current_Time_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Get_Current_Time_Order_By>>;
  where?: InputMaybe<Get_Current_Time_Bool_Exp>;
};


export type Subscription_RootGet_Current_Time_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Get_Current_Time_Stream_Cursor_Input>>;
  where?: InputMaybe<Get_Current_Time_Bool_Exp>;
};


export type Subscription_RootHeatArgs = {
  distinct_on?: InputMaybe<Array<Heat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Heat_Order_By>>;
  where?: InputMaybe<Heat_Bool_Exp>;
};


export type Subscription_RootHeat_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootHeat_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Heat_Stream_Cursor_Input>>;
  where?: InputMaybe<Heat_Bool_Exp>;
};


export type Subscription_RootLaneArgs = {
  distinct_on?: InputMaybe<Array<Lane_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lane_Order_By>>;
  where?: InputMaybe<Lane_Bool_Exp>;
};


export type Subscription_RootLane_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootLane_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lane_Stream_Cursor_Input>>;
  where?: InputMaybe<Lane_Bool_Exp>;
};


export type Subscription_RootLookup_Event_TypeArgs = {
  distinct_on?: InputMaybe<Array<Lookup_Event_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lookup_Event_Type_Order_By>>;
  where?: InputMaybe<Lookup_Event_Type_Bool_Exp>;
};


export type Subscription_RootLookup_Event_Type_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootLookup_Event_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lookup_Event_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Lookup_Event_Type_Bool_Exp>;
};


export type Subscription_RootPoint_ListArgs = {
  distinct_on?: InputMaybe<Array<Point_List_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Point_List_Order_By>>;
  where?: InputMaybe<Point_List_Bool_Exp>;
};


export type Subscription_RootPoint_List_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootPoint_List_RowArgs = {
  distinct_on?: InputMaybe<Array<Point_List_Row_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Point_List_Row_Order_By>>;
  where?: InputMaybe<Point_List_Row_Bool_Exp>;
};


export type Subscription_RootPoint_List_Row_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootPoint_List_Row_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Point_List_Row_Stream_Cursor_Input>>;
  where?: InputMaybe<Point_List_Row_Bool_Exp>;
};


export type Subscription_RootPoint_List_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Point_List_Stream_Cursor_Input>>;
  where?: InputMaybe<Point_List_Bool_Exp>;
};


export type Subscription_RootRankArgs = {
  distinct_on?: InputMaybe<Array<Rank_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rank_Order_By>>;
  where?: InputMaybe<Rank_Bool_Exp>;
};


export type Subscription_RootRank_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootRank_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rank_Stream_Cursor_Input>>;
  where?: InputMaybe<Rank_Bool_Exp>;
};


export type Subscription_RootRelay_CompetitorArgs = {
  distinct_on?: InputMaybe<Array<Relay_Competitor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Relay_Competitor_Order_By>>;
  where?: InputMaybe<Relay_Competitor_Bool_Exp>;
};


export type Subscription_RootRelay_Competitor_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootRelay_Competitor_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Relay_Competitor_Stream_Cursor_Input>>;
  where?: InputMaybe<Relay_Competitor_Bool_Exp>;
};


export type Subscription_RootRoundArgs = {
  distinct_on?: InputMaybe<Array<Round_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Round_Order_By>>;
  where?: InputMaybe<Round_Bool_Exp>;
};


export type Subscription_RootRound_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootRound_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Round_Stream_Cursor_Input>>;
  where?: InputMaybe<Round_Bool_Exp>;
};


export type Subscription_RootSponsorArgs = {
  distinct_on?: InputMaybe<Array<Sponsor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sponsor_Order_By>>;
  where?: InputMaybe<Sponsor_Bool_Exp>;
};


export type Subscription_RootSponsor_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootSponsor_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sponsor_Stream_Cursor_Input>>;
  where?: InputMaybe<Sponsor_Bool_Exp>;
};


export type Subscription_RootSub_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Sub_Results_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sub_Results_Order_By>>;
  where?: InputMaybe<Sub_Results_Bool_Exp>;
};


export type Subscription_RootSub_Results_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootSub_Results_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sub_Results_Stream_Cursor_Input>>;
  where?: InputMaybe<Sub_Results_Bool_Exp>;
};


export type Subscription_RootSubscriptions_Starred_CompetitionArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Starred_Competition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Starred_Competition_Order_By>>;
  where?: InputMaybe<Subscriptions_Starred_Competition_Bool_Exp>;
};


export type Subscription_RootSubscriptions_Starred_Competition_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootSubscriptions_Starred_Competition_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscriptions_Starred_Competition_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscriptions_Starred_Competition_Bool_Exp>;
};


export type Subscription_RootSubscriptions_Starred_Competition_SwimmersArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Starred_Competition_Swimmers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Starred_Competition_Swimmers_Order_By>>;
  where?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Bool_Exp>;
};


export type Subscription_RootSubscriptions_Starred_Competition_Swimmers_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootSubscriptions_Starred_Competition_Swimmers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscriptions_Starred_Competition_Swimmers_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Bool_Exp>;
};


export type Subscription_RootSubscriptions_Starred_Global_SwimmersArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Starred_Global_Swimmers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Starred_Global_Swimmers_Order_By>>;
  where?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Bool_Exp>;
};


export type Subscription_RootSubscriptions_Starred_Global_Swimmers_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootSubscriptions_Starred_Global_Swimmers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscriptions_Starred_Global_Swimmers_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Bool_Exp>;
};


export type Subscription_RootSubscriptions_SubscriberArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriber_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriber_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriber_Bool_Exp>;
};


export type Subscription_RootSubscriptions_Subscriber_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSubscriptions_Subscriber_DeviceArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriber_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriber_Device_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriber_Device_Bool_Exp>;
};


export type Subscription_RootSubscriptions_Subscriber_Device_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootSubscriptions_Subscriber_Device_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscriptions_Subscriber_Device_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscriptions_Subscriber_Device_Bool_Exp>;
};


export type Subscription_RootSubscriptions_Subscriber_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscriptions_Subscriber_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscriptions_Subscriber_Bool_Exp>;
};


export type Subscription_RootSummary_TypeArgs = {
  distinct_on?: InputMaybe<Array<Summary_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Summary_Type_Order_By>>;
  where?: InputMaybe<Summary_Type_Bool_Exp>;
};


export type Subscription_RootSummary_Type_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootSummary_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Summary_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Summary_Type_Bool_Exp>;
};


export type Subscription_RootTime_Program_EntryArgs = {
  distinct_on?: InputMaybe<Array<Time_Program_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Time_Program_Entry_Order_By>>;
  where?: InputMaybe<Time_Program_Entry_Bool_Exp>;
};


export type Subscription_RootTime_Program_Entry_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootTime_Program_Entry_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Time_Program_Entry_Stream_Cursor_Input>>;
  where?: InputMaybe<Time_Program_Entry_Bool_Exp>;
};

/** columns and relationships of "subscriptions.starred_competition" */
export type Subscriptions_Starred_Competition = {
  __typename?: 'subscriptions_starred_competition';
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  subscriber: Subscriptions_Subscriber;
  subscriber_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "subscriptions.starred_competition" */
export type Subscriptions_Starred_Competition_Aggregate_Order_By = {
  avg?: InputMaybe<Subscriptions_Starred_Competition_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscriptions_Starred_Competition_Max_Order_By>;
  min?: InputMaybe<Subscriptions_Starred_Competition_Min_Order_By>;
  stddev?: InputMaybe<Subscriptions_Starred_Competition_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Subscriptions_Starred_Competition_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Subscriptions_Starred_Competition_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Subscriptions_Starred_Competition_Sum_Order_By>;
  var_pop?: InputMaybe<Subscriptions_Starred_Competition_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Subscriptions_Starred_Competition_Var_Samp_Order_By>;
  variance?: InputMaybe<Subscriptions_Starred_Competition_Variance_Order_By>;
};

/** order by avg() on columns of table "subscriptions.starred_competition" */
export type Subscriptions_Starred_Competition_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "subscriptions.starred_competition". All fields are combined with a logical 'AND'. */
export type Subscriptions_Starred_Competition_Bool_Exp = {
  _and?: InputMaybe<Array<Subscriptions_Starred_Competition_Bool_Exp>>;
  _not?: InputMaybe<Subscriptions_Starred_Competition_Bool_Exp>;
  _or?: InputMaybe<Array<Subscriptions_Starred_Competition_Bool_Exp>>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  subscriber?: InputMaybe<Subscriptions_Subscriber_Bool_Exp>;
  subscriber_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscriptions.starred_competition" */
export enum Subscriptions_Starred_Competition_Constraint {
  /** unique or primary key constraint on columns "id" */
  StarredCompetitionPkey = 'starred_competition_pkey',
  /** unique or primary key constraint on columns "competition_id", "subscriber_id" */
  StarredCompetitionSubscriberIdCompetitionIdKey = 'starred_competition_subscriber_id_competition_id_key'
}

/** input type for inserting data into table "subscriptions.starred_competition" */
export type Subscriptions_Starred_Competition_Insert_Input = {
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  subscriber_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "subscriptions.starred_competition" */
export type Subscriptions_Starred_Competition_Max_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subscriber_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "subscriptions.starred_competition" */
export type Subscriptions_Starred_Competition_Min_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subscriber_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscriptions.starred_competition" */
export type Subscriptions_Starred_Competition_Mutation_Response = {
  __typename?: 'subscriptions_starred_competition_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscriptions_Starred_Competition>;
};

/** on_conflict condition type for table "subscriptions.starred_competition" */
export type Subscriptions_Starred_Competition_On_Conflict = {
  constraint: Subscriptions_Starred_Competition_Constraint;
  update_columns?: Array<Subscriptions_Starred_Competition_Update_Column>;
  where?: InputMaybe<Subscriptions_Starred_Competition_Bool_Exp>;
};

/** Ordering options when selecting data from "subscriptions.starred_competition". */
export type Subscriptions_Starred_Competition_Order_By = {
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subscriber?: InputMaybe<Subscriptions_Subscriber_Order_By>;
  subscriber_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscriptions.starred_competition */
export type Subscriptions_Starred_Competition_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "subscriptions.starred_competition" */
export enum Subscriptions_Starred_Competition_Select_Column {
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SubscriberId = 'subscriber_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "subscriptions.starred_competition" */
export type Subscriptions_Starred_Competition_Set_Input = {
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  subscriber_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "subscriptions.starred_competition" */
export type Subscriptions_Starred_Competition_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "subscriptions.starred_competition" */
export type Subscriptions_Starred_Competition_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "subscriptions.starred_competition" */
export type Subscriptions_Starred_Competition_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "subscriptions_starred_competition" */
export type Subscriptions_Starred_Competition_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscriptions_Starred_Competition_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscriptions_Starred_Competition_Stream_Cursor_Value_Input = {
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  subscriber_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "subscriptions.starred_competition" */
export type Subscriptions_Starred_Competition_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "subscriptions.starred_competition_swimmers" */
export type Subscriptions_Starred_Competition_Swimmers = {
  __typename?: 'subscriptions_starred_competition_swimmers';
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  /** An object relationship */
  competitor?: Maybe<Competitor>;
  competitor_oid: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  subscriber: Subscriptions_Subscriber;
  subscriber_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "subscriptions.starred_competition_swimmers" */
export type Subscriptions_Starred_Competition_Swimmers_Aggregate_Order_By = {
  avg?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Max_Order_By>;
  min?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Min_Order_By>;
  stddev?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Sum_Order_By>;
  var_pop?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Var_Samp_Order_By>;
  variance?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Variance_Order_By>;
};

/** order by avg() on columns of table "subscriptions.starred_competition_swimmers" */
export type Subscriptions_Starred_Competition_Swimmers_Avg_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "subscriptions.starred_competition_swimmers". All fields are combined with a logical 'AND'. */
export type Subscriptions_Starred_Competition_Swimmers_Bool_Exp = {
  _and?: InputMaybe<Array<Subscriptions_Starred_Competition_Swimmers_Bool_Exp>>;
  _not?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Bool_Exp>;
  _or?: InputMaybe<Array<Subscriptions_Starred_Competition_Swimmers_Bool_Exp>>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  competitor?: InputMaybe<Competitor_Bool_Exp>;
  competitor_oid?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  subscriber?: InputMaybe<Subscriptions_Subscriber_Bool_Exp>;
  subscriber_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscriptions.starred_competition_swimmers" */
export enum Subscriptions_Starred_Competition_Swimmers_Constraint {
  /** unique or primary key constraint on columns "id" */
  StarredCompetitionSwimmersPkey = 'starred_competition_swimmers_pkey',
  /** unique or primary key constraint on columns "competition_id", "subscriber_id", "competitor_oid" */
  StarredCompetitionSwimmersSubscriberIdCompetitionIdCompe = 'starred_competition_swimmers_subscriber_id_competition_id_compe'
}

/** input type for incrementing numeric columns in table "subscriptions.starred_competition_swimmers" */
export type Subscriptions_Starred_Competition_Swimmers_Inc_Input = {
  competitor_oid?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "subscriptions.starred_competition_swimmers" */
export type Subscriptions_Starred_Competition_Swimmers_Insert_Input = {
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  competitor_oid?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  subscriber_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "subscriptions.starred_competition_swimmers" */
export type Subscriptions_Starred_Competition_Swimmers_Max_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subscriber_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "subscriptions.starred_competition_swimmers" */
export type Subscriptions_Starred_Competition_Swimmers_Min_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subscriber_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscriptions.starred_competition_swimmers" */
export type Subscriptions_Starred_Competition_Swimmers_Mutation_Response = {
  __typename?: 'subscriptions_starred_competition_swimmers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscriptions_Starred_Competition_Swimmers>;
};

/** on_conflict condition type for table "subscriptions.starred_competition_swimmers" */
export type Subscriptions_Starred_Competition_Swimmers_On_Conflict = {
  constraint: Subscriptions_Starred_Competition_Swimmers_Constraint;
  update_columns?: Array<Subscriptions_Starred_Competition_Swimmers_Update_Column>;
  where?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Bool_Exp>;
};

/** Ordering options when selecting data from "subscriptions.starred_competition_swimmers". */
export type Subscriptions_Starred_Competition_Swimmers_Order_By = {
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  competitor?: InputMaybe<Competitor_Order_By>;
  competitor_oid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subscriber?: InputMaybe<Subscriptions_Subscriber_Order_By>;
  subscriber_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscriptions.starred_competition_swimmers */
export type Subscriptions_Starred_Competition_Swimmers_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "subscriptions.starred_competition_swimmers" */
export enum Subscriptions_Starred_Competition_Swimmers_Select_Column {
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CompetitorOid = 'competitor_oid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SubscriberId = 'subscriber_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "subscriptions.starred_competition_swimmers" */
export type Subscriptions_Starred_Competition_Swimmers_Set_Input = {
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  competitor_oid?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  subscriber_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "subscriptions.starred_competition_swimmers" */
export type Subscriptions_Starred_Competition_Swimmers_Stddev_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "subscriptions.starred_competition_swimmers" */
export type Subscriptions_Starred_Competition_Swimmers_Stddev_Pop_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "subscriptions.starred_competition_swimmers" */
export type Subscriptions_Starred_Competition_Swimmers_Stddev_Samp_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "subscriptions_starred_competition_swimmers" */
export type Subscriptions_Starred_Competition_Swimmers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscriptions_Starred_Competition_Swimmers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscriptions_Starred_Competition_Swimmers_Stream_Cursor_Value_Input = {
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  competitor_oid?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  subscriber_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "subscriptions.starred_competition_swimmers" */
export type Subscriptions_Starred_Competition_Swimmers_Sum_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "subscriptions.starred_competition_swimmers" */
export enum Subscriptions_Starred_Competition_Swimmers_Update_Column {
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CompetitorOid = 'competitor_oid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  SubscriberId = 'subscriber_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Subscriptions_Starred_Competition_Swimmers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscriptions_Starred_Competition_Swimmers_Bool_Exp;
};

/** order by var_pop() on columns of table "subscriptions.starred_competition_swimmers" */
export type Subscriptions_Starred_Competition_Swimmers_Var_Pop_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "subscriptions.starred_competition_swimmers" */
export type Subscriptions_Starred_Competition_Swimmers_Var_Samp_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "subscriptions.starred_competition_swimmers" */
export type Subscriptions_Starred_Competition_Swimmers_Variance_Order_By = {
  competitor_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "subscriptions.starred_competition" */
export enum Subscriptions_Starred_Competition_Update_Column {
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  SubscriberId = 'subscriber_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Subscriptions_Starred_Competition_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscriptions_Starred_Competition_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscriptions_Starred_Competition_Bool_Exp;
};

/** order by var_pop() on columns of table "subscriptions.starred_competition" */
export type Subscriptions_Starred_Competition_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "subscriptions.starred_competition" */
export type Subscriptions_Starred_Competition_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "subscriptions.starred_competition" */
export type Subscriptions_Starred_Competition_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "subscriptions.starred_global_swimmers" */
export type Subscriptions_Starred_Global_Swimmers = {
  __typename?: 'subscriptions_starred_global_swimmers';
  born?: Maybe<Scalars['String']['output']>;
  club?: Maybe<Scalars['String']['output']>;
  club_short_name?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  gender: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  license: Scalars['String']['output'];
  nation_code: Scalars['String']['output'];
  /** An object relationship */
  subscriber: Subscriptions_Subscriber;
  subscriber_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "subscriptions.starred_global_swimmers" */
export type Subscriptions_Starred_Global_Swimmers_Aggregate_Order_By = {
  avg?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Max_Order_By>;
  min?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Min_Order_By>;
  stddev?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Sum_Order_By>;
  var_pop?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Var_Samp_Order_By>;
  variance?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Variance_Order_By>;
};

/** order by avg() on columns of table "subscriptions.starred_global_swimmers" */
export type Subscriptions_Starred_Global_Swimmers_Avg_Order_By = {
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "subscriptions.starred_global_swimmers". All fields are combined with a logical 'AND'. */
export type Subscriptions_Starred_Global_Swimmers_Bool_Exp = {
  _and?: InputMaybe<Array<Subscriptions_Starred_Global_Swimmers_Bool_Exp>>;
  _not?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Bool_Exp>;
  _or?: InputMaybe<Array<Subscriptions_Starred_Global_Swimmers_Bool_Exp>>;
  born?: InputMaybe<String_Comparison_Exp>;
  club?: InputMaybe<String_Comparison_Exp>;
  club_short_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  license?: InputMaybe<String_Comparison_Exp>;
  nation_code?: InputMaybe<String_Comparison_Exp>;
  subscriber?: InputMaybe<Subscriptions_Subscriber_Bool_Exp>;
  subscriber_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscriptions.starred_global_swimmers" */
export enum Subscriptions_Starred_Global_Swimmers_Constraint {
  /** unique or primary key constraint on columns "id" */
  StarredGlobalSwimmersPkey = 'starred_global_swimmers_pkey',
  /** unique or primary key constraint on columns "license", "subscriber_id", "nation_code" */
  StarredGlobalSwimmersSubscriberIdLicenseNationCodeKey = 'starred_global_swimmers_subscriber_id_license_nation_code_key'
}

/** input type for incrementing numeric columns in table "subscriptions.starred_global_swimmers" */
export type Subscriptions_Starred_Global_Swimmers_Inc_Input = {
  gender?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "subscriptions.starred_global_swimmers" */
export type Subscriptions_Starred_Global_Swimmers_Insert_Input = {
  born?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['String']['input']>;
  club_short_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  nation_code?: InputMaybe<Scalars['String']['input']>;
  subscriber_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "subscriptions.starred_global_swimmers" */
export type Subscriptions_Starred_Global_Swimmers_Max_Order_By = {
  born?: InputMaybe<Order_By>;
  club?: InputMaybe<Order_By>;
  club_short_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  license?: InputMaybe<Order_By>;
  nation_code?: InputMaybe<Order_By>;
  subscriber_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "subscriptions.starred_global_swimmers" */
export type Subscriptions_Starred_Global_Swimmers_Min_Order_By = {
  born?: InputMaybe<Order_By>;
  club?: InputMaybe<Order_By>;
  club_short_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  license?: InputMaybe<Order_By>;
  nation_code?: InputMaybe<Order_By>;
  subscriber_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscriptions.starred_global_swimmers" */
export type Subscriptions_Starred_Global_Swimmers_Mutation_Response = {
  __typename?: 'subscriptions_starred_global_swimmers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscriptions_Starred_Global_Swimmers>;
};

/** on_conflict condition type for table "subscriptions.starred_global_swimmers" */
export type Subscriptions_Starred_Global_Swimmers_On_Conflict = {
  constraint: Subscriptions_Starred_Global_Swimmers_Constraint;
  update_columns?: Array<Subscriptions_Starred_Global_Swimmers_Update_Column>;
  where?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Bool_Exp>;
};

/** Ordering options when selecting data from "subscriptions.starred_global_swimmers". */
export type Subscriptions_Starred_Global_Swimmers_Order_By = {
  born?: InputMaybe<Order_By>;
  club?: InputMaybe<Order_By>;
  club_short_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  license?: InputMaybe<Order_By>;
  nation_code?: InputMaybe<Order_By>;
  subscriber?: InputMaybe<Subscriptions_Subscriber_Order_By>;
  subscriber_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscriptions.starred_global_swimmers */
export type Subscriptions_Starred_Global_Swimmers_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "subscriptions.starred_global_swimmers" */
export enum Subscriptions_Starred_Global_Swimmers_Select_Column {
  /** column name */
  Born = 'born',
  /** column name */
  Club = 'club',
  /** column name */
  ClubShortName = 'club_short_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  License = 'license',
  /** column name */
  NationCode = 'nation_code',
  /** column name */
  SubscriberId = 'subscriber_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "subscriptions.starred_global_swimmers" */
export type Subscriptions_Starred_Global_Swimmers_Set_Input = {
  born?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['String']['input']>;
  club_short_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['Int']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  nation_code?: InputMaybe<Scalars['String']['input']>;
  subscriber_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "subscriptions.starred_global_swimmers" */
export type Subscriptions_Starred_Global_Swimmers_Stddev_Order_By = {
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "subscriptions.starred_global_swimmers" */
export type Subscriptions_Starred_Global_Swimmers_Stddev_Pop_Order_By = {
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "subscriptions.starred_global_swimmers" */
export type Subscriptions_Starred_Global_Swimmers_Stddev_Samp_Order_By = {
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "subscriptions_starred_global_swimmers" */
export type Subscriptions_Starred_Global_Swimmers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscriptions_Starred_Global_Swimmers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscriptions_Starred_Global_Swimmers_Stream_Cursor_Value_Input = {
  born?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['String']['input']>;
  club_short_name?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  nation_code?: InputMaybe<Scalars['String']['input']>;
  subscriber_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "subscriptions.starred_global_swimmers" */
export type Subscriptions_Starred_Global_Swimmers_Sum_Order_By = {
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "subscriptions.starred_global_swimmers" */
export enum Subscriptions_Starred_Global_Swimmers_Update_Column {
  /** column name */
  Born = 'born',
  /** column name */
  Club = 'club',
  /** column name */
  ClubShortName = 'club_short_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  LastName = 'last_name',
  /** column name */
  License = 'license',
  /** column name */
  NationCode = 'nation_code',
  /** column name */
  SubscriberId = 'subscriber_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Subscriptions_Starred_Global_Swimmers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscriptions_Starred_Global_Swimmers_Bool_Exp;
};

/** order by var_pop() on columns of table "subscriptions.starred_global_swimmers" */
export type Subscriptions_Starred_Global_Swimmers_Var_Pop_Order_By = {
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "subscriptions.starred_global_swimmers" */
export type Subscriptions_Starred_Global_Swimmers_Var_Samp_Order_By = {
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "subscriptions.starred_global_swimmers" */
export type Subscriptions_Starred_Global_Swimmers_Variance_Order_By = {
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "subscriptions.subscriber" */
export type Subscriptions_Subscriber = {
  __typename?: 'subscriptions_subscriber';
  app_user_id: Scalars['String']['output'];
  expiration_date?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  is_active: Scalars['Boolean']['output'];
  /** An array relationship */
  starred_competition_swimmers: Array<Subscriptions_Starred_Competition_Swimmers>;
  /** An array relationship */
  starred_competitions: Array<Subscriptions_Starred_Competition>;
  /** An array relationship */
  starred_global_swimmers: Array<Subscriptions_Starred_Global_Swimmers>;
  /** An array relationship */
  subscriber_devices: Array<Subscriptions_Subscriber_Device>;
};


/** columns and relationships of "subscriptions.subscriber" */
export type Subscriptions_SubscriberStarred_Competition_SwimmersArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Starred_Competition_Swimmers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Starred_Competition_Swimmers_Order_By>>;
  where?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Bool_Exp>;
};


/** columns and relationships of "subscriptions.subscriber" */
export type Subscriptions_SubscriberStarred_CompetitionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Starred_Competition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Starred_Competition_Order_By>>;
  where?: InputMaybe<Subscriptions_Starred_Competition_Bool_Exp>;
};


/** columns and relationships of "subscriptions.subscriber" */
export type Subscriptions_SubscriberStarred_Global_SwimmersArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Starred_Global_Swimmers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Starred_Global_Swimmers_Order_By>>;
  where?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Bool_Exp>;
};


/** columns and relationships of "subscriptions.subscriber" */
export type Subscriptions_SubscriberSubscriber_DevicesArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Subscriber_Device_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Subscriber_Device_Order_By>>;
  where?: InputMaybe<Subscriptions_Subscriber_Device_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "subscriptions.subscriber". All fields are combined with a logical 'AND'. */
export type Subscriptions_Subscriber_Bool_Exp = {
  _and?: InputMaybe<Array<Subscriptions_Subscriber_Bool_Exp>>;
  _not?: InputMaybe<Subscriptions_Subscriber_Bool_Exp>;
  _or?: InputMaybe<Array<Subscriptions_Subscriber_Bool_Exp>>;
  app_user_id?: InputMaybe<String_Comparison_Exp>;
  expiration_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  starred_competition_swimmers?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Bool_Exp>;
  starred_competitions?: InputMaybe<Subscriptions_Starred_Competition_Bool_Exp>;
  starred_global_swimmers?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Bool_Exp>;
  subscriber_devices?: InputMaybe<Subscriptions_Subscriber_Device_Bool_Exp>;
};

/** columns and relationships of "subscriptions.subscriber_device" */
export type Subscriptions_Subscriber_Device = {
  __typename?: 'subscriptions_subscriber_device';
  app_version: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  device_id: Scalars['String']['output'];
  device_type: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  language: Scalars['String']['output'];
  os_version: Scalars['String']['output'];
  /** An object relationship */
  subscriber: Subscriptions_Subscriber;
  subscriber_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "subscriptions.subscriber_device" */
export type Subscriptions_Subscriber_Device_Aggregate_Order_By = {
  avg?: InputMaybe<Subscriptions_Subscriber_Device_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscriptions_Subscriber_Device_Max_Order_By>;
  min?: InputMaybe<Subscriptions_Subscriber_Device_Min_Order_By>;
  stddev?: InputMaybe<Subscriptions_Subscriber_Device_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Subscriptions_Subscriber_Device_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Subscriptions_Subscriber_Device_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Subscriptions_Subscriber_Device_Sum_Order_By>;
  var_pop?: InputMaybe<Subscriptions_Subscriber_Device_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Subscriptions_Subscriber_Device_Var_Samp_Order_By>;
  variance?: InputMaybe<Subscriptions_Subscriber_Device_Variance_Order_By>;
};

/** order by avg() on columns of table "subscriptions.subscriber_device" */
export type Subscriptions_Subscriber_Device_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "subscriptions.subscriber_device". All fields are combined with a logical 'AND'. */
export type Subscriptions_Subscriber_Device_Bool_Exp = {
  _and?: InputMaybe<Array<Subscriptions_Subscriber_Device_Bool_Exp>>;
  _not?: InputMaybe<Subscriptions_Subscriber_Device_Bool_Exp>;
  _or?: InputMaybe<Array<Subscriptions_Subscriber_Device_Bool_Exp>>;
  app_version?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  device_id?: InputMaybe<String_Comparison_Exp>;
  device_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  os_version?: InputMaybe<String_Comparison_Exp>;
  subscriber?: InputMaybe<Subscriptions_Subscriber_Bool_Exp>;
  subscriber_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscriptions.subscriber_device" */
export enum Subscriptions_Subscriber_Device_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriberDevicePkey = 'subscriber_device_pkey',
  /** unique or primary key constraint on columns "subscriber_id", "device_id" */
  SubscriberDeviceSubscriberIdDeviceIdKey = 'subscriber_device_subscriber_id_device_id_key'
}

/** input type for inserting data into table "subscriptions.subscriber_device" */
export type Subscriptions_Subscriber_Device_Insert_Input = {
  app_version?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  device_id?: InputMaybe<Scalars['String']['input']>;
  device_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  os_version?: InputMaybe<Scalars['String']['input']>;
  subscriber_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "subscriptions.subscriber_device" */
export type Subscriptions_Subscriber_Device_Max_Order_By = {
  app_version?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  device_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  os_version?: InputMaybe<Order_By>;
  subscriber_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "subscriptions.subscriber_device" */
export type Subscriptions_Subscriber_Device_Min_Order_By = {
  app_version?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  device_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  os_version?: InputMaybe<Order_By>;
  subscriber_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscriptions.subscriber_device" */
export type Subscriptions_Subscriber_Device_Mutation_Response = {
  __typename?: 'subscriptions_subscriber_device_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscriptions_Subscriber_Device>;
};

/** on_conflict condition type for table "subscriptions.subscriber_device" */
export type Subscriptions_Subscriber_Device_On_Conflict = {
  constraint: Subscriptions_Subscriber_Device_Constraint;
  update_columns?: Array<Subscriptions_Subscriber_Device_Update_Column>;
  where?: InputMaybe<Subscriptions_Subscriber_Device_Bool_Exp>;
};

/** Ordering options when selecting data from "subscriptions.subscriber_device". */
export type Subscriptions_Subscriber_Device_Order_By = {
  app_version?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_id?: InputMaybe<Order_By>;
  device_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  os_version?: InputMaybe<Order_By>;
  subscriber?: InputMaybe<Subscriptions_Subscriber_Order_By>;
  subscriber_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscriptions.subscriber_device */
export type Subscriptions_Subscriber_Device_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "subscriptions.subscriber_device" */
export enum Subscriptions_Subscriber_Device_Select_Column {
  /** column name */
  AppVersion = 'app_version',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DeviceType = 'device_type',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  OsVersion = 'os_version',
  /** column name */
  SubscriberId = 'subscriber_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "subscriptions.subscriber_device" */
export type Subscriptions_Subscriber_Device_Set_Input = {
  app_version?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  device_id?: InputMaybe<Scalars['String']['input']>;
  device_type?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  os_version?: InputMaybe<Scalars['String']['input']>;
  subscriber_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "subscriptions.subscriber_device" */
export type Subscriptions_Subscriber_Device_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "subscriptions.subscriber_device" */
export type Subscriptions_Subscriber_Device_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "subscriptions.subscriber_device" */
export type Subscriptions_Subscriber_Device_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "subscriptions_subscriber_device" */
export type Subscriptions_Subscriber_Device_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscriptions_Subscriber_Device_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscriptions_Subscriber_Device_Stream_Cursor_Value_Input = {
  app_version?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  device_id?: InputMaybe<Scalars['String']['input']>;
  device_type?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  os_version?: InputMaybe<Scalars['String']['input']>;
  subscriber_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "subscriptions.subscriber_device" */
export type Subscriptions_Subscriber_Device_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "subscriptions.subscriber_device" */
export enum Subscriptions_Subscriber_Device_Update_Column {
  /** column name */
  AppVersion = 'app_version',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceId = 'device_id',
  /** column name */
  DeviceType = 'device_type',
  /** column name */
  Language = 'language',
  /** column name */
  OsVersion = 'os_version',
  /** column name */
  SubscriberId = 'subscriber_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Subscriptions_Subscriber_Device_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscriptions_Subscriber_Device_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscriptions_Subscriber_Device_Bool_Exp;
};

/** order by var_pop() on columns of table "subscriptions.subscriber_device" */
export type Subscriptions_Subscriber_Device_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "subscriptions.subscriber_device" */
export type Subscriptions_Subscriber_Device_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "subscriptions.subscriber_device" */
export type Subscriptions_Subscriber_Device_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "subscriptions.subscriber". */
export type Subscriptions_Subscriber_Order_By = {
  app_user_id?: InputMaybe<Order_By>;
  expiration_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  starred_competition_swimmers_aggregate?: InputMaybe<Subscriptions_Starred_Competition_Swimmers_Aggregate_Order_By>;
  starred_competitions_aggregate?: InputMaybe<Subscriptions_Starred_Competition_Aggregate_Order_By>;
  starred_global_swimmers_aggregate?: InputMaybe<Subscriptions_Starred_Global_Swimmers_Aggregate_Order_By>;
  subscriber_devices_aggregate?: InputMaybe<Subscriptions_Subscriber_Device_Aggregate_Order_By>;
};

/** select columns of table "subscriptions.subscriber" */
export enum Subscriptions_Subscriber_Select_Column {
  /** column name */
  AppUserId = 'app_user_id',
  /** column name */
  ExpirationDate = 'expiration_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active'
}

/** Streaming cursor of the table "subscriptions_subscriber" */
export type Subscriptions_Subscriber_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscriptions_Subscriber_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscriptions_Subscriber_Stream_Cursor_Value_Input = {
  app_user_id?: InputMaybe<Scalars['String']['input']>;
  expiration_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "summary_type" */
export type Summary_Type = {
  __typename?: 'summary_type';
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  hidden: Scalars['Boolean']['output'];
  hide_q: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  oid: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  rank_type: Scalars['Int']['output'];
  /** An array relationship */
  ranks: Array<Rank>;
  ranks_count: Scalars['Int']['output'];
  /** An object relationship */
  round?: Maybe<Round>;
  round_oid: Scalars['Int']['output'];
  sort_by_name: Scalars['Boolean']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "summary_type" */
export type Summary_TypeRanksArgs = {
  distinct_on?: InputMaybe<Array<Rank_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rank_Order_By>>;
  where?: InputMaybe<Rank_Bool_Exp>;
};

/** order by aggregate values of table "summary_type" */
export type Summary_Type_Aggregate_Order_By = {
  avg?: InputMaybe<Summary_Type_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Summary_Type_Max_Order_By>;
  min?: InputMaybe<Summary_Type_Min_Order_By>;
  stddev?: InputMaybe<Summary_Type_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Summary_Type_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Summary_Type_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Summary_Type_Sum_Order_By>;
  var_pop?: InputMaybe<Summary_Type_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Summary_Type_Var_Samp_Order_By>;
  variance?: InputMaybe<Summary_Type_Variance_Order_By>;
};

/** order by avg() on columns of table "summary_type" */
export type Summary_Type_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  rank_type?: InputMaybe<Order_By>;
  ranks_count?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "summary_type". All fields are combined with a logical 'AND'. */
export type Summary_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Summary_Type_Bool_Exp>>;
  _not?: InputMaybe<Summary_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Summary_Type_Bool_Exp>>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  hidden?: InputMaybe<Boolean_Comparison_Exp>;
  hide_q?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  oid?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  rank_type?: InputMaybe<Int_Comparison_Exp>;
  ranks?: InputMaybe<Rank_Bool_Exp>;
  ranks_count?: InputMaybe<Int_Comparison_Exp>;
  round?: InputMaybe<Round_Bool_Exp>;
  round_oid?: InputMaybe<Int_Comparison_Exp>;
  sort_by_name?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "summary_type" */
export type Summary_Type_Max_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  rank_type?: InputMaybe<Order_By>;
  ranks_count?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "summary_type" */
export type Summary_Type_Min_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  rank_type?: InputMaybe<Order_By>;
  ranks_count?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "summary_type". */
export type Summary_Type_Order_By = {
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  hidden?: InputMaybe<Order_By>;
  hide_q?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  rank_type?: InputMaybe<Order_By>;
  ranks_aggregate?: InputMaybe<Rank_Aggregate_Order_By>;
  ranks_count?: InputMaybe<Order_By>;
  round?: InputMaybe<Round_Order_By>;
  round_oid?: InputMaybe<Order_By>;
  sort_by_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "summary_type" */
export enum Summary_Type_Select_Column {
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  HideQ = 'hide_q',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Oid = 'oid',
  /** column name */
  Order = 'order',
  /** column name */
  RankType = 'rank_type',
  /** column name */
  RanksCount = 'ranks_count',
  /** column name */
  RoundOid = 'round_oid',
  /** column name */
  SortByName = 'sort_by_name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "summary_type" */
export type Summary_Type_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  rank_type?: InputMaybe<Order_By>;
  ranks_count?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "summary_type" */
export type Summary_Type_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  rank_type?: InputMaybe<Order_By>;
  ranks_count?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "summary_type" */
export type Summary_Type_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  rank_type?: InputMaybe<Order_By>;
  ranks_count?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "summary_type" */
export type Summary_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Summary_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Summary_Type_Stream_Cursor_Value_Input = {
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  hide_q?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oid?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  rank_type?: InputMaybe<Scalars['Int']['input']>;
  ranks_count?: InputMaybe<Scalars['Int']['input']>;
  round_oid?: InputMaybe<Scalars['Int']['input']>;
  sort_by_name?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "summary_type" */
export type Summary_Type_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  rank_type?: InputMaybe<Order_By>;
  ranks_count?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "summary_type" */
export type Summary_Type_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  rank_type?: InputMaybe<Order_By>;
  ranks_count?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "summary_type" */
export type Summary_Type_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  rank_type?: InputMaybe<Order_By>;
  ranks_count?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "summary_type" */
export type Summary_Type_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  rank_type?: InputMaybe<Order_By>;
  ranks_count?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
};

/** columns and relationships of "time_program_entry" */
export type Time_Program_Entry = {
  __typename?: 'time_program_entry';
  /** An object relationship */
  competition: Competitions;
  competition_id: Scalars['uuid']['output'];
  /** An object relationship */
  competition_session?: Maybe<Competition_Session>;
  competition_session_oid: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  heats: Array<Heat>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  oid: Scalars['Int']['output'];
  /** An object relationship */
  round?: Maybe<Round>;
  round_oid?: Maybe<Scalars['Int']['output']>;
  sort_order: Scalars['Int']['output'];
  start_time: Scalars['timestamptz']['output'];
  stop_time: Scalars['timestamptz']['output'];
  type: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "time_program_entry" */
export type Time_Program_EntryHeatsArgs = {
  distinct_on?: InputMaybe<Array<Heat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Heat_Order_By>>;
  where?: InputMaybe<Heat_Bool_Exp>;
};

/** order by aggregate values of table "time_program_entry" */
export type Time_Program_Entry_Aggregate_Order_By = {
  avg?: InputMaybe<Time_Program_Entry_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Time_Program_Entry_Max_Order_By>;
  min?: InputMaybe<Time_Program_Entry_Min_Order_By>;
  stddev?: InputMaybe<Time_Program_Entry_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Time_Program_Entry_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Time_Program_Entry_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Time_Program_Entry_Sum_Order_By>;
  var_pop?: InputMaybe<Time_Program_Entry_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Time_Program_Entry_Var_Samp_Order_By>;
  variance?: InputMaybe<Time_Program_Entry_Variance_Order_By>;
};

/** order by avg() on columns of table "time_program_entry" */
export type Time_Program_Entry_Avg_Order_By = {
  competition_session_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "time_program_entry". All fields are combined with a logical 'AND'. */
export type Time_Program_Entry_Bool_Exp = {
  _and?: InputMaybe<Array<Time_Program_Entry_Bool_Exp>>;
  _not?: InputMaybe<Time_Program_Entry_Bool_Exp>;
  _or?: InputMaybe<Array<Time_Program_Entry_Bool_Exp>>;
  competition?: InputMaybe<Competitions_Bool_Exp>;
  competition_id?: InputMaybe<Uuid_Comparison_Exp>;
  competition_session?: InputMaybe<Competition_Session_Bool_Exp>;
  competition_session_oid?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  heats?: InputMaybe<Heat_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  oid?: InputMaybe<Int_Comparison_Exp>;
  round?: InputMaybe<Round_Bool_Exp>;
  round_oid?: InputMaybe<Int_Comparison_Exp>;
  sort_order?: InputMaybe<Int_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  stop_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  type?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** order by max() on columns of table "time_program_entry" */
export type Time_Program_Entry_Max_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  competition_session_oid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  stop_time?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "time_program_entry" */
export type Time_Program_Entry_Min_Order_By = {
  competition_id?: InputMaybe<Order_By>;
  competition_session_oid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  stop_time?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "time_program_entry". */
export type Time_Program_Entry_Order_By = {
  competition?: InputMaybe<Competitions_Order_By>;
  competition_id?: InputMaybe<Order_By>;
  competition_session?: InputMaybe<Competition_Session_Order_By>;
  competition_session_oid?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  heats_aggregate?: InputMaybe<Heat_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  round?: InputMaybe<Round_Order_By>;
  round_oid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  stop_time?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "time_program_entry" */
export enum Time_Program_Entry_Select_Column {
  /** column name */
  CompetitionId = 'competition_id',
  /** column name */
  CompetitionSessionOid = 'competition_session_oid',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Oid = 'oid',
  /** column name */
  RoundOid = 'round_oid',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  StopTime = 'stop_time',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "time_program_entry" */
export type Time_Program_Entry_Stddev_Order_By = {
  competition_session_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "time_program_entry" */
export type Time_Program_Entry_Stddev_Pop_Order_By = {
  competition_session_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "time_program_entry" */
export type Time_Program_Entry_Stddev_Samp_Order_By = {
  competition_session_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "time_program_entry" */
export type Time_Program_Entry_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Time_Program_Entry_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Time_Program_Entry_Stream_Cursor_Value_Input = {
  competition_id?: InputMaybe<Scalars['uuid']['input']>;
  competition_session_oid?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oid?: InputMaybe<Scalars['Int']['input']>;
  round_oid?: InputMaybe<Scalars['Int']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  start_time?: InputMaybe<Scalars['timestamptz']['input']>;
  stop_time?: InputMaybe<Scalars['timestamptz']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "time_program_entry" */
export type Time_Program_Entry_Sum_Order_By = {
  competition_session_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "time_program_entry" */
export type Time_Program_Entry_Var_Pop_Order_By = {
  competition_session_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "time_program_entry" */
export type Time_Program_Entry_Var_Samp_Order_By = {
  competition_session_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "time_program_entry" */
export type Time_Program_Entry_Variance_Order_By = {
  competition_session_oid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  oid?: InputMaybe<Order_By>;
  round_oid?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type CompetitionsSince2024QueryVariables = Exact<{
  endDate: Scalars['date']['input'];
}>;


export type CompetitionsSince2024Query = { __typename?: 'query_root', competitions: Array<{ __typename?: 'competitions', city?: string | null, created_at: any, endDate: any, id: any, name: string, nation_code?: string | null, organizer?: string | null, pool_name?: string | null, pool_type: number, seo_text: string, startDate: any, superlive: boolean, updated_at: any }> };

export type CurrentHeatSubscription_WlSubscriptionVariables = Exact<{
  cid?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type CurrentHeatSubscription_WlSubscription = { __typename?: 'subscription_root', current_heat: Array<{ __typename?: 'current_heat', id: number, heat?: { __typename?: 'heat', id: number, number: number, round?: { __typename?: 'round', id: number, status: number, event?: { __typename?: 'events', id: number, number: number } | null } | null } | null, time_program_entry?: { __typename?: 'time_program_entry', id: number, oid: number, name: string, competition_session?: { __typename?: 'competition_session', id: number, oid: number, name: string, number: number } | null } | null }> };

export type CompetitionStatusSubscriptionVariables = Exact<{
  cid: Scalars['uuid']['input'];
}>;


export type CompetitionStatusSubscription = { __typename?: 'subscription_root', competitions_by_pk?: { __typename?: 'competitions', id: any, competition_sessions: Array<{ __typename?: 'competition_session', id: number, oid: number, time_program_entries: Array<{ __typename?: 'time_program_entry', id: number, oid: number, round?: { __typename?: 'round', id: number, oid: number, status: number } | null }> }> } | null };

export type CurrentHeatDataSubscriptionSubscriptionVariables = Exact<{
  currentHeatId: Scalars['Int']['input'];
}>;


export type CurrentHeatDataSubscriptionSubscription = { __typename?: 'subscription_root', heat_by_pk?: { __typename?: 'heat', estimated_start_time: any, id: number, name: string, number: number, oid: number, priority: number, round_oid: number, start_time: any, status: number, lanes: Array<{ __typename?: 'lane', checked: boolean, competitor_oid?: number | null, dnf: boolean, dns: boolean, dq_code?: string | null, dq_description?: string | null, dq_relay_swimmer: number, dsq: boolean, entry_pool: number, entry_time_text: string, fina_points: number, heat_rank?: number | null, id: number, note: string, number: number, oid: number, qualification: string, reaction_time?: string | null, relay_age: number, result_text: string, swimmed_distance: number, total_rank?: number | null, wps_points: number, sub_results: Array<{ __typename?: 'sub_results', done_at: number, id: any, lane_oid: number, oid: number, order: number, relay_competitor_order: number, result_value_text: string, split_diff_text: string, take_over: string }> }> } | null };

export type CompetitionIdQuery_WlQueryVariables = Exact<{
  navigationCID?: InputMaybe<Scalars['String']['input']>;
}>;


export type CompetitionIdQuery_WlQuery = { __typename?: 'query_root', competitions: Array<{ __typename: 'competitions', id: any }> };

export type ClubNamesFragment = { __typename?: 'clubs', name: string, short_name: string, country_code: string } & { ' $fragmentName'?: 'ClubNamesFragment' };

export type ClubCompetitorsQueryVariables = Exact<{
  cid: Scalars['uuid']['input'];
  club_name?: InputMaybe<Scalars['String']['input']>;
}>;


export type ClubCompetitorsQuery = { __typename?: 'query_root', clubs: Array<(
    { __typename?: 'clubs', competitors: Array<(
      { __typename?: 'competitor' }
      & { ' $fragmentRefs'?: { 'CompetitorDataFragment': CompetitorDataFragment } }
    )> }
    & { ' $fragmentRefs'?: { 'ClubNamesFragment': ClubNamesFragment } }
  )> };

export type GetClubNamesQueryVariables = Exact<{
  cid: Scalars['uuid']['input'];
}>;


export type GetClubNamesQuery = { __typename?: 'query_root', clubs: Array<(
    { __typename?: 'clubs', competitors_aggregate: { __typename?: 'competitor_aggregate', aggregate?: { __typename?: 'competitor_aggregate_fields', count: number } | null } }
    & { ' $fragmentRefs'?: { 'ClubNamesFragment': ClubNamesFragment } }
  )> };

export type CompetitionsDataQueryVariables = Exact<{
  cid: Scalars['uuid']['input'];
}>;


export type CompetitionsDataQuery = { __typename?: 'query_root', competitions_by_pk?: { __typename?: 'competitions', endDate: any, id: any, locked: boolean, manual_live_sort_order: number, name: string, nation_code?: string | null, organizer?: string | null, city?: string | null, pool_name?: string | null, pool_type: number, seo_text: string, show_age: boolean, startDate: any, superlive: boolean, updated_at: any, events: Array<{ __typename?: 'events', athlete_count: number, competition_id: any, created_at?: any | null, distance: number, event_competition_level: number, event_type: number, gender_number: number, hidden?: boolean | null, id: number, is_masters_event: boolean, is_para_event: boolean, is_relay: boolean, max_age: number, min_age: number, name: string, number: number, oid: number, sponsor_oid?: number | null, updated_at?: any | null, use_pre_masters: boolean, agegroups: Array<{ __typename?: 'agegroup', competition_id: any, created_at: any, event_oid: number, from_age: number, id: number, name: string, number: number, oid: number, to_age: number, updated_at: any }> }>, competition_sessions: Array<{ __typename?: 'competition_session', competition_id: any, created_at?: any | null, day: number, id: number, name: string, number: number, oid: number, start_time: any, superlive_seo_link?: string | null, updated_at?: any | null, time_program_entries: Array<{ __typename?: 'time_program_entry', competition_id: any, competition_session_oid: number, created_at?: any | null, id: number, name: string, oid: number, round_oid?: number | null, sort_order: number, start_time: any, stop_time: any, type: number, updated_at?: any | null, round?: { __typename?: 'round', competition_id: any, created_at?: any | null, event_oid: number, id: number, name: string, official_at?: any | null, oid: number, round_type: number, sort_order: number, status: number, updated_at?: any | null } | null }> }>, file_archives: Array<{ __typename?: 'file_archive', category_type: number, competition_id: any, competition_session_oid?: number | null, created_at?: any | null, description?: string | null, id: any, link?: string | null, name: string, order: number, round_oid?: number | null, updated_at?: any | null, visible: boolean }>, competitors: Array<{ __typename?: 'competitor', age: number, birthday: any, club_oid: number, code: string, competition_id: any, country_code: string, created_at?: any | null, first_name: string, full_name?: string | null, full_name_reversed?: string | null, gender_number: number, id: number, is_para: boolean, is_relay: boolean, last_name: string, oid: number, para_class_breast?: string | null, para_class_free?: string | null, para_class_medley?: string | null, updated_at?: any | null }>, clubs: Array<{ __typename?: 'clubs', city: string, code: string, competition_id: any, country_code: string, country_name: string, id: number, name: string, oid: number, region_name: string, short_name: string }> } | null };

export type EventsQueryVariables = Exact<{
  cid: Scalars['uuid']['input'];
  event: Scalars['Int']['input'];
}>;


export type EventsQuery = { __typename?: 'query_root', events: Array<(
    { __typename?: 'events', entry_list_types: Array<(
      { __typename?: 'entry_list_type', entry_ranks: Array<(
        { __typename?: 'entry_rank', entry?: (
          { __typename?: 'entry', competitor?: (
            { __typename?: 'competitor', club?: (
              { __typename?: 'clubs' }
              & { ' $fragmentRefs'?: { 'ClubNamesFragment': ClubNamesFragment } }
            ) | null, relay_competitors: Array<{ __typename?: 'relay_competitor', competition_id: any, competitor_oid?: number | null, created_at: any, entry_oid?: number | null, id: number, lane_oid?: number | null, oid: number, order: number, updated_at: any }> }
            & { ' $fragmentRefs'?: { 'CompetitorDataFragment': CompetitorDataFragment } }
          ) | null }
          & { ' $fragmentRefs'?: { 'EntryDataFragment': EntryDataFragment } }
        ) | null }
        & { ' $fragmentRefs'?: { 'EntryRankDataFragment': EntryRankDataFragment } }
      )> }
      & { ' $fragmentRefs'?: { 'EntryListTypeDataFragment': EntryListTypeDataFragment } }
    )>, rounds: Array<(
      { __typename?: 'round', summary_types: Array<(
        { __typename?: 'summary_type', ranks: Array<(
          { __typename?: 'rank', lane?: (
            { __typename?: 'lane', competitor?: (
              { __typename?: 'competitor', club?: (
                { __typename?: 'clubs' }
                & { ' $fragmentRefs'?: { 'ClubNamesFragment': ClubNamesFragment } }
              ) | null, relay_competitors: Array<{ __typename?: 'relay_competitor', competition_id: any, competitor_oid?: number | null, created_at: any, entry_oid?: number | null, id: number, lane_oid?: number | null, oid: number, order: number, updated_at: any }> }
              & { ' $fragmentRefs'?: { 'CompetitorDataFragment': CompetitorDataFragment } }
            ) | null, heat?: (
              { __typename?: 'heat' }
              & { ' $fragmentRefs'?: { 'HeatDataFragment': HeatDataFragment } }
            ) | null }
            & { ' $fragmentRefs'?: { 'LaneDataFragment': LaneDataFragment } }
          ) | null }
          & { ' $fragmentRefs'?: { 'RankDataFragment': RankDataFragment } }
        )> }
        & { ' $fragmentRefs'?: { 'SummaryTypeDataFragment': SummaryTypeDataFragment } }
      )>, heats: Array<(
        { __typename?: 'heat', time_program_entry_oid?: number | null, lanes: Array<(
          { __typename?: 'lane', sub_results: Array<{ __typename?: 'sub_results', done_at: number, result_value_text: string }>, competitor?: (
            { __typename?: 'competitor', club?: (
              { __typename?: 'clubs' }
              & { ' $fragmentRefs'?: { 'ClubNamesFragment': ClubNamesFragment } }
            ) | null, relay_competitors: Array<{ __typename?: 'relay_competitor', competition_id: any, competitor_oid?: number | null, created_at: any, entry_oid?: number | null, id: number, lane_oid?: number | null, oid: number, order: number, updated_at: any }> }
            & { ' $fragmentRefs'?: { 'CompetitorDataFragment': CompetitorDataFragment } }
          ) | null }
          & { ' $fragmentRefs'?: { 'LaneDataFragment': LaneDataFragment } }
        )> }
        & { ' $fragmentRefs'?: { 'HeatDataFragment': HeatDataFragment } }
      )> }
      & { ' $fragmentRefs'?: { 'RoundDataFragment': RoundDataFragment } }
    )> }
    & { ' $fragmentRefs'?: { 'EventDataFragment': EventDataFragment } }
  )> };

export type CompetitorDataFragment = { __typename?: 'competitor', id: number, oid: number, full_name?: string | null, birthday: any, first_name: string, last_name: string, gender_number: number, country_code: string } & { ' $fragmentName'?: 'CompetitorDataFragment' };

export type CompetitorsQueryVariables = Exact<{
  cid: Scalars['uuid']['input'];
}>;


export type CompetitorsQuery = { __typename?: 'query_root', competitor: Array<(
    { __typename?: 'competitor', club?: (
      { __typename?: 'clubs' }
      & { ' $fragmentRefs'?: { 'ClubNamesFragment': ClubNamesFragment } }
    ) | null }
    & { ' $fragmentRefs'?: { 'CompetitorDataFragment': CompetitorDataFragment } }
  )> };

export type ProgramItemDataFragment = { __typename?: 'time_program_entry', id: number, oid: number, round_oid?: number | null, sort_order: number, start_time: any, stop_time: any, type: number, name: string } & { ' $fragmentName'?: 'ProgramItemDataFragment' };

export type RoundDataFragment = { __typename?: 'round', id: number, oid: number, event_oid: number, name: string, official_at?: any | null, round_type: number, sort_order: number, status: number } & { ' $fragmentName'?: 'RoundDataFragment' };

export type SummaryTypeDataFragment = { __typename?: 'summary_type', id: number, oid: number, order: number, rank_type: number, ranks_count: number, round_oid: number, sort_by_name: boolean, name: string } & { ' $fragmentName'?: 'SummaryTypeDataFragment' };

export type RankDataFragment = { __typename?: 'rank', id: number, rank: number, type: number } & { ' $fragmentName'?: 'RankDataFragment' };

export type LaneDataFragment = { __typename?: 'lane', id: number, competitor_oid?: number | null, dnf: boolean, dns: boolean, dq_code?: string | null, dq_description?: string | null, dq_relay_swimmer: number, dsq: boolean, entry_time_text: string, fina_points: number, heat_rank?: number | null, not_in_competition: boolean, note: string, number: number, oid: number, qualification: string, reaction_time?: string | null, result_text: string, swimmed_distance: number, total_rank?: number | null } & { ' $fragmentName'?: 'LaneDataFragment' };

export type HeatDataFragment = { __typename?: 'heat', id: number, oid: number, name: string, number: number, start_time: any, estimated_start_time: any, status: number } & { ' $fragmentName'?: 'HeatDataFragment' };

export type EventDataFragment = { __typename?: 'events', id: number, oid: number, athlete_count: number, distance: number, event_type: number, gender_number: number, hidden?: boolean | null, is_masters_event: boolean, is_para_event: boolean, is_relay: boolean, name: string, number: number } & { ' $fragmentName'?: 'EventDataFragment' };

export type EntryDataFragment = { __typename?: 'entry', id: number, auto_withdrawn: boolean, entry_time_text: string, late_entry: boolean, not_in_competition: boolean, ranking: number, withdrawn: boolean, reserve: boolean } & { ' $fragmentName'?: 'EntryDataFragment' };

export type EntryRankDataFragment = { __typename?: 'entry_rank', id: number, oid: number, rank: number, entry_rank_type: number } & { ' $fragmentName'?: 'EntryRankDataFragment' };

export type EntryListTypeDataFragment = { __typename?: 'entry_list_type', id: number, oid: number, name: string, sort_by_name: boolean, order: number, entries_count: number } & { ' $fragmentName'?: 'EntryListTypeDataFragment' };

export type TimeProgramEntryDataQueryVariables = Exact<{
  programItemId: Scalars['Int']['input'];
}>;


export type TimeProgramEntryDataQuery = { __typename?: 'query_root', time_program_entry_by_pk?: (
    { __typename?: 'time_program_entry', round?: (
      { __typename?: 'round', status: number, summary_types: Array<(
        { __typename?: 'summary_type', ranks: Array<(
          { __typename?: 'rank', lane?: (
            { __typename?: 'lane', heat?: (
              { __typename?: 'heat' }
              & { ' $fragmentRefs'?: { 'HeatDataFragment': HeatDataFragment } }
            ) | null, competitor?: (
              { __typename?: 'competitor', club?: (
                { __typename?: 'clubs' }
                & { ' $fragmentRefs'?: { 'ClubNamesFragment': ClubNamesFragment } }
              ) | null }
              & { ' $fragmentRefs'?: { 'CompetitorDataFragment': CompetitorDataFragment } }
            ) | null }
            & { ' $fragmentRefs'?: { 'LaneDataFragment': LaneDataFragment } }
          ) | null }
          & { ' $fragmentRefs'?: { 'RankDataFragment': RankDataFragment } }
        )> }
        & { ' $fragmentRefs'?: { 'SummaryTypeDataFragment': SummaryTypeDataFragment } }
      )>, event?: (
        { __typename?: 'events', entry_list_types: Array<(
          { __typename?: 'entry_list_type', entry_ranks: Array<(
            { __typename?: 'entry_rank', entry?: (
              { __typename?: 'entry', competitor?: (
                { __typename?: 'competitor', club?: (
                  { __typename?: 'clubs' }
                  & { ' $fragmentRefs'?: { 'ClubNamesFragment': ClubNamesFragment } }
                ) | null, relay_competitors: Array<{ __typename?: 'relay_competitor', competition_id: any, competitor_oid?: number | null, created_at: any, entry_oid?: number | null, id: number, lane_oid?: number | null, oid: number, order: number, updated_at: any }> }
                & { ' $fragmentRefs'?: { 'CompetitorDataFragment': CompetitorDataFragment } }
              ) | null }
              & { ' $fragmentRefs'?: { 'EntryDataFragment': EntryDataFragment } }
            ) | null }
            & { ' $fragmentRefs'?: { 'EntryRankDataFragment': EntryRankDataFragment } }
          )> }
          & { ' $fragmentRefs'?: { 'EntryListTypeDataFragment': EntryListTypeDataFragment } }
        )> }
        & { ' $fragmentRefs'?: { 'EventDataFragment': EventDataFragment } }
      ) | null }
      & { ' $fragmentRefs'?: { 'RoundDataFragment': RoundDataFragment } }
    ) | null, heats: Array<(
      { __typename?: 'heat', lanes: Array<(
        { __typename?: 'lane', competitor?: (
          { __typename?: 'competitor', club?: (
            { __typename?: 'clubs' }
            & { ' $fragmentRefs'?: { 'ClubNamesFragment': ClubNamesFragment } }
          ) | null, relay_competitors: Array<{ __typename?: 'relay_competitor', competition_id: any, competitor_oid?: number | null, created_at: any, entry_oid?: number | null, id: number, lane_oid?: number | null, oid: number, order: number, updated_at: any }> }
          & { ' $fragmentRefs'?: { 'CompetitorDataFragment': CompetitorDataFragment } }
        ) | null }
        & { ' $fragmentRefs'?: { 'LaneDataFragment': LaneDataFragment } }
      )> }
      & { ' $fragmentRefs'?: { 'HeatDataFragment': HeatDataFragment } }
    )> }
    & { ' $fragmentRefs'?: { 'ProgramItemDataFragment': ProgramItemDataFragment } }
  ) | null };

export type CompetitorDetailsQueryVariables = Exact<{
  cid: Scalars['uuid']['input'];
  full_name: Scalars['String']['input'];
  age: Scalars['Int']['input'];
}>;


export type CompetitorDetailsQuery = { __typename?: 'query_root', competitor: Array<(
    { __typename?: 'competitor', club?: (
      { __typename?: 'clubs' }
      & { ' $fragmentRefs'?: { 'ClubNamesFragment': ClubNamesFragment } }
    ) | null, entries: Array<(
      { __typename?: 'entry', entry_ranks: Array<(
        { __typename?: 'entry_rank', entry_list_type?: (
          { __typename?: 'entry_list_type' }
          & { ' $fragmentRefs'?: { 'EntryListTypeDataFragment': EntryListTypeDataFragment } }
        ) | null }
        & { ' $fragmentRefs'?: { 'EntryRankDataFragment': EntryRankDataFragment } }
      )>, event?: (
        { __typename?: 'events' }
        & { ' $fragmentRefs'?: { 'EventDataFragment': EventDataFragment } }
      ) | null, relay_competitors: Array<{ __typename?: 'relay_competitor', competition_id: any, competitor_oid?: number | null, created_at: any, entry_oid?: number | null, id: number, lane_oid?: number | null, oid: number, order: number, updated_at: any, competitor?: { __typename?: 'competitor', id: number, oid: number, full_name?: string | null, first_name: string, last_name: string, birthday: any, age: number } | null }> }
      & { ' $fragmentRefs'?: { 'EntryDataFragment': EntryDataFragment } }
    )>, lanes: Array<(
      { __typename?: 'lane', result_text: string, fina_points: number, wps_points: number, sub_results: Array<{ __typename?: 'sub_results', done_at: number, id: any, oid: number, order: number, relay_competitor_order: number, result_value_text: string, split_diff_text: string, take_over: string }>, heat?: (
        { __typename?: 'heat', time_program_entry_oid?: number | null, round?: (
          { __typename?: 'round', event?: (
            { __typename?: 'events' }
            & { ' $fragmentRefs'?: { 'EventDataFragment': EventDataFragment } }
          ) | null }
          & { ' $fragmentRefs'?: { 'RoundDataFragment': RoundDataFragment } }
        ) | null }
        & { ' $fragmentRefs'?: { 'HeatDataFragment': HeatDataFragment } }
      ) | null, ranks: Array<(
        { __typename?: 'rank', summary_type?: (
          { __typename?: 'summary_type', round?: (
            { __typename?: 'round' }
            & { ' $fragmentRefs'?: { 'RoundDataFragment': RoundDataFragment } }
          ) | null }
          & { ' $fragmentRefs'?: { 'SummaryTypeDataFragment': SummaryTypeDataFragment } }
        ) | null }
        & { ' $fragmentRefs'?: { 'RankDataFragment': RankDataFragment } }
      )> }
      & { ' $fragmentRefs'?: { 'LaneDataFragment': LaneDataFragment } }
    )> }
    & { ' $fragmentRefs'?: { 'CompetitorDataFragment': CompetitorDataFragment } }
  )> };

export type CompetitorCompetitionsQueryVariables = Exact<{
  full_name: Scalars['String']['input'];
}>;


export type CompetitorCompetitionsQuery = { __typename?: 'query_root', competitor: Array<{ __typename?: 'competitor', age: number, birthday: any, competition_id: any, id: number, full_name?: string | null, country_code: string, club?: { __typename?: 'clubs', id: number, name: string } | null, competition: { __typename?: 'competitions', name: string, startDate: any, endDate: any, seo_text: string } }> };

export type CompetitorResultsQueryVariables = Exact<{
  competitor_id: Scalars['Int']['input'];
  competition_id: Scalars['uuid']['input'];
  event_type: Scalars['Int']['input'];
  distance: Scalars['Int']['input'];
}>;


export type CompetitorResultsQuery = { __typename?: 'query_root', lane: Array<{ __typename?: 'lane', id: number, competition_id: any, result_text: string, qualification: string, dns: boolean, dsq: boolean, dnf: boolean, dq_code?: string | null, dq_description?: string | null, heat_rank?: number | null, reaction_time?: string | null, total_rank?: number | null, entry_pool: number, heat?: { __typename?: 'heat', round?: { __typename?: 'round', event?: { __typename?: 'events', number: number } | null } | null } | null, sub_results: Array<{ __typename?: 'sub_results', done_at: number, order: number, result_value_text: string }> }> };

export type CompetitionsQueryVariables = Exact<{
  startDate: Scalars['date']['input'];
  endDate: Scalars['date']['input'];
}>;


export type CompetitionsQuery = { __typename?: 'query_root', competitions: Array<{ __typename?: 'competitions', city?: string | null, created_at: any, endDate: any, id: any, name: string, nation_code?: string | null, organizer?: string | null, pool_name?: string | null, pool_type: number, seo_text: string, startDate: any, superlive: boolean, updated_at: any }> };

export const ClubNamesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClubNames"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"clubs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]} as unknown as DocumentNode<ClubNamesFragment, unknown>;
export const CompetitorDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompetitorData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"competitor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender_number"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]} as unknown as DocumentNode<CompetitorDataFragment, unknown>;
export const ProgramItemDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgramItemData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"time_program_entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"round_oid"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}},{"kind":"Field","name":{"kind":"Name","value":"start_time"}},{"kind":"Field","name":{"kind":"Name","value":"stop_time"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ProgramItemDataFragment, unknown>;
export const RoundDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoundData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"round"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"event_oid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"official_at"}},{"kind":"Field","name":{"kind":"Name","value":"round_type"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<RoundDataFragment, unknown>;
export const SummaryTypeDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SummaryTypeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"summary_type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"rank_type"}},{"kind":"Field","name":{"kind":"Name","value":"ranks_count"}},{"kind":"Field","name":{"kind":"Name","value":"round_oid"}},{"kind":"Field","name":{"kind":"Name","value":"sort_by_name"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<SummaryTypeDataFragment, unknown>;
export const RankDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RankData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"rank"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<RankDataFragment, unknown>;
export const LaneDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LaneData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lane"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"competitor_oid"}},{"kind":"Field","name":{"kind":"Name","value":"dnf"}},{"kind":"Field","name":{"kind":"Name","value":"dns"}},{"kind":"Field","name":{"kind":"Name","value":"dq_code"}},{"kind":"Field","name":{"kind":"Name","value":"dq_description"}},{"kind":"Field","name":{"kind":"Name","value":"dq_relay_swimmer"}},{"kind":"Field","name":{"kind":"Name","value":"dsq"}},{"kind":"Field","name":{"kind":"Name","value":"entry_time_text"}},{"kind":"Field","name":{"kind":"Name","value":"fina_points"}},{"kind":"Field","name":{"kind":"Name","value":"heat_rank"}},{"kind":"Field","name":{"kind":"Name","value":"not_in_competition"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"qualification"}},{"kind":"Field","name":{"kind":"Name","value":"reaction_time"}},{"kind":"Field","name":{"kind":"Name","value":"result_text"}},{"kind":"Field","name":{"kind":"Name","value":"swimmed_distance"}},{"kind":"Field","name":{"kind":"Name","value":"total_rank"}}]}}]} as unknown as DocumentNode<LaneDataFragment, unknown>;
export const HeatDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HeatData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"heat"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"start_time"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_start_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<HeatDataFragment, unknown>;
export const EventDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"events"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"athlete_count"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"gender_number"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"is_masters_event"}},{"kind":"Field","name":{"kind":"Name","value":"is_para_event"}},{"kind":"Field","name":{"kind":"Name","value":"is_relay"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]} as unknown as DocumentNode<EventDataFragment, unknown>;
export const EntryDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_withdrawn"}},{"kind":"Field","name":{"kind":"Name","value":"entry_time_text"}},{"kind":"Field","name":{"kind":"Name","value":"late_entry"}},{"kind":"Field","name":{"kind":"Name","value":"not_in_competition"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"withdrawn"}},{"kind":"Field","name":{"kind":"Name","value":"reserve"}}]}}]} as unknown as DocumentNode<EntryDataFragment, unknown>;
export const EntryRankDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryRankData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"entry_rank"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"entry_rank_type"}}]}}]} as unknown as DocumentNode<EntryRankDataFragment, unknown>;
export const EntryListTypeDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryListTypeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"entry_list_type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sort_by_name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"entries_count"}}]}}]} as unknown as DocumentNode<EntryListTypeDataFragment, unknown>;
export const CompetitionsSince2024Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompetitionsSince2024"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"nation_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"FIN","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nation_code"}},{"kind":"Field","name":{"kind":"Name","value":"organizer"}},{"kind":"Field","name":{"kind":"Name","value":"pool_name"}},{"kind":"Field","name":{"kind":"Name","value":"pool_type"}},{"kind":"Field","name":{"kind":"Name","value":"seo_text"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"superlive"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<CompetitionsSince2024Query, CompetitionsSince2024QueryVariables>;
export const CurrentHeatSubscription_WlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"currentHeatSubscription_WL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current_heat"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"competition_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"heat_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"1"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"round"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"time_program_entry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"competition_session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CurrentHeatSubscription_WlSubscription, CurrentHeatSubscription_WlSubscriptionVariables>;
export const CompetitionStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"CompetitionStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competitions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"competition_sessions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"time_program_entries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"round"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CompetitionStatusSubscription, CompetitionStatusSubscriptionVariables>;
export const CurrentHeatDataSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"CurrentHeatDataSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentHeatId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heat_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentHeatId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimated_start_time"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"round_oid"}},{"kind":"Field","name":{"kind":"Name","value":"start_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lanes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checked"}},{"kind":"Field","name":{"kind":"Name","value":"competitor_oid"}},{"kind":"Field","name":{"kind":"Name","value":"dnf"}},{"kind":"Field","name":{"kind":"Name","value":"dns"}},{"kind":"Field","name":{"kind":"Name","value":"dq_code"}},{"kind":"Field","name":{"kind":"Name","value":"dq_description"}},{"kind":"Field","name":{"kind":"Name","value":"dq_relay_swimmer"}},{"kind":"Field","name":{"kind":"Name","value":"dsq"}},{"kind":"Field","name":{"kind":"Name","value":"entry_pool"}},{"kind":"Field","name":{"kind":"Name","value":"entry_time_text"}},{"kind":"Field","name":{"kind":"Name","value":"fina_points"}},{"kind":"Field","name":{"kind":"Name","value":"heat_rank"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"qualification"}},{"kind":"Field","name":{"kind":"Name","value":"reaction_time"}},{"kind":"Field","name":{"kind":"Name","value":"relay_age"}},{"kind":"Field","name":{"kind":"Name","value":"result_text"}},{"kind":"Field","name":{"kind":"Name","value":"swimmed_distance"}},{"kind":"Field","name":{"kind":"Name","value":"total_rank"}},{"kind":"Field","name":{"kind":"Name","value":"wps_points"}},{"kind":"Field","name":{"kind":"Name","value":"sub_results"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lane_oid"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"relay_competitor_order"}},{"kind":"Field","name":{"kind":"Name","value":"result_value_text"}},{"kind":"Field","name":{"kind":"Name","value":"split_diff_text"}},{"kind":"Field","name":{"kind":"Name","value":"take_over"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CurrentHeatDataSubscriptionSubscription, CurrentHeatDataSubscriptionSubscriptionVariables>;
export const CompetitionIdQuery_WlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"competitionIdQuery_WL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"navigationCID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seo_text"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"navigationCID"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<CompetitionIdQuery_WlQuery, CompetitionIdQuery_WlQueryVariables>;
export const ClubCompetitorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClubCompetitors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"club_name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"60"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clubs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"competition_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"club_name"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClubNames"}},{"kind":"Field","name":{"kind":"Name","value":"competitors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompetitorData"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClubNames"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"clubs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompetitorData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"competitor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender_number"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]} as unknown as DocumentNode<ClubCompetitorsQuery, ClubCompetitorsQueryVariables>;
export const GetClubNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClubNames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"60"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clubs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"competition_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClubNames"}},{"kind":"Field","name":{"kind":"Name","value":"competitors_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClubNames"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"clubs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]} as unknown as DocumentNode<GetClubNamesQuery, GetClubNamesQueryVariables>;
export const CompetitionsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompetitionsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"60"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competitions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locked"}},{"kind":"Field","name":{"kind":"Name","value":"manual_live_sort_order"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nation_code"}},{"kind":"Field","name":{"kind":"Name","value":"organizer"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"pool_name"}},{"kind":"Field","name":{"kind":"Name","value":"pool_type"}},{"kind":"Field","name":{"kind":"Name","value":"seo_text"}},{"kind":"Field","name":{"kind":"Name","value":"show_age"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"superlive"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"athlete_count"}},{"kind":"Field","name":{"kind":"Name","value":"competition_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"event_competition_level"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"gender_number"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_masters_event"}},{"kind":"Field","name":{"kind":"Name","value":"is_para_event"}},{"kind":"Field","name":{"kind":"Name","value":"is_relay"}},{"kind":"Field","name":{"kind":"Name","value":"max_age"}},{"kind":"Field","name":{"kind":"Name","value":"min_age"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"sponsor_oid"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"use_pre_masters"}},{"kind":"Field","name":{"kind":"Name","value":"agegroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competition_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"event_oid"}},{"kind":"Field","name":{"kind":"Name","value":"from_age"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"to_age"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"competition_sessions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competition_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"start_time"}},{"kind":"Field","name":{"kind":"Name","value":"superlive_seo_link"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"time_program_entries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competition_id"}},{"kind":"Field","name":{"kind":"Name","value":"competition_session_oid"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"round_oid"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}},{"kind":"Field","name":{"kind":"Name","value":"start_time"}},{"kind":"Field","name":{"kind":"Name","value":"stop_time"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"round"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competition_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"event_oid"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"official_at"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"round_type"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"file_archives"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category_type"}},{"kind":"Field","name":{"kind":"Name","value":"competition_id"}},{"kind":"Field","name":{"kind":"Name","value":"competition_session_oid"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"round_oid"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"competitors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"club_oid"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"competition_id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name_reversed"}},{"kind":"Field","name":{"kind":"Name","value":"gender_number"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_para"}},{"kind":"Field","name":{"kind":"Name","value":"is_relay"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"para_class_breast"}},{"kind":"Field","name":{"kind":"Name","value":"para_class_free"}},{"kind":"Field","name":{"kind":"Name","value":"para_class_medley"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clubs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"competition_id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"country_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"region_name"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}}]}}]}}]}}]} as unknown as DocumentNode<CompetitionsDataQuery, CompetitionsDataQueryVariables>;
export const EventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Events"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"competition_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventData"}},{"kind":"Field","name":{"kind":"Name","value":"entry_list_types"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryListTypeData"}},{"kind":"Field","name":{"kind":"Name","value":"entry_ranks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryRankData"}},{"kind":"Field","name":{"kind":"Name","value":"entry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryData"}},{"kind":"Field","name":{"kind":"Name","value":"competitor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompetitorData"}},{"kind":"Field","name":{"kind":"Name","value":"club"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClubNames"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relay_competitors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competition_id"}},{"kind":"Field","name":{"kind":"Name","value":"competitor_oid"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"entry_oid"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lane_oid"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rounds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoundData"}},{"kind":"Field","name":{"kind":"Name","value":"summary_types"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SummaryTypeData"}},{"kind":"Field","name":{"kind":"Name","value":"ranks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rank"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RankData"}},{"kind":"Field","name":{"kind":"Name","value":"lane"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LaneData"}},{"kind":"Field","name":{"kind":"Name","value":"competitor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompetitorData"}},{"kind":"Field","name":{"kind":"Name","value":"club"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClubNames"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relay_competitors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competition_id"}},{"kind":"Field","name":{"kind":"Name","value":"competitor_oid"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"entry_oid"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lane_oid"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HeatData"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HeatData"}},{"kind":"Field","name":{"kind":"Name","value":"time_program_entry_oid"}},{"kind":"Field","name":{"kind":"Name","value":"lanes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LaneData"}},{"kind":"Field","name":{"kind":"Name","value":"sub_results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"result_value_text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"competitor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompetitorData"}},{"kind":"Field","name":{"kind":"Name","value":"club"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClubNames"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relay_competitors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competition_id"}},{"kind":"Field","name":{"kind":"Name","value":"competitor_oid"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"entry_oid"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lane_oid"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"events"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"athlete_count"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"gender_number"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"is_masters_event"}},{"kind":"Field","name":{"kind":"Name","value":"is_para_event"}},{"kind":"Field","name":{"kind":"Name","value":"is_relay"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryListTypeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"entry_list_type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sort_by_name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"entries_count"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryRankData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"entry_rank"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"entry_rank_type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_withdrawn"}},{"kind":"Field","name":{"kind":"Name","value":"entry_time_text"}},{"kind":"Field","name":{"kind":"Name","value":"late_entry"}},{"kind":"Field","name":{"kind":"Name","value":"not_in_competition"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"withdrawn"}},{"kind":"Field","name":{"kind":"Name","value":"reserve"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompetitorData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"competitor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender_number"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClubNames"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"clubs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoundData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"round"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"event_oid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"official_at"}},{"kind":"Field","name":{"kind":"Name","value":"round_type"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SummaryTypeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"summary_type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"rank_type"}},{"kind":"Field","name":{"kind":"Name","value":"ranks_count"}},{"kind":"Field","name":{"kind":"Name","value":"round_oid"}},{"kind":"Field","name":{"kind":"Name","value":"sort_by_name"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RankData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"rank"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LaneData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lane"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"competitor_oid"}},{"kind":"Field","name":{"kind":"Name","value":"dnf"}},{"kind":"Field","name":{"kind":"Name","value":"dns"}},{"kind":"Field","name":{"kind":"Name","value":"dq_code"}},{"kind":"Field","name":{"kind":"Name","value":"dq_description"}},{"kind":"Field","name":{"kind":"Name","value":"dq_relay_swimmer"}},{"kind":"Field","name":{"kind":"Name","value":"dsq"}},{"kind":"Field","name":{"kind":"Name","value":"entry_time_text"}},{"kind":"Field","name":{"kind":"Name","value":"fina_points"}},{"kind":"Field","name":{"kind":"Name","value":"heat_rank"}},{"kind":"Field","name":{"kind":"Name","value":"not_in_competition"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"qualification"}},{"kind":"Field","name":{"kind":"Name","value":"reaction_time"}},{"kind":"Field","name":{"kind":"Name","value":"result_text"}},{"kind":"Field","name":{"kind":"Name","value":"swimmed_distance"}},{"kind":"Field","name":{"kind":"Name","value":"total_rank"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HeatData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"heat"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"start_time"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_start_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<EventsQuery, EventsQueryVariables>;
export const CompetitorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Competitors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"60"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competitor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"competition_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompetitorData"}},{"kind":"Field","name":{"kind":"Name","value":"club"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClubNames"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompetitorData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"competitor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender_number"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClubNames"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"clubs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]} as unknown as DocumentNode<CompetitorsQuery, CompetitorsQueryVariables>;
export const TimeProgramEntryDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TimeProgramEntryData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"programItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"30"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time_program_entry_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"programItemId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProgramItemData"}},{"kind":"Field","name":{"kind":"Name","value":"round"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoundData"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"summary_types"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SummaryTypeData"}},{"kind":"Field","name":{"kind":"Name","value":"ranks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RankData"}},{"kind":"Field","name":{"kind":"Name","value":"lane"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LaneData"}},{"kind":"Field","name":{"kind":"Name","value":"heat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HeatData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"competitor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompetitorData"}},{"kind":"Field","name":{"kind":"Name","value":"club"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClubNames"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventData"}},{"kind":"Field","name":{"kind":"Name","value":"entry_list_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryListTypeData"}},{"kind":"Field","name":{"kind":"Name","value":"entry_ranks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryRankData"}},{"kind":"Field","name":{"kind":"Name","value":"entry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryData"}},{"kind":"Field","name":{"kind":"Name","value":"competitor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompetitorData"}},{"kind":"Field","name":{"kind":"Name","value":"club"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClubNames"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relay_competitors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competition_id"}},{"kind":"Field","name":{"kind":"Name","value":"competitor_oid"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"entry_oid"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lane_oid"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"heats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HeatData"}},{"kind":"Field","name":{"kind":"Name","value":"lanes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LaneData"}},{"kind":"Field","name":{"kind":"Name","value":"competitor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompetitorData"}},{"kind":"Field","name":{"kind":"Name","value":"club"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClubNames"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relay_competitors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competition_id"}},{"kind":"Field","name":{"kind":"Name","value":"competitor_oid"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"entry_oid"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lane_oid"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProgramItemData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"time_program_entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"round_oid"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}},{"kind":"Field","name":{"kind":"Name","value":"start_time"}},{"kind":"Field","name":{"kind":"Name","value":"stop_time"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoundData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"round"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"event_oid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"official_at"}},{"kind":"Field","name":{"kind":"Name","value":"round_type"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SummaryTypeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"summary_type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"rank_type"}},{"kind":"Field","name":{"kind":"Name","value":"ranks_count"}},{"kind":"Field","name":{"kind":"Name","value":"round_oid"}},{"kind":"Field","name":{"kind":"Name","value":"sort_by_name"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RankData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"rank"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LaneData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lane"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"competitor_oid"}},{"kind":"Field","name":{"kind":"Name","value":"dnf"}},{"kind":"Field","name":{"kind":"Name","value":"dns"}},{"kind":"Field","name":{"kind":"Name","value":"dq_code"}},{"kind":"Field","name":{"kind":"Name","value":"dq_description"}},{"kind":"Field","name":{"kind":"Name","value":"dq_relay_swimmer"}},{"kind":"Field","name":{"kind":"Name","value":"dsq"}},{"kind":"Field","name":{"kind":"Name","value":"entry_time_text"}},{"kind":"Field","name":{"kind":"Name","value":"fina_points"}},{"kind":"Field","name":{"kind":"Name","value":"heat_rank"}},{"kind":"Field","name":{"kind":"Name","value":"not_in_competition"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"qualification"}},{"kind":"Field","name":{"kind":"Name","value":"reaction_time"}},{"kind":"Field","name":{"kind":"Name","value":"result_text"}},{"kind":"Field","name":{"kind":"Name","value":"swimmed_distance"}},{"kind":"Field","name":{"kind":"Name","value":"total_rank"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HeatData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"heat"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"start_time"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_start_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompetitorData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"competitor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender_number"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClubNames"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"clubs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"events"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"athlete_count"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"gender_number"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"is_masters_event"}},{"kind":"Field","name":{"kind":"Name","value":"is_para_event"}},{"kind":"Field","name":{"kind":"Name","value":"is_relay"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryListTypeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"entry_list_type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sort_by_name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"entries_count"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryRankData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"entry_rank"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"entry_rank_type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_withdrawn"}},{"kind":"Field","name":{"kind":"Name","value":"entry_time_text"}},{"kind":"Field","name":{"kind":"Name","value":"late_entry"}},{"kind":"Field","name":{"kind":"Name","value":"not_in_competition"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"withdrawn"}},{"kind":"Field","name":{"kind":"Name","value":"reserve"}}]}}]} as unknown as DocumentNode<TimeProgramEntryDataQuery, TimeProgramEntryDataQueryVariables>;
export const CompetitorDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompetitorDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"full_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"age"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"30"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competitor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"competition_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cid"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entries"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"relay_competitors"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"competitor"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"full_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"full_name"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"age"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"age"}}}]}}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"full_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"full_name"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"age"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"age"}}}]}}]}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompetitorData"}},{"kind":"Field","name":{"kind":"Name","value":"club"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClubNames"}}]}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryData"}},{"kind":"Field","name":{"kind":"Name","value":"entry_ranks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rank"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryRankData"}},{"kind":"Field","name":{"kind":"Name","value":"entry_list_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryListTypeData"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relay_competitors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competition_id"}},{"kind":"Field","name":{"kind":"Name","value":"competitor_oid"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"entry_oid"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lane_oid"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"competitor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"age"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lanes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"heat"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result_text"}},{"kind":"Field","name":{"kind":"Name","value":"fina_points"}},{"kind":"Field","name":{"kind":"Name","value":"wps_points"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LaneData"}},{"kind":"Field","name":{"kind":"Name","value":"sub_results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"relay_competitor_order"}},{"kind":"Field","name":{"kind":"Name","value":"result_value_text"}},{"kind":"Field","name":{"kind":"Name","value":"split_diff_text"}},{"kind":"Field","name":{"kind":"Name","value":"take_over"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HeatData"}},{"kind":"Field","name":{"kind":"Name","value":"time_program_entry_oid"}},{"kind":"Field","name":{"kind":"Name","value":"round"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoundData"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventData"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ranks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RankData"}},{"kind":"Field","name":{"kind":"Name","value":"summary_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SummaryTypeData"}},{"kind":"Field","name":{"kind":"Name","value":"round"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoundData"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompetitorData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"competitor"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender_number"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClubNames"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"clubs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_withdrawn"}},{"kind":"Field","name":{"kind":"Name","value":"entry_time_text"}},{"kind":"Field","name":{"kind":"Name","value":"late_entry"}},{"kind":"Field","name":{"kind":"Name","value":"not_in_competition"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"withdrawn"}},{"kind":"Field","name":{"kind":"Name","value":"reserve"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryRankData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"entry_rank"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"entry_rank_type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryListTypeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"entry_list_type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sort_by_name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"entries_count"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"events"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"athlete_count"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"gender_number"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"is_masters_event"}},{"kind":"Field","name":{"kind":"Name","value":"is_para_event"}},{"kind":"Field","name":{"kind":"Name","value":"is_relay"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LaneData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lane"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"competitor_oid"}},{"kind":"Field","name":{"kind":"Name","value":"dnf"}},{"kind":"Field","name":{"kind":"Name","value":"dns"}},{"kind":"Field","name":{"kind":"Name","value":"dq_code"}},{"kind":"Field","name":{"kind":"Name","value":"dq_description"}},{"kind":"Field","name":{"kind":"Name","value":"dq_relay_swimmer"}},{"kind":"Field","name":{"kind":"Name","value":"dsq"}},{"kind":"Field","name":{"kind":"Name","value":"entry_time_text"}},{"kind":"Field","name":{"kind":"Name","value":"fina_points"}},{"kind":"Field","name":{"kind":"Name","value":"heat_rank"}},{"kind":"Field","name":{"kind":"Name","value":"not_in_competition"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"qualification"}},{"kind":"Field","name":{"kind":"Name","value":"reaction_time"}},{"kind":"Field","name":{"kind":"Name","value":"result_text"}},{"kind":"Field","name":{"kind":"Name","value":"swimmed_distance"}},{"kind":"Field","name":{"kind":"Name","value":"total_rank"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HeatData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"heat"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"start_time"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_start_time"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoundData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"round"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"event_oid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"official_at"}},{"kind":"Field","name":{"kind":"Name","value":"round_type"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RankData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"rank"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SummaryTypeData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"summary_type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oid"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"rank_type"}},{"kind":"Field","name":{"kind":"Name","value":"ranks_count"}},{"kind":"Field","name":{"kind":"Name","value":"round_oid"}},{"kind":"Field","name":{"kind":"Name","value":"sort_by_name"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<CompetitorDetailsQuery, CompetitorDetailsQueryVariables>;
export const CompetitorCompetitionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompetitorCompetitions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"full_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"60"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competitor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"full_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"full_name"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"competition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"StringValue","value":"2024-01-01","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"birthday"}},{"kind":"Field","name":{"kind":"Name","value":"competition_id"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"club"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"competition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"seo_text"}}]}}]}}]}}]} as unknown as DocumentNode<CompetitorCompetitionsQuery, CompetitorCompetitionsQueryVariables>;
export const CompetitorResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompetitorResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"competitor_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"competition_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event_type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"distance"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"60"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lane"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"competition_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"competition_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"competitor"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"competitor_id"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"heat"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"round"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"event"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event_type"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"distance"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"distance"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"competition_id"}},{"kind":"Field","name":{"kind":"Name","value":"result_text"}},{"kind":"Field","name":{"kind":"Name","value":"qualification"}},{"kind":"Field","name":{"kind":"Name","value":"dns"}},{"kind":"Field","name":{"kind":"Name","value":"dsq"}},{"kind":"Field","name":{"kind":"Name","value":"dnf"}},{"kind":"Field","name":{"kind":"Name","value":"dq_code"}},{"kind":"Field","name":{"kind":"Name","value":"dq_description"}},{"kind":"Field","name":{"kind":"Name","value":"heat_rank"}},{"kind":"Field","name":{"kind":"Name","value":"reaction_time"}},{"kind":"Field","name":{"kind":"Name","value":"total_rank"}},{"kind":"Field","name":{"kind":"Name","value":"entry_pool"}},{"kind":"Field","name":{"kind":"Name","value":"heat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"round"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sub_results"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"result_value_text"}}]}}]}}]}}]} as unknown as DocumentNode<CompetitorResultsQuery, CompetitorResultsQueryVariables>;
export const CompetitionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Competitions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nation_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"FIN","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nation_code"}},{"kind":"Field","name":{"kind":"Name","value":"organizer"}},{"kind":"Field","name":{"kind":"Name","value":"pool_name"}},{"kind":"Field","name":{"kind":"Name","value":"pool_type"}},{"kind":"Field","name":{"kind":"Name","value":"seo_text"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"superlive"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<CompetitionsQuery, CompetitionsQueryVariables>;